export const data = {
  "en": {
    "Users":{
      "Main":{
        "Middle":{
          "Content": {
            "tab_Password": "Password",
            "Password": {
              "label_OldPassword": "Old password",
              "placeholder_OldPassword": "Enter old password",
              "validinfo_OldPassword": "You must provide your current password in order to change it.",

              "label_NewPassword1": "New password",
              "placeholder_NewPassword1": "Enter new password",
              "validinfo_NewPassword1": "Password should be at least 6 characters.",

              "label_NewPassword2": "Password confirmation",
              "placeholder_NewPassword2": "Enter new password",
              "validinfo_NewPassword2": "Password confirmation doesn't match.",

              "button_Confirm": "Confirm",
              "alert_Success": "The password has been changed",
              "alert_Error": "The password hasn't been changed",


            },
            "tab_Users": "Users",
            "Users": {
              "infotext_1": "Users list:",
              "table_header_FirstName": "FirstName",
              "table_header_LastName": "LastName",
              "table_header_Login": "Username",
              "table_header_Email": "Email",
              "table_header_Role": "Role",
              "table_header_Groups": "Groups",
              "table_header_Active": "Is Active",
              "table_header_Actions": "Actions",
              "contextmenu_text_Edit": "Edit",
              "contextmenu_text_Delete": "Delete",
              "button_Edit": "Edit",
              "button_Delete": "Delete",
              "modal_UpdateUser": {
                "modal_Title": "Update user",

                "label_FirstName": "First Name",
                "placeholder_FirstName": "Enter First Name",
                "validinfo_FirstName": "Enter First Name",

                "label_LastName": "Last Name",
                "placeholder_LastName": "Enter Last Name",
                "validinfo_LastName": "Enter Last Name",

                "label_Login": "Username",
                "placeholder_Login": "Enter Username",
                "validinfo_Login": "Enter Username",

                "label_Password": "Password",
                "placeholder_Password": "Enter Password",
                "validinfo_Password": "Password should be at least 6 characters.",

                "label_Email": "Email",
                "placeholder_Email": "Enter Email",
                "validinfo_Email": "Enter Email",

                "label_Role": "Role",
                "placeholder_Role": "Select Role",
                "validinfo_Role": "Select Role",

                "PermissionGroups": {
                  "label_Groups": "Groups",
                  "label_Search": "Search group",
                  "infotext_1": "There are no groups available to select",
                  "infotext_2": "There are no groups matching your search criteria"
                },

                "option_Empty": "Choose...",
                "label_IsActive": "User Is Active",

                "button_OK": "OK",
                "button_Cancel": "Cancel",


              },
              "alert_success_CreateUser": "User data has been created correctly",
              "alert_error_CreateUser": "User data was not created correctly. Error",
              "alert_success_UpdateUser": "User data has been updated correctly",
              "alert_error_UpdateUser": "User data was not updated correctly. Error",
              "alert_success_DeleteUser": "User data has been deleted correctly",
              "alert_error_DeleteUser": "User data was not deleted correctly. Error",
            },
            "tab_Groups": "Groups",
            "Groups": {
              "infotext_1": "Groups list:",
              "table_header_GroupName": "Groups",
              "table_header_Actions": "Actions",
              "contextmenu_text_Edit": "Edit",
              "contextmenu_text_Delete": "Delete",
              "button_Edit": "Edit",
              "button_Delete": "Delete",
              "modal_UpdateGroup": {
                "modal_Title": "Update group",

                "label_GroupName": "Group name",
                "placeholder_GroupName": "Enter Group",
                "validinfo_GroupName": "Enter Group",

                "button_OK": "OK",
                "button_Cancel": "Cancel",


              },
              "alert_TitleDelete": "Delete group",
              "alert_TextDelete": "Are you sure?",
              "alert_success_UpdateGroup": "Group has been updated correctly",
              "alert_error_UpdateGroup": "Group was not updated correctly. Error",
              "alert_error_GroupName": "The group name must not be empty.",
              "alert_success_DeleteGroup": "The group was deleted correctly",
              "alert_error_DeleteGroup": "The group was not deleted correctly",
            },
            "tab_LoginAudit": "Login audit",
            "LoginAudit": {
              "infotext_1": "Login audit list:",
              "table_header_FirstName": "FirstName",
              "table_header_LastName": "LastName",
              "table_header_Username": "Username",
              "table_header_Role": "Role",
              "table_header_Success": "Success",
              "table_header_LoginDate": "LoginDate",
              "table_header_LogoutDate": "LogoutDate",
              "export_label_top": "Login audit"
            },
          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_NewUser": "New user",
          "button_NewGroup": "New group",
          "modal_CreateUser": {
            "modal_Title": "Create new user",

            "label_FirstName": "First Name",
            "placeholder_FirstName": "Enter First Name",
            "validinfo_FirstName": "Enter First Name",

            "label_LastName": "Last Name",
            "placeholder_LastName": "Enter Last Name",
            "validinfo_LastName": "Enter Last Name",

            "label_Login": "Username",
            "placeholder_Login": "Enter Username",
            "validinfo_Login": "Enter Username",

            "label_Password": "Password",
            "placeholder_Password": "Enter Password",
            "validinfo_Password": "Password should be at least 6 characters.",

            "label_Email": "Email",
            "placeholder_Email": "Enter Email",
            "validinfo_Email": "Enter Email",

            "label_Role": "Role",
            "placeholder_Role": "Select Role",
            "validinfo_Role": "Select Role",

            "PermissionGroups": {
              "label_Groups": "Groups",
              "label_Search": "Search group",
              "infotext_1": "There are no groups available to select",
              "infotext_2": "There are no groups matching your search criteria"
            },


            "option_Empty": "Choose...",
            "label_IsActive": "User Is Active",

            "button_OK": "OK",
            "button_Cancel": "Cancel"
          },
          "alert_success_CreateUser": "The user was created correctly",
          "alert_error_CreateUser": "User was not created correctly. Error",
          "modal_CreateGroup": {
            "modal_Title": "Create new group",

            "label_Group": "Group name",
            "placeholder_Role": "Enter Group name",
            "validinfo_Role": "Enter Group name",
            "button_OK": "OK",
            "button_Cancel": "Cancel"
          },
          "alert_success_CreateGroup": "The group was created correctly",
          "alert_error_CreateGroup": "Group was not created correctly. Error",
          "alert_error_GroupName": "The group name must not be empty."
        }
      }
    },
    "Settings":{
      "Main":{
        "Middle":{
          "Content": {
            "tab_General": "General",
            "titlepanel_1": "Theme",
            "infotext_1": "With this option you can switch the interface colour from dark to light or vice versa.",
            "titlepanel_2": "Language",
            "infotext_2": "With this option you can switch the language.",

            "titlepanel_3": "Global settings",
            "label_displayLocalLinks": "Enable links to file-share paths",
            "label_displayLocalLinks_tooltip": "E.g. //local-server/resources/datasheet.xlsx in MPN details will become clickable; it may still require an additional change in browser settings, or a 3rd party extension",
            "label_displayHttpLinks": "Enable links to external web resources",
            "label_displayHttpLinks_tooltip": "E.g. https://somevendor.com/datasheet.pdf in MPN details will become clickable",
            "label_doubleApproval": "Enforce the four-eye principle",
            "label_doubleApproval_tooltip": "A second person’s approval will be required for all new components and libraries and their new revisions",
            "label_placingPrototype": "Allow early use of components",
            "label_placingPrototype_tooltip": "Newly requested components can be placed on a circuit diagram, before they are fully approved",
            "label_deletionOfElements": "Allow arbitrary deletion of data",
            "label_deletionOfElements_tooltip": "Admins will be able to completely remove any component, library, project or even wipe clean all data from OMNYA without a second person’s approval",
            "label_cleanDependencies": "Enforce clean dependencies",
            "label_cleanDependencies_tooltip": "The approval of a part or library will fail if any of the libraries they depend on is unapproved itself or is missing crucial files",
            "label_advancedPermissions": "Enable advanced permissions",
            "label_advancedPermissions_tooltip": "Advanced permissions allow you to create groups, assign users and permissions to them",
            "label_fixedNumberInPartNumber": "Fixed width for Part number",
            "label_fixedNumberInPartNumber_tooltip": "Fixed width for Part number means filling the numbers given by the template with zeros, for example: FC-00001 instead of FC-1",
            "label_footprintDependencies": "Allow cascading footprint approval",
            "label_footprintDependencies_tooltip": "Cascading approval allows footprints to be pushed together with dependent elements, and then allows them to be approved with a single command.",
            "label_requests": "Allow use of requests",
            "label_requests_tooltip": "Requests enable the creation of parts or libraries by designated users through a simple process.",
            "label_automaticArchivingClosedRevision": "Automatic archiving Closed revision in Projects",
            "label_automaticArchivingClosedRevision_tooltip": "When the latest revision of a project changes its status to Active, the old revision, which changes to Closed, is automatically archived.",
            "label_hideNoMpnTag": "Hide NoMpnTag",
            "label_hideNoMpnTag_tooltip": "Allows to hide the noMPN tag in the Parts table.",
            "label_IPCTopColour": "IPC board’s TOP layer color",
            "label_IPCTopColour_tooltip": "The color used to present the contents of the TOP layer on the PCB board images based on the IPC files imported to projects",
            "label_IPCBottomColour": "IPC board’s BOTTOM layer color",
            "label_IPCBottomColour_tooltip": "The color used to present the contents of the BOTTOM layer on the PCB board images based on the IPC files imported to projects",
            "label_SEDetails": "SE Details",
            "label_SEDetails_tooltip": "Enabling/disabling SE Details",

            "alert_Title_advancedPermissions": "Advanced permissions",
            "alert_advancedPermissions": "All settings of advanced permissions will be lost. All users will have access to all data. Are you sure you want to restore the simplified settings?",

            "titlepanel_SE": "SiliconExpert",
            "label_howManyDaysRefresh": "After how many days should SE data be refreshed",
            "label_SERiskRanges": "SE Risk parameter ranges for SE data",
            "label_SEEOLRanges": "SE EOL parameter ranges for SE data",

            "label_SEtoEOL": "Set data from SE to EOL, EOS, and tags parameters",
            "label_SEtoEOL_tooltip": "Data retrieved from SiliconExpert will be set as EOL, EOS application parameters, and Forbidden and NRND tags.",
            "label_SEdataAutoRefresh": "Allow automatic refreshing of data from SE",
            "label_SEdataAutoRefresh_tooltip": "Data from SiliconExpert will be automatically refreshed.",
            "label_SEOverwritesAdditionalParameters": "SE data overwrites Additional Parameters for MPN",
            "label_SEOverwritesAdditionalParameters_tooltip": "Data from SiliconExpert overwrites Additional Parameters for MPN",

            "tab_SearchEngines": "Search Engines",
            "label_Login": "Login",
            "description_Login1": "Enter login to",
            "description_Login2": "service",
            "placeholder_Login": "Enter login",
            "label_Password": "Password",
            "description_Password1": "Enter password to",
            "description_Password2": "service",
            "placeholder_Password": "Enter password",
            "label_ApiKey": "ApiKey",
            "description_ApiKey1": "Enter ApiKey to",
            "description_ApiKey2": "service",
            "placeholder_ApiKey": "Enter ApiKey",
            "label_RedirectUri": "RedirectUri",
            "description_RedirectUri1": "Enter RedirectUri to",
            "description_RedirectUri2": "service",
            "placeholder_RedirectUri": "Enter RedirectUri",
            "label_AccessToken": "AccessToken",
            "description_AccessToken1": "Enter AccessToken to",
            "description_AccessToken2": "service",
            "placeholder_AccessToken": "Enter AccessToken",
            "label_RefreshToken": "RefreshToken",
            "description_RefreshToken1": "Enter RefreshToken to",
            "description_RefreshToken2": "service",
            "placeholder_RefreshToken": "Enter RefreshToken",
            "button_Initialization": "Initialization",
            "label_ClientId": "Client Id",
            "description_ClientId": "Enter Client Id to",
            "placeholder_ClientId": "Enter Client Id",
            "label_ClientSecret": "Client Secret",
            "description_ClientSecret": "Enter Client Secret to",
            "placeholder_ClientSecret": "Enter Client Secret",
            "description_Service": "service",
            "checkbox_IsActive": "Is active",
            "button_Save": "Save",
            "alert_success_save": "The data has been saved",
            "alert_error_save": "Data has not been saved",
            "tab_Database": "Database",
            "titlepanel_Database": "Erasing the database",
            "infotext3": "Be careful. This command cannot be undone. Only users will be saved.",
            "button_CleanDatabase": "Remove all data from database",
            "alert_success_cleanDatabase": "Erasing the database was successful.",
            "alert_error_cleanDatabase": "Erasing the database failed. Error",
            "alert_clean": "Are you sure you want to clear the database? This command cannot be undone.",
            "titlepanel_DatabaseRestore": "Restore the database",
            "infotext5": "Be careful. This command cannot be undone. The database will have an initial setting.",
            "button_RestoreDatabase": "Restore database",
            "alert_success_restoreDatabase": "Restoring the database was successful.",
            "alert_error_restoreDatabase": "Database restore failed. Error",
            "alert_restore": "Are you sure you want to restore the database? This command cannot be undone.",
            "tab_Files": "Files",
            "infotext4": "Set the file types that should be imported or excluded.",
            "label_Libraries": "In Libraries",
            "label_Projects": "In Projects",
            "label_Requests": "In Requests",
            "label_WhiteList": "White list",
            "label_BlackList": "Black list",
            "button_Confirm": "Confirm",
            "placeholder_extList": "Enter file extensions (each on a new line)",
            "alert_success_ExtConfirm": "The white list and black list have been saved correctly.",
            "alert_error_ExtConfirm": "The white list and black list have not been saved correctly.",
            "tab_License": "License",
            "label_File": "Upload a file (ENC format) containing the application license",
            "placeholder_File": "Choose a file or drop it here...",
            "label_file_invalid": "Choose a file in ENC format. ",
            "alert_success_uploadLicense": "The license file was uploaded correctly",
            "alert_error_uploadLicense": "License file was not uploaded correctly",

            "tab_Dump": "Dump files",
            "titlepanel_GetProjectDump": "Project files dump",
            "infotext5": "Download files that allow you to create a dump of all project files from the application.",
            "titlepanel_GetLibraryDump": "Library files dump",
            "infotext6": "Download files that allow you to create a dump of all library files from the application.",

            "button_Structure": "Download file structure",
            "button_ScriptWindows": "Download the script",
            "button_ScriptLinux": "Download the script for Linux",
            "alert_success_Dump": "File download completed successfully.",
            "alert_error_Dump": "File download failed",

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_NewUser": "???",
        }
      }
    },
    "About":{
      "Main":{
        "Middle":{
          "Content": {
            "tab_General": "General",
            "titlepanel_1": "Support",
            "infotext_1": "Problems or questions? Please contact:",
            "titlepanel_2": "Links",
            "infotext_2": "OMNYA Help Page",
            "infotext_3": "Download and install the isolated OrCAD environment ",
            "titlepanel_3": "Build",
            "label_build1": "OMNYA",
            "label_build2": "OMNYA Agent",
            "label_build3": "You should use the OMNYA Agent version",
            "label_build4": "Download the compatible version of Agent",
            "label_build4_feedback": "File temporarily unavailable",
            "infotext_4": "unavailable",
            "label_isAgent_tooltip": "You are connected directly to your Omnya platform, bypassing the local Agent. Some features will not be available",
            "titlepanel_4": "License",
            "label_license1": "Expires in",
            "label_license2": "day",
            "label_license3": "days",
            "label_license4": "has expired",
            "label_licenseUsers": "Users",
            "titlepanel_5": "SiliconExpert",
            "label_SE_tokens": "Credits",
            "label_SE_expiration": "Expiration date"
          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",

        }
      }
    },
    "Header": {
      "Dashboard": "Dashboard",
      "Parts": "Parts",
      "Libraries": "Libraries",
      "Processes": "Processes",
      "ProjectsBasic": "Projects",
      "Projects": "Projects",
      "Requests": "Requests",
      "Users": "Users",
      "Settings": "Settings",
      "About": "About",
      "button_Logout": "Log out",
      "button_Settings": "Settings",
      "label_license1": "License will expire in",
      "label_license2": "day",
      "label_license3": "days",
      "label_license4": "License has expired",
    },
    "Footer": {
      "Alerts": {
        "1": "Application loaded successfully"
      },
      "Loader": {
        "alert_load": "Loading...",
        "alert_download": "Downloading...",
        "alert_wait": "Wait...",
        "alert_open": "Opening...",
        "alert_push": "Pushing..."
      },
      "LivePanel": {

      },
      "Notifications":{
        "infotext_1": "You have new notification...",
        "modal_Title": "Notifications",
        "infotext_2": "Notification list",
      }
    },
    "AlertComponent": {

    },
    "ModalComponent": {

    },
    "Login": {
      "label_Login": "Login",
      "label_Email": "Email",
      "label_Password": "Password",
      "infotext_1": "Password or email incorrect. Check your credentials.",
      "button_Login": "Log in"
    },
    "ExternalResponse": {
      "alert_success_approveToken": "Token has been successfully downloaded",
      "alert_error_approveToken": "Token not downloaded correctly",

    },
    "Dashboard":{
      "DashboardWidgets":{
        "Left": {
          "button_Settings": "Settings",
          "Content": {
            "Cards":{

              "ActiveParts":{
                "header_description": "Active parts",
                "footer_Description": "All active parts divided into categories.",
                "Chart": {
                  "infotext_1": "No data available",
                }
              },
              "PendingParts":{
                "header_description": "Pending parts",
                "footer_Description": "All pending parts divided into categories.",
                "Chart": {
                  "infotext_1": "No data available",
                }
              },
              "ActiveLibraries":{
                "header_description": "Active libraries",
                "footer_Description": "All active libraries divided into categories.",
                "Chart": {
                  "infotext_1": "No data available",
                }
              },
              "PendingLibraries":{
                "header_description": "Pending libraries",
                "footer_Description": "All pending libraries divided into categories.",
                "Chart": {
                  "infotext_1": "No data available",
                }
              },
              "RoHSParts":{
                "header_description": "RoHS status",
                "footer_Description": "Parts compliant with ROHS or not divided into categories.",
                "infotext_1": "No data available",
                "Chart": {
                  "legend_Yes": "RoHS compliant",
                  "legend_None": "RoHS non-compliant",
                  "infotext_1": "No data available",
                }
              },
              "MyTasks":{
                "header_description": "My tasks",
                "footer_Description": "List of tasks requiring the user's attention.",
                "Table": {
                  "placeholder_Search": "Search",
                  "table_header_Type": "Type",
                  "table_header_Name": "Name",
                  "table_header_Revision": "Rev",
                  "table_header_Level": "Level",
                  "table_header_Date": "Creation date",
                }
              },
              "Tasks":{
                "header_description": "Tasks",
                "footer_Description": "List of tasks that the user can take over.",
                "Table": {
                  "placeholder_Search": "Search",
                  "table_header_Type": "Type",
                  "table_header_Name": "Name",
                  "table_header_Revision": "Rev",
                  "table_header_Level": "Level",
                  "table_header_Date": "Creation date",
                }
              },
              "MyRequestedElements":{
                "header_description": "My requested elements",
                "footer_Description": "List of items I initiated.",
                "Table": {
                  "placeholder_Search": "Search",
                  "table_header_Type": "Type",
                  "table_header_Name": "Name",
                  "table_header_Revision": "Rev",
                  "table_header_Level": "Level",
                  "table_header_Date": "Creation date",
                }
              },

              "LibStatuses":{
                "header_description": "Library synchronization status",
                "footer_Description": "Status indicating progress of library synchronization.",
                "Table": {
                  "placeholder_Search": "Search",
                  "table_header_Type": "Type",
                  "table_header_Name": "Name",
                  "table_header_Revision": "Rev",
                  "table_header_Date": "Creation date",
                }
              },
              "EndOfParts":{
                "header_description": "Lifecycle status",
                "footer_Description": "Elements found in projects with a near end-of-life date.",
                "Table": {
                  "placeholder_Search": "Search",
                  "table_header_ProjectName": "Project number",
                  "table_header_PartNumber": "Part number",
                  "table_header_Revision": "Rev",
                  "table_header_EndOfLife": "End of Life",
                  "table_header_EndOfSale": "End of Sale",
                  "label_Year": "Year",
                  "label_6Months": "6 months",
                  "label_3Months": "3 months",
                  "label_1Month": "1 month",
                }
              },
              "MyRequests":{
                "header_description": "My requests",
                "footer_Description": "List of requests requiring the user's attention.",
                "Table": {
                  "placeholder_Search": "Search",
                  "table_header_Type": "Type",
                  "table_header_Name": "RequestNumber",
                  "table_header_Stage": "Stage",
                  "table_header_Priority": "Priority",
                  "table_header_Date": "Creation date",
                }
              },
            },
            "modal_Settings":{
              "modal_Title": "Settings",
              "label_MyTasks": "My tasks",
              "label_Tasks": "Tasks",
              "label_StatusesOfLibraries": "Statuses of libraries",
              "label_ActiveParts": "Active parts",
              "label_PendingParts": "Pending parts",
              "label_EndOfParts": "Lifecycle status",
              "label_ActiveLibraries": "Active libraries",
              "label_PendingLibraries": "Pending libraries",
              "label_RoHSParts": "RoHS status",
              "label_MyRequests": "My requests",
              "label_MyRequestedElements": "My requested elements",
            }
          }
        }
      }
    },
    "PartManager": {
      "PartTable": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "alert_success_create_category": "Category has been created.",
            "alert_error_create_category": "Category hasn't been created.",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }
          },
          "button_Hide": "Hide",
          "button_Categories": "Categories",

        },
        "Middle": {
          "Content": {
            "tab_Parts": "Generic parts",
            "infotext_1": "Filters",
            "infotext_2": "Categories",
            "PartTable":{
              "infotext_1": "Advanced search",
              "infotext_2": "List of generic parts",
              "label_Column": "Column",
              "label_Value": "Value",
              "header_Image": "Image",
              "header_Status": "Status",
              "header_Revision": "Revision",
              "header_Category": "Category",
              "header_PartLogin": "Creator",
              "header_PartDate": "Date",
              "status_Used": "used",
              "status_Alternative": "noMPN",
              "status_Assembly": "assembly",
              "contextmenu_text_Details": "Details",
              "contextmenu_text_Derive": "Derive",
              "contextmenu_text_Withdraw": "Withdraw",
              "contextmenu_text_Delete": "Delete",
              "contextmenu_text_Place": "Place",
              "export_label_top": "Parts from",
              "alert_placing": "The application has disabled the placement of prototype parts on the circuit diagram",
              "alert_error_GetParts": "Problem with downloading data. Error"
            },
            "Filters": {
              "placeholder": "Add filters"
            },
            "FiltersButtons":{
              "infotext_1": "Applied"
            },
            "PluginCategory":{
              "placeholder_Categories": "Choose category"
            },


          },
          "button_New": "New",
          "button_Details": "Details",
          "button_Derive": "Derive",
          "button_Delete": "Delete",
          "button_RemoveRevision": "Remove revision",
          "button_Place": "Place",
          "button_Withdraw": "Withdraw",
          "button_MoveTo": "Move",
          "button_Properties": "Properties",
          "button_Import": "Import",
          "button_SearchOutside": "MPNs",
          "button_AddPhysical": "Add MPN",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "alert_error_PlacePart": "The part could not be placed correctly. Error",
          "alert_error_EmptySymbolName": "Part should have a defined symbol",
          "alert_error_NoActive": "The symbol assigned to the part must be active",
          "alert_withdraw": "Are you sure you want to withdraw selected items from use?",
          "alert_delete": "Are you sure?",
          "alert_removeRevision": "Only the latest revision will be removed. Are you sure?",
          "alert_success_withdraw": "Parts have been withdrawn",
          "alert_error_withdraw": "Parts have not been withdrawn. Error",
          "alert_success_delete_part": "Part has been correctly removed",
          "alert_success_delete_parts": "Parts have been correctly removed",
          "alert_error_delete_part": "Parts was not deleted correctly. Error",
          "modal_title_delete": "Deleting",
          "alert_success_removeRevision_part": "The revision of part was removed correctly",
          "alert_error_removeRevision_part": "The revision of part was not removed correctly. Error",
          "modal_title_removeRevision": "Removing revision",
          "modal_Moving": {
            "modal_Title": "Moving part to another category",
            "label_Categories": "Please select a target category",

            "infotext_1": "You can safely move a part to the category of your choice",
            "infotext_2": "Moving a part to a selected category will lose the following properties",

            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Name": "Name of property",
            "table_header_Value": "Value",
            "placeholder_Search": "Search",

            "button_OK": "Move",
            "button_Cancel": "Cancel"
          },
          "alert_success_MovePart": "The part has been moved to another category correctly",
          "alert_error_MovePart": "The part has not been moved to another category correctly",
          "alert_error_MovePartCategory": "Select a target category",
          "modal_title_BulkFeedback": "Feedback reports",
          "modal_button_Close": "Close",
          "modal_BulkFeedback": {
            "modal_Title": "Feedback reports",
            "infotext_1": "The operation was not performed correctly for the following items",
            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Message": "Message",
            "table_header_Status": "Status",
            "placeholder_Search": "Search",

            "button_Close": "Close"
          }
        },
        "Right": {
          "Content": {
            "tab_QuickView": "Quick view",
            "infotext_1": "Select one element in the middle panel to display details data.",
            "tab_Tasks": "Tasks",
            "infotext_2": "Select one element in the middle panel to display tasks of part.",
            "tab_Search": "External Search",
            "tab_WhereUse": "Where used",
            "infotext_3": "Select one element in the middle panel to display report on the part.",
            "tab_Alternatives": "MPNs",
            "infotext_4": "Select one element in the middle panel to display MPNs.",
            "tab_Pins": "Pins",
            "infotext_5": "Select one element in the middle panel to display pins.",
            "infotext_6": "Pin analysis",
            "infotext_7": "Pins of libraries",
            "QuickView":{
              "infotext_1": "List of properties for",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
              "infotext_2": "List of parts in the assembly",
              "table_header_PartNumber": "PartNumber",
              "table_header_Revision": "Revision",
              "table_header_Quantity": "Quantity",
              "table_header_Actions": "Actions",
              "button_CreateSvg": "Create image",
              "alert_success_create_image": "The image was created correctly",
              "alert_error_create_image": "The image was not created correctly",
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },
              "label_pinSwitch": "Pin switch",
              "label_Properties": "Properties"
            },
            "Tasks":{
              "infotext_1": "This part has tasks",
              "infotext_2": "This part has no tasks.",
              "infotext_3": "Select pending revision in the table on the left panel.",
              "infotext_4": "To manage the tasks for this item, go to request.",
              "button_Approve": "Approve",
              "button_Reject": "Reject",
              "label_Reason": "Rejected",
              "label_Comment": "Comment for task",
              "label_Transfer": "Transfer ownership",
              "label_Name": "Task name",
              "label_Level1": "1st level",
              "label_Level2": "2nd level",
              "description": "Approve or reject the task",
              "alert_error_approve1": "Field",
              "alert_error_approve2": "must be completed before release. Check completeness in Details.",
              "alert_success_approve": "The approval was successful",
              "alert_error_approve": "The approval was not successful",
              "modal_Reason":{
                "placeholder_Reason": "Enter a reason",
                "label_Reason": "Reason for rejection",
                "modal_Title": "Rejection"
              },
              "modal_EventTaskForm":{
                "placeholder_Reason": "Enter a comment",
                "label_Reason": "Comment",
                "modal_Title": "Approving process",
                "label_ChangeRevision": "",
                "label_Users": "If you want, select a 2nd level user"
              },
              "modal_EventTaskFormValidation":{
                "modal_Title": "Validation process",
                "infotext_1": "Approval is not possible.",
                "infotext_2": "List of libraries that have been used and may not be complete",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "modal_EventTaskDependencyInfo":{
                "modal_Title": "Dependency info",
                "infotext_1": "List of libraries that are used in",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "DetailsHistory": {
                "infotext_1": "Select the revision in the table on the left panel",
                "infotext_2": "Comments in revision",
                "infotext_3": "No comments",
                "label_Reason": "Rejected",
                "label_Comment": "Approved with comment",
                "label_WithoutComment": "Approved without comment",
                "label_Transfer": "Transfer ownership",
                "label_Assign": "Assigned MPN",
                "label_Unassign": "Unassigned MPN",
                "label_Move": "Category changed"
              },
            },
            "Search":{
              "button_Search": "Search",
              "button_Reset": "Reset",
              "input_placeholder": "Search",
              "loader_Search": "Searching",
              "infotext_1": "No defined search engines",
              "infotext_2": "Search from third-party suppliers",
              "searchError": "The search failed. Please try again.",
              "alert_error_Searching": "Searching error"
            },
            "WhereUse":{
              "infotext_1": "Where used report",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_Variant": "Variant",
              "table_header_Quantity": "Quantity",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },
            "WhatIsIncluded": {
              "infotext_1": "Depends on",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "Alternatives":{
              "infotext_1": "List of MPNs",
              "table_header_Expand": "Exp",
              "table_header_Priority": "Priority",
              "table_header_Image": "Image",
              "table_header_Status": "Status",
              "table_header_SEStatus": "SE Status",
              "table_header_ManufacturerName": "Manufacturer Name",
              "table_header_ManufacturerPartNumber": "Manufacturer Part Number",
              "table_header_Description": "Description",
              "table_header_Datasheet": "Datasheet",
              "table_header_Login": "Who assigned",
              "table_header_Date": "When assigned",
              "table_header_SyncDate": "Synchronization date",
              "table_header_Manual": "Info",
              "table_info_Manual": "Manual MPN",
              "table_header_Action": "Action",
              "table_button_Unassign": "Unassign",
              "table_button_Details": "Details",
              "table_button_Sync": "Sync",
              "table_button_SyncSE": "SyncSE",
              "placeholder_Search": "Search",
              "alert_success_unassignAlternative": "MPN has been unassigned",
              "alert_error_unassignAlternative": "MPN has not been unassigned",
              "alert_success_syncAlternative": "MPN has been synchronized",
              "alert_error_syncAlternative": "MPN has not been synchronized. Error",
              "alert_Title": "Unassign MPN",
              "alert_Text": "Are you sure?",
              "alert_EndOfPart": "End of",
              "alert_Preferred": "Preferred",
              "alert_NRND": "NRND",
              "alert_Forbidden": "Forbidden",
              "alert_success_ChangeMPNPriority": "Priority changed correctly.",
              "alert_error_ChangeMPNPriority": "Priority not changed correctly.",
              "alert_success_StatusMPN": "The status of the MPN has been changed.",
              "alert_error_StatusMPN": "The status of the MPN has not been changed.",
              "modal_SERisk": {
                "modal_Title": "SiliconExpert Details",
                "infotext_1": "MPN",
                "infotext_2": "Manufacturer name"
              },
              "button_label_Details": "Details",
              "button_label_GetDataFromSE": "Get data from SE",
              "button_label_SE_sync": "SE Sync",
              "button_label_SE_RiskDetails": "Risk details",
              "button_label_SyncPartSE": "Sync SE data",
              "button_label_SE_unassign": "Unassign SE data",
              "modal_title_unassignSEData": "Unassign SE data",
              "alert_unassignSEData": "Are you sure?",
              "alert_success_unassignSEData": "SE data has been unassigned",
              "alert_error_unassignSEData": "SE data has not been unassigned. Error",
              "alert_success_SyncSEData": "SE data has been synchronized",
              "alert_error_SyncSEData": "SE data has not been synchronized. Error",
              "TreeSE": {
                "placeholder_Search": "Search",
              },
              "modal_SESuggestions": {
                  "modal_Title": "SiliconExpert Parts",
                  "OverallDetails": {
                    "infotext_1": "Overall properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "PropertiesDetails":{
                    "infotext_1": "Technical properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "SEPropertiesChoose": {
                    "infotext_1": "SiliconExpert details data",
                    "infotext_2": "Select one SE part and link it to the MPN part",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                },
              "alert_success_AssignPartSEToMPN": "PartSE has been assigned to MPN.",
              "alert_error_AssignPartSEToMPN": "PartSE has not been assigned to MPN. Error",
            },
            "AlternativeDetails":{
              "button_Back": "Back",
              "button_Unassign": "Unassign",
              "button_Sync": "Sync",
              "button_SyncSE": "SyncSE",
              "alert_success_unassignAlternative": "MPN has been unassigned",
              "alert_error_unassignAlternative": "MPN has not been unassigned",
              "alert_success_syncAlternative": "MPN has been synchronized",
              "alert_error_syncAlternative": "MPN has not been synchronized. Error",
              "alert_Title": "Unassign MPN",
              "alert_Text": "Are you sure?",
              "OverallDetails": {
                "infotext_1": "Overall properties of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "PropertiesDetails":{
                "infotext_1": "Technical properties of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "AvailabilityDetails":{
                "infotext_1": "Availability of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "PriceDetails":{
                "infotext_1": "Prices of the MPN",
                "table_header_MinQuantity": "Min Quantity",
                "table_header_Price": "Price",
                "table_header_Currency": "Currency",
                "placeholder_Search": "Search",
              },
              "AvailabilityDetails":{
                "infotext_1": "Availability of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "SEDetails":{
                "infotext_1": "SiliconExpert details",
                "infotext_2": "Data from SiliconExpert not matched to MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
                "modal_SERisk": {
                  "modal_Title": "SiliconExpert Details",
                  "infotext_1": "MPN",
                  "infotext_2": "Manufacturer name"
                },
                "button_label_Details": "Details",
                "button_label_GetDataFromSE": "Get data from SE",
                "button_label_SE_sync": "Sync SE data",
                "button_label_SE_RiskDetails": "Risk details",
                "button_label_SyncPartSE": "Sync SE data",
                "button_label_SE_unassign": "Unassign SE data",
                "modal_title_unassignSEData": "Unassign SE data",
                "alert_unassignSEData": "Are you sure?",
                "alert_success_unassignSEData": "SE data has been unassigned",
                "alert_error_unassignSEData": "SE data has not been unassigned. Error",
                "alert_success_SyncSEData": "SE data has been synchronized",
                "alert_error_SyncSEData": "SE data has not been synchronized. Error",
                "TreeSE": {
                  "placeholder_Search": "Search",
                },
                "modal_SESuggestions": {
                  "modal_Title": "SiliconExpert Parts",
                  "OverallDetails": {
                    "infotext_1": "Overall properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "PropertiesDetails":{
                    "infotext_1": "Technical properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "SEPropertiesChoose": {
                    "infotext_1": "SiliconExpert details data",
                    "infotext_2": "Select one SE part and link it to the MPN part",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                },
                "alert_success_AssignPartSEToMPN": "PartSE has been assigned to MPN.",
                "alert_error_AssignPartSEToMPN": "PartSE has not been assigned to MPN. Error",
              },
              "label_Manual": "Additional parameters",
              "label_EndOfLife": "End of Life date",
              "label_EndOfSale": "End of Sale date",
              "label_OverallRisk": "OverallRisk",
              "label_LifeCycleRiskGrade": "LifeCycleRiskGrade",
              "label_RohsRisk": "RohsRisk",
              "label_RoHSVersion": "RoHSVersion",
              "label_ChinaRoHSStatus": "ChinaRoHSStatus",
              "label_LifecycleRisk": "LifecycleRisk",
              "label_PartStatus": "PartStatus",
              "label_EstimatedYearsToEOL": "EstimatedYearsToEOL",
              "label_MultiSourcingRisk": "MultiSourcingRisk",
              "label_Comment": "Comment",
              "button_Update": "Update",
              "alert_success_updateAlternative": "The parameters have been saved correctly",
              "alert_error_updateAlternative": "Parameters were not saved correctly",

            },
            "PinsPartsTable": {

              "infotext_1": "Pins of libraries",
              "infotext_2": "symbol",
              "infotext_3": "hdl symbol",
              "infotext_4": "footprint",
              "label_Primitives": "Primitives",
              "table_header_Number": "Number",
              "table_header_Name": "Name",
              "table_header_Padstack": "Padstack",
              "table_header_Type": "Type",
              "placeholder_Search": "Search",

            },
            "modal_PinAnalysis": {
              "modal_Title": "Pin analysis",
              "infotext_1": "Pin matching alerts",
              "infotext_2": "Pins of libraries",
              "label_PinCountMatching": "Pin count matching",
              "label_PinNumberMatching": "Pin number matching",
              "label_Primitives": "Primitives",
              "table_header_OverSymbol": "Symbol",
              "table_header_OverHDLSymbol": "HDL symbol",
              "table_header_OverFootprint": "Footprint",
              "table_header_Number": "Number",
              "table_header_Name": "Name",
              "table_header_Padstack": "Padstack",
              "table_header_Type": "Type",
              "placeholder_Search": "Search",
              "label_pinSwitch": "Pin switch",

            },
            "button_Analyze": "Analyze",

          },
          "button_Hide": "Hide"
        }
      },

      "PartDerive": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }

          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_NewPart": "New part",
            "DerivePartForm":{
              "infotext_1": "Fill out the form to create a new part for category",
              "infotext_2": "This property is required to create a new part.",
              "infotext_3": "Unable to create an new part in the 'All components' category",
              "infotext_4": "If you create part in this category, it will not be visible in CIS Explorer",
              "infotext_5": "This property doesn’t inherit previous value.",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "button_Library": "Select from list",
              "button_AltSymbols": "Select from list",
              "label_PartNumber": "A blank field will automatically generate a Part number according to the template",
              "modal_Footprints":{
                "modal_Title": "Footprints",
                "infotext_1": "You can search and select footprint from the table below",
                "tab_Footprints": "Footprints",
                "table_Footprints":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new footprint",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The footprint name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",

                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new part.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The renamed library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                },
                "tab_LibraryRequest": "Request",
                "LibraryRequest": {
                  "infotext_1": "Fill out the new library request form",
                  "label_Remarks": "Remarks",
                  "validinfo_Remarks": "The Remarks name must not be empty.",
                  "label_Priority": "Priority",
                  "label_Deadline": "Deadline",
                  "validinfo_Deadline": "Deadline may not be in the past.",
                  "label_Files": "Files",
                  "validinfo_Files": "Incorrect file format",
                  "placeholder_Files": "No files choosen",
                  "button_CreateLibRequest": "Create library request",
                  "alert_success_CreateLibRequest": "The library request was created correctly.",
                  "alert_error_CreateLibRequest": "Library request was not created correctly. Error",
                  "modal_PushRequest": {
                    "modal_Title": "Pushed files",
                    "infotext_1": "List of pushed files",
                    "infotext_2": "No files were pushed",
                    "infotext_3": "As a result of the file push operation, a new revision was created",
                    "table_header_Name": "Filename",
                    "table_header_Status": "Status",
                    "table_header_Dependency": "Dependency",
                    "table_header_Description": "Description",
                    "placeholder_Search": "Search",
                  },
                }
              },
              "modal_Symbols":{
                "modal_Title": "Symbols",
                "modal_TitleHDL": "HDL symbols",
                "modal_TitleSymbols": "Symbols",
                "infotext_1": "You can search and add symbols from the table below",
                "tab_Symbols": "Symbols",
                "table_Symbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Add": "Add",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new symbol",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The symbol name must not be empty.",
                "alert_success_create_symbol": "A new symbol has been created",
                "alert_error_create_symbol": "A new symbol has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new part.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The renamed library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                },
                "tab_LibraryRequest": "Request",
                "LibraryRequest": {
                  "infotext_1": "Fill out the new library request form",
                  "label_Remarks": "Remarks",
                  "validinfo_Remarks": "The Remarks name must not be empty.",
                  "label_Priority": "Priority",
                  "label_Deadline": "Deadline",
                  "validinfo_Deadline": "Deadline may not be in the past.",
                  "label_Files": "Files",
                  "validinfo_Files": "Incorrect file format",
                  "placeholder_Files": "No files choosen",
                  "button_CreateLibRequest": "Create library request",
                  "alert_success_CreateLibRequest": "The library request was created correctly.",
                  "alert_error_CreateLibRequest": "Library request was not created correctly. Error",
                  "modal_PushRequest": {
                    "modal_Title": "Pushed files",
                    "infotext_1": "List of pushed files",
                    "infotext_2": "No files were pushed",
                    "infotext_3": "As a result of the file push operation, a new revision was created",
                    "table_header_Name": "Filename",
                    "table_header_Status": "Status",
                    "table_header_Dependency": "Dependency",
                    "table_header_Description": "Description",
                    "placeholder_Search": "Search",
                  },
                }

              },
              "modal_Libraries":{
                "modal_Title": "Libraries",
                "infotext_1": "You can search and select library from the table below",
                "table_Libraries":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",


              },
              "modal_AltSymbols":{
                "modal_Title": "ALT_SYMBOLS",
                "infotext_1": "You can search and select library from the table below",
                "table_AltSymbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_AddTop": "Add to Top",
                  "button_AddBottom": "Add to Bottom",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new library has been created",
                "alert_error_create_footprint": "A new library has not been created",


              },
            },
            "tab_NewPartFound": "New part from found",
            "DeriveSearchedPartForm":{
              "infotext_1": "Fill out the form to create a new part for category",
              "infotext_2": "This property is required to create a new part.",
              "infotext_3": "Unable to create an new part in the 'All components' category",
              "infotext_4": "If you create part in this category, it will not be visible in CIS Explorer",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",
              "label_PartNumber": "A blank field will automatically generate a Part number according to the template",
              "table_header_Found": "Property value from found",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "button_Library": "Select from list",
              "button_AltSymbols": "Select from list",
              "modal_Footprints":{
                "modal_Title": "Footprints",
                "infotext_1": "You can search and select footprint from the table below",
                "tab_Footprints": "Footprints",
                "table_Footprints":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new footprint",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The footprint name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new part.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The renamed library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                }
              },
              "modal_Symbols":{
                "modal_Title": "Symbols",
                "modal_TitleHDL": "HDL symbols",
                "modal_TitleSymbols": "Symbols",
                "infotext_1": "You can search and add symbols from the table below",
                "tab_Symbols": "Symbols",
                "table_Symbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Add": "Add",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new symbol",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The symbol name must not be empty.",
                "alert_success_create_symbol": "A new symbol has been created",
                "alert_error_create_symbol": "A new symbol has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new part.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The renamed library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                },
                "tab_LibraryRequest": "Request",
                "LibraryRequest": {
                  "infotext_1": "Fill out the new library request form",
                  "label_Remarks": "Remarks",
                  "validinfo_Remarks": "The Remarks name must not be empty.",
                  "label_Priority": "Priority",
                  "label_Deadline": "Deadline",
                  "validinfo_Deadline": "Deadline may not be in the past.",
                  "label_Files": "Files",
                  "validinfo_Files": "Incorrect file format",
                  "placeholder_Files": "No files choosen",
                  "button_CreateLibRequest": "Create library request",
                  "alert_success_CreateLibRequest": "The library request was created correctly.",
                  "alert_error_CreateLibRequest": "Library request was not created correctly. Error",
                  "modal_PushRequest": {
                    "modal_Title": "Pushed files",
                    "infotext_1": "List of pushed files",
                    "infotext_2": "No files were pushed",
                    "infotext_3": "As a result of the file push operation, a new revision was created",
                    "table_header_Name": "Filename",
                    "table_header_Status": "Status",
                    "table_header_Dependency": "Dependency",
                    "table_header_Description": "Description",
                    "placeholder_Search": "Search",
                  },
                }
              },
              "modal_Libraries":{
                "modal_Title": "Libraries",
                "infotext_1": "You can search and select library from the table below",
                "table_Libraries":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",


              },
              "modal_AltSymbols":{
                "modal_Title": "ALT_SYMBOLS",
                "infotext_1": "You can search and select library from the table below",
                "table_AltSymbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_AddTop": "Add to Top",
                  "button_AddBottom": "Add to Bottom",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new library has been created",
                "alert_error_create_footprint": "A new library has not been created",


              },
            },
            "CreatePropertiesForm": {
              "infotext_1": "Select the parameters that will be used to create new properties",
              "placeholder_Search": "Search",
              "table_header_Name": "New name of property",
              "table_header_Type": "Type of property",
              "table_header_Value": "Property value",
              "table_header_Found": "Property name and value from found",

              "button_Delete": "Delete"
            }

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Save": "Save as new",
          "alert_success_new_part": "The new part has been saved.",
          "alert_error_new_part_required": "Fields marked as Request must not be empty.",
          "alert_error_new_part": "The new part has not been saved. Error",
          "alert_error_new_props": "The new properties have not been added. Error",

        },
        "Right": {
          "Content": {


          },
          "button_Hide": "Hide"
        }
      },

      "PartDetails": {
        "Left": {
          "Content": {
            "tab_Revisions": "Revision history",
            "InfoElement": {
              "infotext_1": "List of revisions for",
              "infotext_2": "Category",
            },
            "RevisionsTable": {
              "table_header_Expand": "Exp",
              "table_header_Select": "Select",
              "table_header_Revision": "Revision",
              "table_header_Status": "Status",
              "table_header_Date": "When",
              "table_header_User": "Who",
              "table_header_RequestDate": "Request",
              "table_header_RequestLogin": "Request",
              "table_header_Date1": "Level 1",
              "table_header_Login1": "Level 1",
              "table_header_Date2": "Level 2",
              "table_header_Login2": "Level 2",
              "placeholder_Search": "Search"
            },
            "tab_Diagram": "Diagram",
            "RevisionsDiagram":{

            }


          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_Details": "Part details",
            "infotext_1": "List of properties of the generic part",
            "PartDetails":{

              "table_header_Name": "Name",
              "table_header_Value": "Values for revision",
              "placeholder_Search": "Search",
              "infotext_1": "Select the revision in the table on the left panel",
              "infotext_Request": "This property is required to save a part.",
              "infotext_Release": "This property is required to approve a part.",
              "infotext_Revision": "Changing this property will change the revision after saving.",
              "table_subheader": "Revision",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "button_Library": "Select from list",
              "button_AltSymbols": "Select from list",


              "modal_Footprints": {
                "modal_Title": "Footprints",
                "infotext_1": "You can search and select footprint from the table below",

                "tab_Footprints": "Footprints",
                "table_Footprints":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new footprint",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The footprint name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "alert_error_appendfiles_UL": "Library file download error. UL API Error.",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new library.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "infotext_7": "Such a library name already exists",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                },
                "tab_LibraryRequest": "Request",
                "LibraryRequest": {
                  "infotext_1": "Fill out the new library request form",
                  "label_Remarks": "Remarks",
                  "validinfo_Remarks": "The Remarks name must not be empty.",
                  "label_Priority": "Priority",
                  "label_Deadline": "Deadline",
                  "validinfo_Deadline": "Deadline may not be in the past.",
                  "label_Files": "Files",
                  "validinfo_Files": "Incorrect file format",
                  "placeholder_Files": "No files choosen",
                  "button_CreateLibRequest": "Create library request",
                  "alert_success_CreateLibRequest": "The library request was created correctly.",
                  "alert_error_CreateLibRequest": "Library request was not created correctly. Error",
                  "modal_PushRequest": {
                    "modal_Title": "Pushed files",
                    "infotext_1": "List of pushed files",
                    "infotext_2": "No files were pushed",
                    "infotext_3": "As a result of the file push operation, a new revision was created",
                    "table_header_Name": "Filename",
                    "table_header_Status": "Status",
                    "table_header_Dependency": "Dependency",
                    "table_header_Description": "Description",
                    "placeholder_Search": "Search",
                  },
                }


              },
              "modal_Symbols":{
                "modal_Title": "Symbols",
                "modal_TitleHDL": "HDL symbols",
                "modal_TitleSymbols": "Symbols",
                "infotext_1": "You can search and add symbols from the table below",

                "tab_Symbols": "Symbols",
                "table_Symbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Add": "Add",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new symbol",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The symbol name must not be empty.",
                "alert_success_create_symbol": "A new symbol has been created",
                "alert_error_create_symbol": "A new symbol has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new library.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "infotext_7": "Such a library name already exists",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                },
                "tab_LibraryRequest": "Request",
                "LibraryRequest": {
                  "infotext_1": "Fill out the new library request form",
                  "label_Remarks": "Remarks",
                  "validinfo_Remarks": "The Remarks name must not be empty.",
                  "label_Priority": "Priority",
                  "label_Deadline": "Deadline",
                  "validinfo_Deadline": "Deadline may not be in the past.",
                  "label_Files": "Files",
                  "validinfo_Files": "Incorrect file format",
                  "placeholder_Files": "No files choosen",
                  "button_CreateLibRequest": "Create library request",
                  "alert_success_CreateLibRequest": "The library request was created correctly.",
                  "alert_error_CreateLibRequest": "Library request was not created correctly. Error",
                  "modal_PushRequest": {
                    "modal_Title": "Pushed files",
                    "infotext_1": "List of pushed files",
                    "infotext_2": "No files were pushed",
                    "infotext_3": "As a result of the file push operation, a new revision was created",
                    "table_header_Name": "Filename",
                    "table_header_Status": "Status",
                    "table_header_Dependency": "Dependency",
                    "table_header_Description": "Description",
                    "placeholder_Search": "Search",
                  },
                }

              },
              "modal_Libraries":{
                "modal_Title": "Libraries",
                "infotext_1": "You can search and select library from the table below",
                "table_Libraries":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",


              },
              "modal_AltSymbols":{
                "modal_Title": "ALT_SYMBOLS",
                "infotext_1": "You can search and select library from the table below",
                "table_AltSymbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_AddTop": "Add to Top",
                  "button_AddBottom": "Add to Bottom",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new library has been created",
                "alert_error_create_footprint": "A new library has not been created",


              },
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },
              "label_pinSwitch": "Pin switch",
              "label_Properties": "Properties"
            },
            "tab_History": "History",

            "DetailsHistory": {
              "infotext_1": "Select the revision in the table on the left panel",
              "infotext_2": "Comments in revision",
              "infotext_3": "No comments",
              "label_Reason": "Rejected",
              "label_Comment": "Approved with comment",
              "label_WithoutComment": "Approved without comment",
              "label_Transfer": "Transfer ownership",
              "label_Assign": "Assigned MPN",
              "label_Unassign": "Unassigned MPN",
              "label_Move": "Category changed"
            },
            "infotext_2": "Parts in assembly",
            "AssemblyDetails": {
              "placeholder_Search": "Search",
              "table_header_Expand": "Exp",
              "table_header_Revision": "Assembly revision",
              "table_header_MpnImage": "MPN image",
              "table_header_PartNumber": "Part Number",
              "table_header_PartRevision": "Part revision",
              "table_header_Quantity": "Quantity",
              "table_header_Type": "Type",
              "table_header_Actions": "Actions",
              "label_Main": "Main",
              "button_UnassignActions": "Unassign",
              "alert_success_unassign": "Part has been unassigned.",
              "alert_error_unassign": "Part has not been unassigned. Error",
              "alert_error_AssemblyQuantity": "The number of elements must be greater than 0",
              "modal_QuantityForAssembly": {
                "modal_Title": "Quantity",
                "label_Quantity": "Quantity",
                "validinfo_Quantity": "The specified value must be an integer."
              },
            }


          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Up": "Up",
          "button_Edit": "Edit",
          "button_Unedit": "Disable editing",
          "button_Save": "Save",
          "button_AssignToAssembly": "Assign part",
          "button_RemoveFromAssembly": "Remove part",
          "button_Derive": "Derive",
          "button_Withdraw": "Withdraw",
          "button_Delete": "Delete",
          "button_RemoveRevision": "Remove revision",
          "button_MoveTo": "Move",
          "button_SearchOutside": "MPNs",
          "button_AddPhysical": "Add MPN",
          "button_TransferOwnership": "Transfer ownership",
          "alert_success_edit_part": "The properties of the part have been saved.",
          "alert_error_edit_part": "Part properties have not been saved. Error",
          "alert_error_edit_required": "Fields marked as Request must not be empty.",

          "button_GotoRequest": "Go to request",

          "modal_TransferOwnership": {
            "modal_Title": "Transfer ownership to another user",
            "label_Users": "Users",

          },

          "alert_success_TransferOwnership": "Ownership of the part has been transferred to another user.",
          "alert_error_TransferOwnership": "Ownership of the part has not been transferred to another user. Error",
          "modal_SearchParts": {
            "modal_Title": "Searching for parts",

              "Tree": {
                "infotext_1": "Category tree:",
                "placeholder_Search": "Search",
                "button_Delete": "Delete",
                "TreeItem": {
                  "alert_success_delete_category": "Category has been deleted.",
                  "alert_error_delete_category": "Category hasn't been deleted.",
                }
              },
              "PartTable":{
                "infotext_2": "List of generic parts",
                "header_Image": "Image",
                "header_Status": "Status",
                "header_Revision": "Revision",
                "status_Used": "used",
                "status_Alternative": "no MPN",
                "status_Assembly": "assembly",
                "contextmenu_text_Details": "Details",
                "contextmenu_text_Derive": "Derive",
                "contextmenu_text_Withdraw": "Withdraw",
                "contextmenu_text_Delete": "Delete",
                "contextmenu_text_Place": "Place",
                "export_label_top": "Parts from",
                "label_checkbox": "Only parts matching through footprints",
            },
            "infotext_1": "Select one element in the middle panel to display details data.",
            "QuickView":{
              "infotext_1": "List of properties for",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
              "infotext_2": "List of parts in the assembly",
              "table_header_PartNumber": "PartNumber",
              "table_header_Revision": "Revision",
              "table_header_Quantity": "Quantity",
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },
              "label_pinSwitch": "Pin switch",
              "label_Properties": "Properties"
            },
          },
          "modal_QuantityForAssembly": {
            "modal_Title": "Quantity",
            "label_Quantity": "Quantity",
            "validinfo_Quantity": "The specified value must be an integer."

          },
          "alert_success_AssignAssembly": "The part has been assigned to assembly.",
          "alert_error_AssignAssembly": "Item has not been assigned to the assembly. Error",
          "alert_withdraw": "Are you sure you want to withdraw selected items from use?",
          "alert_delete": "Are you sure?",
          "alert_removeRevision": "Only the latest revision will be removed. Are you sure?",
          "alert_success_withdraw": "Parts have been withdrawn",
          "alert_error_withdraw": "Parts have not been withdrawn. Error",
          "alert_success_delete_part": "Part has been correctly removed",
          "alert_success_delete_parts": "Parts have been correctly removed",
          "alert_error_delete_part": "Parts was not deleted correctly. Error",
          "modal_title_delete": "Deleting",
          "alert_success_removeRevision_part": "The revision of part was removed correctly",
          "alert_error_removeRevision_part": "The revision of part was not removed correctly. Error",
          "modal_title_removeRevision": "Removing revision",
          "modal_Moving": {
              "modal_Title": "Moving part to another category",
              "label_Categories": "Please select a target category",

              "infotext_1": "You can safely move a part to the category of your choice",
              "infotext_2": "Moving a part to a selected category will lose the following properties",

              "table_header_PartNumber": "Part number",
              "table_header_LibraryNumber": "Library number",
              "table_header_ProjectNumber": "Project number",
              "table_header_Name": "Name of property",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",

              "button_OK": "Move",
              "button_Cancel": "Cancel"
            },
          "alert_success_MovePart": "The part has been moved to another category correctly",
          "alert_error_MovePart": "The part has not been moved to another category correctly",
          "alert_error_MovePartCategory": "Select a target category",
          "modal_title_BulkFeedback": "Feedback reports",
          "modal_button_Close": "Close",
          "modal_BulkFeedback": {
            "modal_Title": "Feedback reports",
            "infotext_1": "The operation was not performed correctly for the following items",
            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Message": "Message",
            "table_header_Status": "Status",
            "placeholder_Search": "Search",

            "button_Close": "Close"
          }
        },
        "Right": {
          "Content": {
            "tab_Tasks": "My tasks",
            "tab_WhereUse": "Where used",
            "tab_Alternatives": "MPNs",
            "infotext_3": "Select one element in the middle panel to display MPNs.",
            "tab_Pins": "Pins",
            "infotext_5": "Select one element in the middle panel to display pins.",
            "infotext_6": "Pin analysis",
            "infotext_7": "Pins of libraries",
            "Tasks":{
              "infotext_1": "This part has tasks",
              "infotext_2": "This part has no tasks.",
              "infotext_3": "Select pending revision in the table on the left panel.",
              "infotext_4": "To manage the tasks for this item, go to request.",
              "button_Approve": "Approve",
              "button_Reject": "Reject",
              "label_Reason": "Reason for rejection",
              "label_Comment": "Comment for task",
              "label_Transfer": "Transfer ownership",
              "label_Name": "Task name",
              "label_Level1": "1st level",
              "label_Level2": "2nd level",
              "description": "Approve or reject the task",
              "alert_error_approve1": "Field",
              "alert_error_approve2": "must be completed before release.",
              "alert_success_approve": "The approval was successful",
              "alert_error_approve": "The approval was not successful",
              "modal_Reason":{
                "placeholder_Reason": "Enter a reason",
                "label_Reason": "Reason for rejection",
                "modal_Title": "Rejection"
              },
              "modal_EventTaskForm":{
                "placeholder_Reason": "Enter a comment",
                "label_Reason": "Comment",
                "modal_Title": "Approving process",
                "label_ChangeRevision": "",
                "label_Users": "If you want, select a 2nd level user"
              },
              "modal_EventTaskFormValidation":{
                "modal_Title": "Validation process",
                "infotext_1": "Approval is not possible.",
                "infotext_2": "List of libraries that have been used and may not be complete",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"
              },
              "modal_EventTaskDependencyInfo":{
                "modal_Title": "Dependency info",
                "infotext_1": "List of libraries that are used in",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "DetailsHistory": {
                "infotext_1": "Select the revision in the table on the left panel",
                "infotext_2": "Comments in revision",
                "infotext_3": "No comments",
                "label_Reason": "Rejected",
                "label_Comment": "Approved with comment",
                "label_WithoutComment": "Approved without comment",
                "label_Transfer": "Transfer ownership",
                "label_Assign": "Assigned MPN",
                "label_Unassign": "Unassigned MPN",
                "label_Move": "Category changed"
              },
            },
            "WhereUse":{
              "infotext_1": "Where used report",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_Variant": "Variant",
              "table_header_Quantity": "Quantity",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },
            "WhatIsIncluded": {
              "infotext_1": "Depends on",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "Alternatives":{
              "infotext_1": "List of MPNs",
              "table_header_Expand": "Exp",
              "table_header_Priority": "Priority",
              "table_header_Image": "Image",
              "table_header_Status": "Status",
              "table_header_SEStatus": "SE Status",
              "table_header_ManufacturerName": "Manufacturer Name",
              "table_header_ManufacturerPartNumber": "Manufacturer Part Number",
              "table_header_Description": "Description",
              "table_header_Datasheet": "Datasheet",
              "table_header_Login": "Who assigned",
              "table_header_Date": "When assigned",
              "table_header_SyncDate": "Synchronization date",
              "table_header_Manual": "Info",
              "table_info_Manual": "Manual MPN",
              "table_header_Action": "Action",
              "table_button_Unassign": "Unassign",
              "table_button_Details": "Details",
              "table_button_Sync": "Sync",
              "table_button_SyncSE": "SyncSE",
              "placeholder_Search": "Search",
              "alert_success_unassignAlternative": "MPN has been unassigned",
              "alert_error_unassignAlternative": "MPN has not been unassigned",
              "alert_success_syncAlternative": "MPN has been synchronized",
              "alert_error_syncAlternative": "MPN has not been synchronized. Error",
              "alert_Title": "Unassign MPN",
              "alert_Text": "Are you sure?",
              "alert_EndOfPart": "End of",
              "alert_Preferred": "Preferred",
              "alert_NRND": "NRND",
              "alert_Forbidden": "Forbidden",
              "alert_success_ChangeMPNPriority": "Priority changed correctly.",
              "alert_error_ChangeMPNPriority": "Priority not changed correctly.",
              "alert_success_StatusMPN": "The status of the MPN has been changed.",
              "alert_error_StatusMPN": "The status of the MPN has not been changed.",
              "modal_SERisk": {
                "modal_Title": "SiliconExpert Details",
                "infotext_1": "MPN",
                "infotext_2": "Manufacturer name"
              },
              "button_label_Details": "Details",
              "button_label_GetDataFromSE": "Get data from SE",
              "button_label_SE_sync": "SE Sync",
              "button_label_SE_RiskDetails": "Risk details",
              "button_label_SyncPartSE": "Sync SE data",
              "button_label_SE_unassign": "Unassign SE data",
              "modal_title_unassignSEData": "Unassign SE data",
              "alert_unassignSEData": "Are you sure?",
              "alert_success_unassignSEData": "SE data has been unassigned",
              "alert_error_unassignSEData": "SE data has not been unassigned. Error",
              "alert_success_SyncSEData": "SE data has been synchronized",
              "alert_error_SyncSEData": "SE data has not been synchronized. Error",
              "TreeSE": {
                "placeholder_Search": "Search",
              },
              "modal_SESuggestions": {
                  "modal_Title": "SiliconExpert Parts",
                  "OverallDetails": {
                    "infotext_1": "Overall properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "PropertiesDetails":{
                    "infotext_1": "Technical properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "SEPropertiesChoose": {
                    "infotext_1": "SiliconExpert details data",
                    "infotext_2": "Select one SE part and link it to the MPN part",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                },
              "alert_success_AssignPartSEToMPN": "PartSE has been assigned to MPN.",
              "alert_error_AssignPartSEToMPN": "PartSE has not been assigned to MPN. Error",

            },
            "AlternativeDetails":{
              "button_Back": "Back",
              "button_Unassign": "Unassign",
              "button_Sync": "Sync",
              "button_SyncSE": "SyncSE",
              "alert_success_unassignAlternative": "MPN has been unassigned",
              "alert_error_unassignAlternative": "MPN has not been unassigned",
              "alert_success_syncAlternative": "MPN has been synchronized",
              "alert_error_syncAlternative": "MPN has not been synchronized. Error",
              "alert_Title": "Unassign MPN",
              "alert_Text": "Are you sure?",
              "OverallDetails": {
                "infotext_1": "Overall properties of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "PropertiesDetails":{
                "infotext_1": "Technical properties of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "AvailabilityDetails":{
                "infotext_1": "Availability of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "PriceDetails":{
                "infotext_1": "Prices of the MPN",
                "table_header_MinQuantity": "Min Quantity",
                "table_header_Price": "Price",
                "table_header_Currency": "Currency",
                "placeholder_Search": "Search",
              },
              "AvailabilityDetails":{
                "infotext_1": "Availability of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "SEDetails":{
                "infotext_1": "SiliconExpert details",
                "infotext_2": "Data from SiliconExpert not matched to MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
                "modal_SERisk": {
                  "modal_Title": "SiliconExpert Details",
                  "infotext_1": "MPN",
                  "infotext_2": "Manufacturer name"
                },
                "button_label_Details": "Details",
                "button_label_GetDataFromSE": "Get data from SE",
                "button_label_SE_sync": "SE Sync",
                "button_label_SE_RiskDetails": "Risk details",
                "button_label_SyncPartSE": "Sync SE data",
                "button_label_SE_unassign": "Unassign SE data",
                "modal_title_unassignSEData": "Unassign SE data",
                "alert_unassignSEData": "Are you sure?",
                "alert_success_unassignSEData": "SE data has been unassigned",
                "alert_error_unassignSEData": "SE data has not been unassigned. Error",
                "alert_success_SyncSEData": "SE data has been synchronized",
                "alert_error_SyncSEData": "SE data has not been synchronized. Error",
                "TreeSE": {
                  "placeholder_Search": "Search",
                },
                "modal_SESuggestions": {
                  "modal_Title": "SiliconExpert Parts",
                  "OverallDetails": {
                    "infotext_1": "Overall properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "PropertiesDetails":{
                    "infotext_1": "Technical properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "SEPropertiesChoose": {
                    "infotext_1": "SiliconExpert details data",
                    "infotext_2": "Select one SE part and link it to the MPN part",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                },
              "alert_success_AssignPartSEToMPN": "PartSE has been assigned to MPN.",
              "alert_error_AssignPartSEToMPN": "PartSE has not been assigned to MPN. Error",
              },
              "label_Manual": "Additional parameters",
              "label_EndOfLife": "End of Life date",
              "label_EndOfSale": "End of Sale date",
              "label_OverallRisk": "OverallRisk",
              "label_LifeCycleRiskGrade": "LifeCycleRiskGrade",
              "label_RohsRisk": "RohsRisk",
              "label_RoHSVersion": "RoHSVersion",
              "label_ChinaRoHSStatus": "ChinaRoHSStatus",
              "label_LifecycleRisk": "LifecycleRisk",
              "label_PartStatus": "PartStatus",
              "label_EstimatedYearsToEOL": "EstimatedYearsToEOL",
              "label_MultiSourcingRisk": "MultiSourcingRisk",
              "label_Comment": "Comment",
              "button_Update": "Update",
              "alert_success_updateAlternative": "The parameters have been saved correctly",
              "alert_error_updateAlternative": "Parameters were not saved correctly"
            },
            "PinsPartsTable": {

              "infotext_1": "Pins of libraries",
              "infotext_2": "symbol",
              "infotext_3": "hdl symbol",
              "infotext_4": "footprint",
              "label_Primitives": "Primitives",
              "table_header_Number": "Number",
              "table_header_Name": "Name",
              "table_header_Padstack": "Padstack",
              "table_header_Type": "Type",
              "placeholder_Search": "Search",

            },
            "modal_PinAnalysis": {
              "modal_Title": "Pin analysis",
              "infotext_1": "Pin matching alerts",
              "infotext_2": "Pins of libraries",
              "label_PinCountMatching": "Pin count matching",
              "label_PinNumberMatching": "Pin number matching",
              "label_Primitives": "Primitives",
              "table_header_OverSymbol": "Symbol",
              "table_header_OverHDLSymbol": "HDL symbol",
              "table_header_OverFootprint": "Footprint",
              "table_header_Number": "Number",
              "table_header_Name": "Name",
              "table_header_Padstack": "Padstack",
              "table_header_Type": "Type",
              "placeholder_Search": "Search",
              "label_pinSwitch": "Pin switch",

            },
            "button_Analyze": "Analyze",

          },
          "button_Hide": "Hide"
        }
      },

      "PartNew": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }

          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_NewPart": "New part",
            "NewPartForm":{
              "infotext_1": "Fill out the form to create a new part for category",
              "infotext_2": "This property is required to create a new part.",
              "infotext_3": "Unable to create an new part in the 'All components' category",
              "infotext_4": "If you create part in this category, it will not be visible in CIS Explorer",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",
              "label_PartNumber": "A blank field will automatically generate a Part number according to the template",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "button_Library": "Select from list",
              "button_AltSymbols": "Select from list",
              "modal_Footprints": {
                "modal_Title": "Footprints",
                "infotext_1": "You can search and select footprint from the table below",

                "tab_Footprints": "Footprints",
                "table_Footprints":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new footprint",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The footprint name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "alert_error_appendfiles_UL": "Library file download error. UL API Error.",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new library.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "infotext_7": "Such a library name already exists",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                },
                "tab_LibraryRequest": "Request",
                "LibraryRequest": {
                  "infotext_1": "Fill out the new library request form",
                  "label_Remarks": "Remarks",
                  "validinfo_Remarks": "The Remarks name must not be empty.",
                  "label_Priority": "Priority",
                  "label_Deadline": "Deadline",
                  "validinfo_Deadline": "Deadline may not be in the past.",
                  "label_Files": "Files",
                  "validinfo_Files": "Incorrect file format",
                  "placeholder_Files": "No files choosen",
                  "button_CreateLibRequest": "Create library request",
                  "alert_success_CreateLibRequest": "The library request was created correctly.",
                  "alert_error_CreateLibRequest": "Library request was not created correctly. Error",
                  "modal_PushRequest": {
                    "modal_Title": "Pushed files",
                    "infotext_1": "List of pushed files",
                    "infotext_2": "No files were pushed",
                    "infotext_3": "As a result of the file push operation, a new revision was created",
                    "table_header_Name": "Filename",
                    "table_header_Status": "Status",
                    "table_header_Dependency": "Dependency",
                    "table_header_Description": "Description",
                    "placeholder_Search": "Search",
                  },
                }


              },
              "modal_Symbols":{
                "modal_Title": "Symbols",
                "modal_TitleHDL": "HDL symbols",
                "modal_TitleSymbols": "Symbols",
                "infotext_1": "You can search and add symbols from the table below",

                "tab_Symbols": "Symbols",
                "table_Symbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Add": "Add",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new symbol",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The symbol name must not be empty.",
                "alert_success_create_symbol": "A new symbol has been created",
                "alert_error_create_symbol": "A new symbol has not been created",

                "tab_UltraLibrarian": "Ultra Librarian",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new library.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "infotext_7": "Such a library name already exists",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                },
                "tab_LibraryRequest": "Request",
                "LibraryRequest": {
                  "infotext_1": "Fill out the new library request form",
                  "label_Remarks": "Remarks",
                  "validinfo_Remarks": "The Remarks name must not be empty.",
                  "label_Priority": "Priority",
                  "label_Deadline": "Deadline",
                  "validinfo_Deadline": "Deadline may not be in the past.",
                  "label_Files": "Files",
                  "validinfo_Files": "Incorrect file format",
                  "placeholder_Files": "No files choosen",
                  "button_CreateLibRequest": "Create library request",
                  "alert_success_CreateLibRequest": "The library request was created correctly.",
                  "alert_error_CreateLibRequest": "Library request was not created correctly. Error",
                  "modal_PushRequest": {
                    "modal_Title": "Pushed files",
                    "infotext_1": "List of pushed files",
                    "infotext_2": "No files were pushed",
                    "infotext_3": "As a result of the file push operation, a new revision was created",
                    "table_header_Name": "Filename",
                    "table_header_Status": "Status",
                    "table_header_Dependency": "Dependency",
                    "table_header_Description": "Description",
                    "placeholder_Search": "Search",
                  },
                }

              },
              "modal_Libraries":{
                "modal_Title": "Libraries",
                "infotext_1": "You can search and select library from the table below",
                "table_Libraries":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",


              },
              "modal_AltSymbols":{
                "modal_Title": "ALT_SYMBOLS",
                "infotext_1": "You can search and select library from the table below",
                "table_AltSymbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_AddTop": "Add to Top",
                  "button_AddBottom": "Add to Bottom",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new library",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The library name must not be empty.",
                "alert_success_create_footprint": "A new library has been created",
                "alert_error_create_footprint": "A new library has not been created",


              },
            }

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Save": "Create new",
          "alert_success_new_part": "The new part has been created.",
          "alert_error_new_part_required": "Fields marked as Request must not be empty.",
          "alert_error_new_part": "The new part has not been created. Error",

        },
        "Right": {
          "Content": {


          },
          "button_Hide": "Hide"
        }
      },

      "PartSearch": {
        "Left": {
          "Content": {
            "tab_SearchHistory": "Search history",

            "SearchHistoryTable":{
              "infotext_1": "List of part searches",
              "table_header_Date": "Date",
              "table_header_String": "String",
              "table_header_Supplier": "Supplier",
              "placeholder_Search": "Search"
            },
            "tab_CreatedByUser": "Created by user",
            "infotext_1": "User defined MPN"
          },
          "button_Hide": "Hide",
          "button_Categories": "Categories",



        },
        "Middle": {
          "Content": {
            "tab_SearchedParts": "Searched parts",

            "SearchedParts":{
              "placeholder_Search": "Search",
              "infotext_1": "Selected generic part",
              "infotext_2": "List of parts found",
              "infotext_3": "Not selected",
              "export_label_top": "Searched parts"
            },
            "tab_CreatedByUser": "Created by user",
            "CreatedByUser": {
              "placeholder_Search": "Search",
              "infotext_1": "Selected generic part",
              "infotext_2": "List of parts created by user",
              "infotext_3": "Not selected",
            },
            "tab_UsedMPNs": "Used MPNs",
            "UsedMPNs": {
              "placeholder_Search": "Search",
              "infotext_1": "MPNs used in generic parts",
            }

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Up": "Up",
          "button_Derive": "Derive",
          "button_Alternative": "Assign as MPN",
          "button_AddPhysical": "Add MPN",
          "button_EditPhysical": "Edit MPN",
          "button_DeletePhysical": "Delete MPN",
          "button_CreateRequest": "Create request",
          "modal_CreateRequest": {
            "modal_Title": "New request",
            "infotext_1": "Fill out the new part request form",
            "label_Manufacturer": "Manufacturer",
            "validinfo_Manufacturer": "The Manufacturer name must not be empty.",
            "label_ManufacturerPartNumber": "ManufacturerPartNumber",
            "validinfo_ManufacturerPartNumber": "The ManufacturerPartNumber name must not be empty.",
            "label_Remarks": "Remarks",
            "validinfo_Remarks": "The Remarks name must not be empty.",
            "label_Priority": "Priority",
            "label_Deadline": "Deadline",
            "validinfo_Deadline": "Deadline may not be in the past.",
            "label_Files": "Files",
            "validinfo_Files": "Incorrect file format",
            "placeholder_Files": "No files choosen",
          },
          "modal_PushRequest": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Dependency": "Dependency",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "alerttitle_DeletePhysical": "Are you sure?",
          "modal_title_DeletePhysical": "Delete",
          "alert_Title": "Warning",
          "alert_Text": "The generic part has not been selected.",
          "alert_success_setAlternative": "MPN has been assigned.",
          "alert_error_setAlternative": "MPN has not assigned.",
          "alert_success_deletePhysicalPart": "MPN was deleted correctly.",
          "alert_error_deletePhysicalPart": "MPN was not deleted correctly. Error",
          "modal_title_displayConnectToSEAlert": "Linking MPN with SE",
          "alert_displayConnectToSEAlert": "Do you want to download additional data from Silicon Expert for this MPN? Consent may charge your SE account.",
        },
        "Right": {
          "Content": {
            "tab_Search": "External Search",
            "tab_Details": "Part details",
            "tab_SelectedPart": "Selected generic part",
            "infotext_1": "Select one element in the middle panel to display details data.",
            "infotext_2": "There is no selected generic part.",
            "infotext_3": "Selected generic part",

            "tab_WhereUsedPhysicals": "Where used",
            "Search":{
              "button_Search": "Search",
              "button_Reset": "Reset",
              "input_placeholder": "Search",
              "loader_Search": "Searching",
              "infotext_1": "No defined search engines",
              "infotext_2": "Search from third-party suppliers",
              "searchError": "The search failed. Please try again.",
              "alert_error_Searching": "Searching error"
            },
            "PropertiesDetails":{
              "infotext_1": "List of properties",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
            },
            "PriceDetails":{
              "infotext_1": "Prices",
              "table_header_MinQuantity": "Min Quantity",
              "table_header_Price": "Price",
              "table_header_Currency": "Currency",
              "placeholder_Search": "Search",
            },
            "AvailabilityDetails":{
                "infotext_1": "Availability of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
            },
            "SEDetails":{
              "infotext_1": "SiliconExpert details",
              "infotext_2": "Data from SiliconExpert not matched to MPN",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
              "modal_SERisk": {
                "modal_Title": "SiliconExpert Details",
                "infotext_1": "MPN",
                "infotext_2": "Manufacturer name"
              },
            "button_label_Details": "Details",
            "button_label_GetDataFromSE": "Get data from SE",
            "button_label_SE_sync": "SE Sync",
            "button_label_SE_RiskDetails": "Risk details",
            "button_label_SyncPartSE": "Sync SE data",
            "button_label_SE_unassign": "Unassign SE data",
            "modal_title_unassignSEData": "Unassign SE data",
            "alert_unassignSEData": "Are you sure?",
            "alert_success_unassignSEData": "SE data has been unassigned",
            "alert_error_unassignSEData": "SE data has not been unassigned. Error",
            "alert_success_SyncSEData": "SE data has been synchronized",
            "alert_error_SyncSEData": "SE data has not been synchronized. Error",
            "modal_title_displayConnectToSEAlert": "Linking MPN with SE",
            "alert_displayConnectToSEAlert": "Do you want to download additional data from Silicon Expert for this MPN? Consent may charge your SE account.",
            "TreeSE": {
              "placeholder_Search": "Search",
            },
            "modal_SESuggestions": {
                "modal_Title": "SiliconExpert Parts",
                "OverallDetails": {
                  "infotext_1": "Overall properties of the MPN",
                  "table_header_Name": "Name",
                  "table_header_Value": "Value",
                  "placeholder_Search": "Search",
                },
                "PropertiesDetails":{
                  "infotext_1": "Technical properties of the MPN",
                  "table_header_Name": "Name",
                  "table_header_Value": "Value",
                  "placeholder_Search": "Search",
                },
                "SEPropertiesChoose": {
                  "infotext_1": "SiliconExpert details data",
                  "infotext_2": "Select one SE part and link it to the MPN part",
                  "table_header_Name": "Name",
                  "table_header_Value": "Value",
                  "placeholder_Search": "Search",
                },
              },
              "alert_success_AssignPartSEToMPN": "PartSE has been assigned to MPN.",
              "alert_error_AssignPartSEToMPN": "PartSE has not been assigned to MPN. Error",
            },
            "SelectedPart":{
              "infotext_1": "List of properties",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
              "infotext_2": "List of parts in the assembly",
              "table_header_PartNumber": "PartNumber",
              "table_header_Revision": "Revision",
              "table_header_Quantity": "Quantity",
            },
            "QuickView": {
              "infotext_1": "List of properties for",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "infotext_2": "List of parts in the assembly",
              "placeholder_Search": "Search",
              "button_CreateSvg": "Create image",
              "alert_success_create_image": "The image was created correctly",
              "alert_error_create_image": "The image was not created correctly",
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },
              "label_pinSwitch": "Pin switch",
              "label_Properties": "Properties"
            },
            "WhereUsedPhysicals": {
              "infotext_1": "List of parts",
              "table_header_PartNumber": "Part number",
              "table_header_Revision": "Revision",
              "table_header_Status": "Status",
              "placeholder_Search": "Search",
            },
            "label_Manual": "Additional parameters",
            "label_EndOfLife": "End of Life date",
            "label_EndOfSale": "End of Sale date",
            "label_OverallRisk": "OverallRisk",
            "label_LifeCycleRiskGrade": "LifeCycleRiskGrade",
            "label_RohsRisk": "RohsRisk",
            "label_RoHSVersion": "RoHSVersion",
            "label_ChinaRoHSStatus": "ChinaRoHSStatus",
            "label_LifecycleRisk": "LifecycleRisk",
            "label_PartStatus": "PartStatus",
            "label_EstimatedYearsToEOL": "EstimatedYearsToEOL",
            "label_MultiSourcingRisk": "MultiSourcingRisk",
            "label_Comment": "Comment",
            "button_Update": "Update",
            "alert_success_updateAlternative": "The parameters have been saved correctly",
            "alert_error_updateAlternative": "Parameters were not saved correctly"
          },
          "button_Hide": "Hide"
        }
      },

      "Categories": {
        "Left": {
          "Content": {


          },
          "button_Hide": "Hide"
        },
        "Middle": {
          "Content": {
            "tab_Categories": "Categories",
            "placeholder_Create": "Enter new category name",
            "placeholder_Template": "Enter Part Number template",
            "button_Create": "Create",
            "button_Update": "Update",
            "validinfo_1": "The category name must not be empty.",
            "alert_success_create_category": "Category has been created.",
            "alert_error_create_category": "Category hasn't been created. Error",
            "alert_success_update_category": "Category has been updated.",
            "alert_error_update_category": "Category hasn't been updated. Error",
            "infotext_1": "Category image",
            "infotext_2": "Select a category in the tree and enter a new category name",
            "infotext_3": "Select an image for a category",
            "infotext_4": "Select a new category image",
            "infotext_5": "A new category will be created for the parent category",
            "infotext_6": "Set template for Part Number property",
            "infotext_7": "How should you complete the Part Number template?",
            "infotext_8": "letters taken from the category name",
            "infotext_9": "e.g:",
            "infotext_10": "means taking the first three letters of the category to build the Part Number value",
            "infotext_11": "number generated on the given number of items ",
            "infotext_12": "means the number generated on three positions from 001 to 999",
            "infotext_13": "Compability mode",
            "checkbox_rule4eye": "Turn off the 4 eye rule for this category",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",

              "TreeItem": {
                "button_Delete": "Delete",
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
                "alerttitle_Delete": "Delete",
                "alertinfo_1": "Are you sure?",
                "alertinfo_2": "This category contains ",
                "alertinfo_3": "If a category contains any items, it cannot be deleted.",
                "alertinfo_4": "If a category contains any items, it cannot be deleted.",
                "alertinfo_5": "If a category contains any items, it cannot be deleted.",

              }

            }
          },
          "button_Back": "Back",


        },
        "Right": {
          "Content": {

          },
          "button_Hide": "Hide"
        }
      },
      "Properties": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }
          },
          "button_Hide": "Hide",

        },
        "Middle": {
          "Content": {
            "tab_Properties": "Properties",
            "infotext_1": "Properties for the category",
            "infotext_2": "Explanation",
            "infotext_3": {
              "own": "properties created for the selected category",
              "descendant": "properties created for the descendant of the selected category",
              "ancestor": "properties created for the ancestor of the selected category",
            },

            "tab_CIS": "CIS export",
            "infotext_4": "CIS export",
            "button_DownloadCIS": "Download CIS file",
            "PropertyForm": {
              "table_header_Priority": "Priority",
              "table_header_Origins": "Origins",
              "table_header_Name": "Property name",
              "table_header_Type": "Property type",
              "table_header_Request": "Required On Request",
              "table_header_Release": "Required On Release",
              "table_header_Revision": "Revision Changing",
              "table_header_CISDesignation": "CIS Settings",
              "table_header_CISBrowsable": "CIS Browsable",
              "table_header_HDLDesignation": "HDL Settings",
              "table_header_MaxLength": "Max length",
              "table_header_LibraryCategoryId": "Category of library",
              "table_header_SearchString": "Selected to search string",
              "table_header_Non_derivable": "Non-derivable",
              "table_header_DisplayInBom": "Display In BOM",
              "table_header_Actions": "Actions",
              "button_Delete": "Delete",
              "alert_success_Delete": "Property has been deleted",
              "alert_error_Delete": "Property has not been deleted",
              "alert_success_ChangePriority": "Property changed priority correctly.",
              "alert_error_ChangePriority": "Property did not change priority correctly.",
              "alert_Title": "Deleting property",
              "alert_Text": "Are you sure?",
              "alert_Text_Special": "This property is important for the proper working of the application. Are you sure?",
              "CISDesignationTypes": [
                "Not Exposed", "Exposed to Tables", "Transferred to Design", "Force Displayed", "Force Hidden"
              ],
              "HDLDesignationTypes": [
                "Key", "Injected", "KeyAndInjected", "Cell", "Ignored"
              ]
            }
          },
          "button_Back": "Back",
          "button_New": "New",
          "button_Save": "Save",
          "button_ExportCis": "Export CIS",
          "button_ExportHDL": "Export HDL",
          "button_Delete": "Delete",
          "alert_success_Update": "Changes have been saved",
          "alert_error_Update": "Changes have not been saved",
          "alert_success_NewProperty": "The new property was created correctly",
          "alert_error_NewProperty": "New property was not created correctly. Error",
          "alert_success_CIS": "The data was downloaded correctly",
          "alert_error_CIS": "Data was not downloaded correctly",
          "alert_success_HDL": "The data was downloaded correctly",
          "alert_error_HDL": "Data was not downloaded correctly",
          "alert_error_DuplicateProperty": "You cannot set duplicate reserved properties",
          "alert_error_NoPartNumber": "There must be exactly one property of type 'part number'.",
          "alert_error_NoValue": "There must be exactly one property of type 'value'.",
          "alert_error_NoType": "There must be exactly one property of type 'type'.",
          "alert_error_NoProperties": "There are no properties",
          "alert_error_NotExposeAndBrowsable": "If CIS Settings is 'Not Exposed' then CIS Browsable cannot be selected",
          "modal_NewProperty": {
            "modal_Title": "Create new property",
            "label_Name": "Property name",
            "placeholder_Name": "Enter name",
            "validinfo_1": "Enter name",
            "label_Type": "Type of property",
            "validinfo_2": "Choose type",
            "option_Empty": "Choose...",
            "label_Request": "Required On Request",
            "label_Release": "Required On Release",
            "label_Revision": "Revision Changing",
            "label_SearchString": "The property will be used to external search",
            "label_Non_derivable": "Non-derivable",
            "label_DisplayInBom": "Display In Bom",
            "label_CisConfiguration": "CIS configuration",
            "label_CisDesignation": "CIS Settings",
            "label_CisBrowsable": "CIS Browsable",
            "label_CategoryLibrary": "Category of library",
            "validinfo_3": "Choose category of library",
            "CISDesignationTypes": [
              "Not Exposed", "Exposed to Tables", "Transferred to Design", "Force Displayed", "Force Hidden"
            ],
            "validinfo_4": "Choose CIS Settings",
            "label_HDLDesignation": "HDL Settings",
            "HDLDesignationTypes": [
                "Key", "Injected", "KeyAndInjected", "Cell", "Ignored"
            ],
            "validinfo_5": "Choose HDL Settings",
            "button_OK": "OK",
            "button_Cancel": "Cancel"
          }

        },
        "Right": {
          "Content": {

          },
          "button_Hide": "Hide"
        }
      },
      "PartImport": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }
          },
          "button_Hide": "Hide"

        },
        "Middle": {
          "Content": {
            "tab_Import": "Import parts - type A",
            "label_description_A0": "Generic purpose importing parts",
            "label_description_A1": "into a specific category",
            "label_description_A2": "mapping columns from a file to specific part properties",
            "infotext_4": "If you import parts to this category, it will not be visible in CIS Explorer",
            "infotext_6": "You can't import parts into the All components category",
            "label_file": "Upload a CSV format file containing parts",
            "placeholder_file": "Choose a file or drop it here...",
            "button_Upload": "Upload",
            "infotext_1": "The parts will be imported into the category",
            "infotext_notImportedParts": "List of parts that have not been imported",
            "label_AllActive": "All imported parts will become active immediately",
            "infotext_Bottom": "If the import file contains very many records, only the first 25 are displayed.",
            "label_Type": "Type",
            "label_Delimiter": "Delimiter",
            "TableMapping":{

            },
            "tab_PartTypeImport": "Import parts - type B",
            "label_description_B0": "Importing parts recomended for Orcad",
            "label_description_B1": "to a specific category with the ability to create new subcategories based on the PartType column",
            "label_description_B2": "mapping columns from a file to part property types",
            "label_description_B3": "Enter subcategory",

            "tab_MixImport": "Import parts - type C",
            "label_description_C0": "Importing parts",
            "label_description_C1": "part category is specified from the indicated PartType column. If there is no such category, a new one is created",
            "label_description_C2": "mapping columns from a file to specific part properties",
            "label_description_C3": "only properties of the All components category can be used for mapping.",
            "infotext_5": "Parts will be imported into the category defined by mapping to PartType",
            "tab_ImportHistory": "Import history",
            "infotext_3": "List of historical imports",
            "TableImportHistory":{
              "placeholder_Search": "Search",
              "table_header_When": "Date",
              "table_header_Category": "Category",
              "table_header_Quantity": "Quantity",
              "table_header_Action": "Action",
              "button_Undo": "Undo",
              "alert_success_undo_imported": "Part import has been cancelled correctly",
              "alert_error_undo_imported": "Part import has not been cancelled correctly"
            },

            "alert_error_importParts": "CSV file was not parsed correctly. Error",
            "alert_success_importParts": "CSV file was parsed correctly",

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Import": "Import parts",
          "button_ImportByPartType": "Import parts",
          "button_ImportMix": "Import parts",
          "alert_success_import": "Import of parts successfully completed.",
          "alert_error_import": "Import of parts failed",
          "alert_error_import2": "Some parts were not imported. Check the list.",
          "title_import": "Importing parts",
          "alert_error_DoubleTypes": "Cannot assign the same types to different columns of an imported file.",
          "alert_error_duplicatePropertyid": "Each column from the file can be mapped to only one property.",
        },
        "Right": {
          "Content": {


          },

        }
      },
      "PartAssembly": {
        "Left": {
          "Content": {

          },

        },
        "Middle": {
          "Content": {
            "tab_NewAssembly": "Creating assembly",
            "infotext_1": "Create a new assembly item for",
            "tab_AssignAssembly": "Assigning assembly",
            "infotext_2": "Assigning part",
            "infotext_3": "to assembly item",
            "label_PartNumber": "Part Number",
            "label_Quantity": "Quantity",
            "validinfo_PartNumber": "Enter Part Number for assembly",
            "placeholder_PartNumber": "Enter Part Number for assembly",
            "AssemblyTable": {
              "placeholder_Search": "Search",
              "table_header_When": "Date",
              "table_header_PartNumber": "Part Number",
              "table_header_Revision": "Revision",
              "table_header_ElectricalPartNumber": "Part Number of electric part",
            }
          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_NewAssembly": "Create assembly",

          "alert_success_CreateAssembly": "A new assembly has been created.",
          "alert_error_CreateAssembly": "New assembly has not been created",
          "button_AssignAssembly": "Assign part",
          "alert_success_AssignAssembly": "The part has been assigned to assembly.",
          "alert_error_AssignAssembly": "Item has not been assigned to the assembly",


        },
        "Right": {
          "Content": {


          },

        }
      },
      "PartPhysicals": {
        "Left": {
          "Content": {

          },

        },
        "Middle": {
          "Content": {
            "tab_NewPhysical": "Creating MPN",
            "InfoElement": {
              "infotext_1": "Create a new MPN for",
              "infotext_2": "Category",
            },
            "FormPhysical": {
              "placeholder_Search": "Search",
              "infotext_1": "Main information about MPN",
              "main_table_header_Name": "Name",
              "main_table_header_Value": "Value",

              "table_main_distributorName": "Distributor Name",
              "table_main_informationSource": "Information Source",
              "table_main_distributorPartNumber": "Distributor PN",
              "table_main_distributorKey": "Distributor Key",
              "table_main_manufacturerName": "Manufacturer Name",
              "table_main_manufacturerPN": "Manufacturer PN",
              "table_main_availableQuantity": "Available Quantity",
              "table_main_leadDays": "Lead Days",
              "table_main_rohs": "ROHS",
              "table_main_dtasheetUrl": "Datasheet Url",
              "table_main_description": "Description",
              "table_main_imageUrl": "Image Url",
              "table_main_productDetailUrl": "Product Detail Url",
              "table_main_leadDays": "Lead days",
              "table_main_lifecycleStatus": "Lifecycle status",
              "table_main_EOL": "EOL",
              "table_main_EOS": "EOS",
              "table_main_TempMin": "TempMin",
              "table_main_TempMax": "TempMax",


              "infotext_2": "Properties",
              "properties_table_header_Name": "Name",
              "properties_table_header_Value": "Value",
              "properties_table_header_Action": "Action",
              "properties_table_button_Delete": "Delete",

              "infotext_3": "Prices",
              "price_table_header_MinQuantity": "MinQuantity",
              "price_table_header_Price": "Price",
              "price_table_header_Action": "Action",
              "price_table_header_Currency": "Currency",
              "price_table_button_Delete": "Delete",

              "infotext_4": "Additional data",
              "table_label_EOL": "End of Life date",
              "table_label_EOS": "End of Sale date",
              "table_label_OverallRisk": "OverallRisk",
              "table_label_LifeCycleRiskGrade": "LifeCycleRiskGrade ",
              "table_label_RohsRisk": "RohsRisk",
              "table_label_RoHSVersion": "RohsVersion",
              "table_label_ChinaRoHSStatus": "ChinaRoHSStatus",
              "table_label_LifecycleRisk": "LifecycleRisk",
              "table_label_PartStatus": "PartStatus ",
              "table_label_EstimatedYearsToEOL": "EstimatedYearsToEOL",
              "table_label_MultiSourcingRisk": "MultiSourcingRisk",
              "table_label_Comment": "Comment"
            }


          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_NewPhysical": "Create MPN",
          "button_UpdatePhysical": "Save",

          "alert_success_CreatePhysical": "A new MPN has been created.",
          "alert_error_CreatePhysical": "A new MPN has not been created. Error",

          "alert_success_UpdatePhysical": "A MPN has been updated.",
          "alert_error_UpdatePhysical": "A MPN has not been updated. Error",

          "alert_error_NumberValidation": "Values must be numbers",

        },
        "Right": {
          "Content": {


          },

        }
      },
      "UL": {
        "Left": {
          "Content": {
            "tab_Search": "Search",

          },
          "button_Hide": "Hide"
        },
        "Middle": {
          "Content": {
            "tab_Parts": "Parts",


          },
          "button_Back": "Back",


        },
        "Right": {
          "Content": {

          },
          "button_Hide": "Hide"
        }
      },
    },
    "LibraryManager": {
      "LibraryTable": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "alert_success_create_category": "Category has been created.",
            "alert_error_create_category": "Category hasn't been created.",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }
          },
          "button_Hide": "Hide",
          "button_Categories": "Categories",

        },
        "Middle": {
          "Content": {
            "tab_Parts": "Libraries",
            "infotext_1": "Filters",
            "infotext_2": "Categories",
            "LibraryTable": {
              "infotext_2": "List of libraries",
              "header_Image": "Image",
              "header_Name": "Name",
              "header_Status": "Status",
              "header_Revision": "Revision",
              "header_LibraryType": "Library type",
              "header_LibraryCategory": "Category",
              "header_LibraryLogin": "Creator",
              "header_LibraryDate": "Date",
              "status_Used": "used",
              "status_Alternative": "no MPN",
              "status_Assembly": "assembly",
              "contextmenu_text_Details": "Details",
              "contextmenu_text_Derive": "Derive",
              "contextmenu_text_Withdraw": "Withdraw",
              "contextmenu_text_Place": "Place",
              "export_label_top": "Libraries from"
            },
            "Filters": {
              "placeholder": "Add filters"
            },
            "FiltersButtons": {
              "infotext_1": "Applied"
            },
            "PluginCategory": {
              "placeholder_Categories": "Choose category"
            },


          },
          "button_New": "New",
          "button_Details": "Details",
          "button_Derive": "Derive",
          "button_Withdraw": "Withdraw",
          "button_Delete": "Delete",
          "button_RemoveRevision": "Remove revision",
          "button_MoveTo": "Move",
          "button_Properties": "Properties",
          "button_Push": "Push",
          "button_Open": "Open",
          "button_DownloadZIP": "Offline",
          "button_Import": "Import/Export",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "alert_withdraw": "Are you sure you want to withdraw selected items from use?",
          "alert_delete": "Are you sure?",
          "alert_removeRevision": "Only the latest revision will be removed. Are you sure?",
          "alert_success_withdraw": "The library has been withdrawn",
          "alert_error_withdraw": "The library has not been withdrawn. Error",
          "alert_success_create_image": "The image was created correctly",
          "alert_error_create_image": "The image was not created correctly",

          "alert_success_delete_library": "The library was deleted correctly",
          "alert_error_delete_library": "The library has not been deleted correctly. Error",
          "modal_title_delete": "Deleting",
          "alert_success_removeRevision_library": "The revision of library was removed correctly",
          "alert_error_removeRevision_library": "The revision of library was not removed correctly. Error",
          "modal_title_removeRevision": "Removing revision",
          "modal_PushLibrary": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Dependency": "Dependency",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "alert_openLibrary_1": "Local library files have been detected",
          "alert_openLibrary_2": "Do you want to overwrite the local files with the remote content, or keep working with the local content?",
          "alert_title_openLibrary": "Opening the library",
          "alert_error_PushLibrary": "Library push failed. Error",
          "alert_error_OpenLibrary": "Opening libraries has failed. Error",
          "alert_error_CheckLibrary": "There was a problem accessing local libraries",
          "alert_success_OpenLibrary": "The library was opened to",
          "modal_Moving": {
              "modal_Title": "Moving library to another category",
              "label_Categories": "Please select a target category",

              "infotext_1": "You can safely move a library to the category of your choice",
              "infotext_2": "Moving a library to a selected category will lose the following properties",

              "table_header_PartNumber": "Part number",
              "table_header_LibraryNumber": "Library number",
              "table_header_ProjectNumber": "Project number",
              "table_header_Name": "Name of property",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",

          },
          "alert_success_MoveLibrary": "The library has been moved to another category correctly",
          "alert_error_MoveLibrary": "The library has not been moved to another category correctly",
          "alert_error_MoveLibraryCategory": "Select a target category",
          "modal_title_BulkFeedback": "Feedback reports",
          "modal_button_Close": "Close",
          "modal_BulkFeedback": {
            "modal_Title": "Feedback reports",
            "infotext_1": "The operation was not performed correctly for the following items",
            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Message": "Message",
            "table_header_Status": "Status",
            "placeholder_Search": "Search",

            "button_Close": "Close"
          }
        },
        "Right": {
          "Content": {
            "tab_QuickView": "Quick view",
            "infotext_1": "Select one element in the middle panel to display details data.",
            "tab_Tasks": "Tasks",
            "infotext_2": "Select one element in the middle panel to display tasks of library.",
            "tab_Search": "External Search",
            "tab_WhereUse": "Where used",
            "infotext_3": "Select one element in the middle panel to display report on the library.",
            "tab_Pins": "Pins",
            "infotext_4": "No content for an element of this type.",

            "QuickView": {
              "infotext_1": "List of properties for",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
              "infotext_2": "List of parts in the assembly",
              "button_CreateSvg": "Create image",
              "alert_success_create_image": "The image was created correctly",
              "alert_error_create_image": "The image was not created correctly",
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },
              "label_pinSwitch": "Pin switch",
              "label_Properties": "Properties"
            },
            "LibraryFiles": {
              "infotext_1": "List of files",
              "table_header_Name": "Name",
              "table_header_Size": "Size",
              "table_header_Created": "Created",
              "table_header_Action": "Action",
              "placeholder_Search": "Search",
              "table_button_Download": "Download"


            },
            "LibraryHDLFiles": {
              "infotext_1": "Files tree",

                "FolderTreeItemHDL": {
                  "button_CreateSubfolder": "Create subfolder",
                  "button_ImportFile": "Import file",
                  "button_Delete": "Delete",
                  "button_Download": "Download",
                  "button_Delegate": "Delegate",
                  "button_UndoDelegate": "Cancel delegation",
                  "button_ConfirmResource": "Commit",
                  "button_RejectDelegate": "Reject delegate",
                  "button_SetAsVariant": "Set variant",
                  "button_SetAsBomCore": "Set BOM Core",
                  "button_RemoveAsVariant": "Remove variant",
                  "alert_success_delete_item": "Resource has been deleted.",
                  "alert_error_delete_item": "Resource hasn't been deleted.",

                  "alerttitle_Delete": "Deleting",
                  "alertinfo_1": "Are you sure?",
                  "alertinfo_2": "This folder contains files (",
                  "alertinfo_3": "). If you delete this folder the files will be deleted too. Do you want to continue?",
                  "alerttitle_RemoveVariant": "Removing variant marker",
                  "modal_CreateFolder": {
                    "modal_Title": "Creating new folder",

                    "label_Name": "Name",
                    "placeholder_Name": "Enter Name",
                    "validinfo_Name": "Enter name without \\ / : * ? \" < > |",
                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },
                  "modal_ImportFile": {
                    "modal_Title": "Importing file",

                    "label_File": "File",
                    "placeholder_File": "Choose a file or drop it here...",

                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },


                  "alert_success_import_file": "The file was loaded successfully",
                  "alert_error_import_file": "File did not load correctly. Error",
                  "alert_success_create_folder": "The folder was created correctly",
                  "alert_error_create_folder": "Folder was not created correctly. Error",
                  "alert_error_create_folder_no_name": "The folder must have a name.",
                  "alert_success_download_file": "The file downloaded successfully",
                  "alert_error_download_file": "File did not download correctly. Error",
                  "alert_success_create_variant": "The variant was created correctly",
                  "alert_error_create_variant": "Variant not created correctly. Error",
                  "alert_error_create_variant_no_name": "The variant must have a name.",
                  "alert_success_remove_variant": "The variant was removed correctly.",
                  "alert_error_remove_variant": "Variant was not removed correctly. Error",
                  "alert_success_delete_folder": "The folder was deleted correctly",
                  "alert_error_delete_folder": "Folder was not deleted correctly. Error",
                  "alert_success_delete_file": "The file was created correctly",
                  "alert_error_delete_file": "File was not created correctly. Error",



                }
            },
            "Tasks": {
              "infotext_1": "This library has tasks",
              "infotext_2": "This library has no tasks.",
              "infotext_3": "Select pending revision in the table on the left panel.",
              "infotext_4": "To manage the tasks for this item, go to request.",
              "button_Approve": "Approve",
              "button_Reject": "Reject",
              "label_Reason": "Reason for rejection",
              "label_Comment": "Comment for task",
              "label_Transfer": "Transfer ownership",
              "label_Name": "Task name",
              "label_Level1": "1st level",
              "label_Level2": "2nd level",
              "decription": "Approve or reject the task",
              "alert_error_approve1": "Field",
              "alert_error_approve2": "must be completed before release. Check completeness in Details.",
              "alert_success_approve": "The approval was successful",
              "alert_error_approve": "The approval was not successful",
              "modal_Reason": {
                "placeholder_Reason": "Enter a reason",
                "label_Reason": "Reason for rejection",
                "modal_Title": "Rejection"
              },
              "modal_EventTaskForm":{
                "placeholder_Reason": "Enter a comment",
                "label_Reason": "Comment",
                "modal_Title": "Approving process",
                "label_ChangeRevision": "A change in this library should cause a change in the revision of dependent parts",
                "label_Users": "If you want, select a 2nd level user"
              },
              "modal_EventTaskFormValidation":{
                "modal_Title": "Validation process",
                "infotext_1": "Approval is not possible.",
                "infotext_2": "List of libraries that have been used and may not be complete",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "modal_EventTaskDependencyInfo":{
                "modal_Title": "Dependency info",
                "infotext_1": "List of libraries that are used in",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "DetailsHistory": {
                "infotext_1": "Select the revision in the table on the left panel",
                "infotext_2": "Comments in revision",
                "infotext_3": "No comments",
                "label_Reason": "Rejected",
                "label_Comment": "Approved with comment",
                "label_WithoutComment": "Approved without comment",
                "label_Transfer": "Transfer ownership",
                "label_Assign": "Assigned MPN",
                "label_Unassign": "Unassigned MPN",
                "label_Move": "Category changed"
              },
            },

            "WhereUse": {
              "infotext_1": "Usage report in projects",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_Variant": "Variant",
              "table_header_Quantity": "Quantity",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },

            "WhereLibUsed": {
              "infotext_1": "Usage report in elements",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "WhatIsIncluded": {
              "infotext_1": "Depends on",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "PinsTable":{
              "infotext_1": "Table of pins",
              "infotext_2": "No pins for this type of library.",
              "table_header_Number": "Number",
              "table_header_Name": "Name",
              "table_header_Padstack": "Padstack",
              "table_header_Type": "Type",
              "placeholder_Search": "Search",

            },

          },
          "button_Hide": "Hide"
        }
      },
      "LibraryDerive": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }

          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_NewLibrary": "New library",
            "DeriveLibraryForm":{
              "infotext_1": "Fill out the form to create a new library element for category",
              "infotext_2": "This property is required to create a new part.",
              "infotext_3": "Unable to create an new library element in the 'All libraries' category",
              "infotext_4": "The renamed library files will be copied to the new library.",
              "infotext_5": "Unable to create an new library element in the 2nd level category",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

            },

            "CreatePropertiesForm": {
              "infotext_1": "Select the parameters that will be used to create new properties",
              "placeholder_Search": "Search",
              "table_header_Name": "New name of property",
              "table_header_Type": "Type of property",
              "table_header_Value": "Property value",
              "table_header_Found": "Property name and value from found",

              "button_Delete": "Delete"
            }

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Save": "Save as new",
          "alert_success_derive": "The library has been derived.",
          "alert_error_derive": "The library has not been derived. Error",
          "alert_error_new_library_required": "Fields marked as Request must not be empty.",
          "alert_error_new_props": "The new properties have not been added. Error",

        },
        "Right": {
          "Content": {


          },
          "button_Hide": "Hide"
        }
      },

      "LibraryDetails": {
        "Left": {
          "Content": {
            "tab_Revisions": "Revision history",
            "InfoElement": {
              "infotext_1": "List of revisions for",
              "infotext_2": "Category",
            },
            "RevisionsTable": {
              "table_header_Expand": "Exp",
              "table_header_Select": "Select",
              "table_header_Revision": "Revision",
              "table_header_Status": "Status",
              "table_header_Date": "When",
              "table_header_User": "Who",
              "table_header_RequestDate": "Request",
              "table_header_RequestLogin": "Request",
              "table_header_Date1": "Level 1",
              "table_header_Login1": "Level 1",
              "table_header_Date2": "Level 2",
              "table_header_Login2": "Level 2",
              "placeholder_Search": "Search"
            },
            "tab_Diagram": "Diagram",
            "RevisionsDiagram":{

            }


          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_Details": "Library details",
            "infotext_1": "List of library properties",

            "LibraryDetails":{

              "table_header_Name": "Name",
              "table_header_Value": "Values for revision",
              "placeholder_Search": "Search",
              "infotext_1": "Select the revision in the table on the left panel",
              "infotext_2": "Load library files",
              "filesPlaceholder": "Choose a library files or drop them here...",
              "infotext_Request": "This property is required to save a library.",
              "infotext_Release": "This property is required to approve a library.",
              "infotext_Revision": "Changing this property will change the revision after saving.",
              "table_subheader": "Revision",
              "table_button_Download": "Download",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "button_DeleteFile": "Delete",
              "alert_Title_deleteFile": "Deleting file",
              "alert_deleteFile": "Are you sure?",
              "alert_success_DeleteFile": "The file was deleted correctly",
              "alert_error_DeleteFile": "The file was not deleted correctly. Error",
              "modal_Footprints":{
                "modal_Title": "Footprints",
                "infotext_1": "You can search and select footprint from the table below",
                "table_Footprints":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new footprint",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The footprint name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",

              },
              "modal_Symbols":{
                "modal_Title": "Symbols",
                "modal_TitleHDL": "HDL symbols",
                "modal_TitleSymbols": "Symbols",
                "infotext_1": "You can search and add symbols from the table below",
                "table_Symbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Add": "Add",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new symbol",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The symbol name must not be empty.",
                "alert_success_create_symbol": "A new symbol has been created",
                "alert_error_create_symbol": "A new symbol has not been created",
              },
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },
              "FolderTree": {
                "infotext_1": "Resource tree:",

                "FolderTreeItem": {
                  "button_CreateSubfolder": "Create subfolder",
                  "button_ImportFile": "Import file",
                  "button_Delete": "Delete",
                  "button_Download": "Download",
                  "button_Delegate": "Delegate",
                  "button_UndoDelegate": "Cancel delegation",
                  "button_ConfirmResource": "Commit",
                  "button_RejectDelegate": "Reject delegate",
                  "button_SetAsVariant": "Set variant",
                  "button_SetAsBomCore": "Set BOM Core",
                  "button_RemoveAsVariant": "Remove variant",
                  "alert_success_delete_item": "Resource has been deleted.",
                  "alert_error_delete_item": "Resource hasn't been deleted.",

                  "alerttitle_Delete": "Deleting",
                  "alertinfo_1": "Are you sure?",
                  "alertinfo_2": "This folder contains files (",
                  "alertinfo_3": "). If you delete this folder the files will be deleted too. Do you want to continue?",
                  "alerttitle_RemoveVariant": "Removing variant marker",
                  "modal_CreateFolder": {
                    "modal_Title": "Creating new folder",

                    "label_Name": "Name",
                    "placeholder_Name": "Enter Name",
                    "validinfo_Name": "Enter name without \\ / : * ? \" < > |",
                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },
                  "modal_ImportFile": {
                    "modal_Title": "Importing file",

                    "label_File": "File",
                    "placeholder_File": "Choose a file or drop it here...",

                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },
                  "modal_SetAsVariant": {
                    "modal_Title": "Setting as variant",

                    "label_Name": "Name",
                    "placeholder_Name": "Enter Name",
                    "validinfo_Name": "Enter name without \\ / : * ? \" < > |",
                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },

                  "alert_success_import_file": "The file was loaded successfully",
                  "alert_error_import_file": "File did not load correctly. Error",
                  "alert_success_create_folder": "The folder was created correctly",
                  "alert_error_create_folder": "Folder was not created correctly. Error",
                  "alert_error_create_folder_no_name": "The folder must have a name.",
                  "alert_success_download_file": "The file downloaded successfully",
                  "alert_error_download_file": "File did not download correctly. Error",
                  "alert_success_create_variant": "The variant was created correctly",
                  "alert_error_create_variant": "Variant not created correctly. Error",
                  "alert_error_create_variant_no_name": "The variant must have a name.",
                  "alert_success_remove_variant": "The variant was removed correctly.",
                  "alert_error_remove_variant": "Variant was not removed correctly. Error",
                  "alert_success_delete_folder": "The folder was deleted correctly",
                  "alert_error_delete_folder": "Folder was not deleted correctly. Error",
                  "alert_success_delete_file": "The file was created correctly",
                  "alert_error_delete_file": "File was not created correctly. Error",
                  "modal_Delegation": {
                    "modal_Title": "Delegating a resource to another user",
                    "label_Users": "Users",
                    "placeholder_Users": "You can safely move a project to the category of your choice",

                  },
                  "modal_RejectDelegation": {
                    "modal_Title": "Rejecting delegate a resource",
                    "label_Reason": "Reason",
                    "placeholder_Reason": "Enter a reason",

                  },
                  "alert_error_DelegateUser": "The delegation of the resource was not correct. The user was not chosen.",
                  "alert_success_DelegateFolder": "The folder has been delegated to another user",
                  "alert_error_DelegateFolder": "The folder has not been delegated to another user correctly. Error",
                  "alert_success_DelegateFile": "The file has been delegated to another user",
                  "alert_error_DelegateFile": "The file has not been delegated to another user correctly. Error",

                  "title_UndoDelegate": "Undo delegate",
                  "infotext_UndoDelegate": "Are you sure you want to undo delegate this resource?",
                  "alert_success_UndoDelegateFolder": "Undoing the delegation was done correctly",
                  "alert_error_UndoDelegateFolder": "Undoing the delegation was not done correctly. Error",
                  "alert_success_UndoDelegateFile": "Undoing the delegation was done correctly",
                  "alert_error_UndoDelegateFile": "Undoing the delegation was not done correctly. Error",

                  "title_RejectDelegate": "Rejecting resource",
                  "infotext_RejectDelegate": "Are you sure you want to reject this resource?",
                  "alert_success_RejectDelegateFolder": "Rejection of delegation was done correctly",
                  "alert_error_RejectDelegateFolder": "Rejection of delegation not done correctly. Error",
                  "alert_success_RejectDelegateFile": "Rejection of delegation was done correctly",
                  "alert_error_RejectDelegateFile": "Rejection of delegation not done correctly. Error",

                  "title_CommitDelegate": "Commiting resource",
                  "infotext_CommitDelegate": "Are you sure you want to commit this resource?",
                  "alert_success_CommitDelegateFolder": "The resource was committed correctly",
                  "alert_error_CommitDelegateFolder": "The resource was not committed correctly. Error",
                  "alert_success_CommitDelegateFile": "The resource was committed correctly",
                  "alert_error_CommitDelegateFile": "The resource was not committed correctly. Error",
                }
              },
              "label_pinSwitch": "Pin switch",

            },
            "tab_History": "History",


            "DetailsHistory": {
              "infotext_1": "Select the revision in the table on the left panel",
              "infotext_2": "Comments in revision",
              "infotext_3": "No comments",
              "label_Reason": "Rejected",
              "label_Comment": "Approved with comment",
              "label_WithoutComment": "Approved without comment",
              "label_Transfer": "Transfer ownership",
              "label_Assign": "Assigned MPN",
              "label_Unassign": "Unassigned MPN",
              "label_Move": "Category changed"
            },

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Up": "Up",
          "button_Edit": "Edit",
          "button_Unedit": "Disable editing",
          "button_Save": "Save",
          "button_TransferOwnership": "Transfer ownership",
          "button_Push": "Push",
          "button_Open": "Open",
          "button_Derive": "Derive",
          "button_Withdraw": "Withdraw",
          "button_Delete": "Delete",
          "button_RemoveRevision": "Remove revision",
          "button_MoveTo": "Move",
          "button_GotoRequest": "Go to request",

          "alert_success_edit_library": "The properties of the library have been saved.",
          "alert_error_edit_library": "Library properties have not been saved. Error",
          "alert_error_edit_required": "Fields marked as Request must not be empty.",

          "alert_withdraw": "Are you sure you want to withdraw selected items from use?",
          "alert_success_withdraw": "The library has been withdrawn",
          "alert_error_withdraw": "The library has not been withdrawn. Error",
          "alert_success_delete_library": "The library was deleted correctly",
          "alert_error_delete_library": "The library has not been deleted correctly. Error",
          "modal_title_delete": "Deleting",
          "alert_success_removeRevision_library": "The revision of library was removed correctly",
          "alert_error_removeRevision_library": "The revision of library was not removed correctly. Error",
          "modal_title_removeRevision": "Removing revision",
          "alert_removeRevision": "Only the latest revision will be removed. Are you sure?",
          "alert_delete": "Are you sure?",
          "modal_Moving": {
            "modal_Title": "Moving library to another category",
            "label_Categories": "Please select a target category",

            "infotext_1": "You can safely move a library to the category of your choice",
            "infotext_2": "Moving a library to a selected category will lose the following properties",

            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Name": "Name of property",
            "table_header_Value": "Value",
            "placeholder_Search": "Search",

          },
          "alert_success_MoveLibrary": "The library has been moved to another category correctly",
          "alert_error_MoveLibrary": "The library has not been moved to another category correctly",
          "alert_error_MoveLibraryCategory": "Select a target category",
          "modal_title_BulkFeedback": "Feedback reports",
          "modal_button_Close": "Close",
          "modal_BulkFeedback": {
            "modal_Title": "Feedback reports",
            "infotext_1": "The operation was not performed correctly for the following items",
            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Message": "Message",
            "table_header_Status": "Status",
            "placeholder_Search": "Search",

            "button_Close": "Close"
          },
          "modal_PushLibrary": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Dependency": "Dependency",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "modal_buttonWaitAlert": "Problems occurred while pushing files",
          "alert_openLibrary_1": "Local library files have been detected",
          "alert_openLibrary_2": "Do you want to overwrite the local files with the remote content, or keep working with the local content?",
          "alert_title_openLibrary": "Opening the library",
          "alert_error_PushLibrary": "Library push failed. Error",
          "alert_error_OpenLibrary": "Opening libraries has failed. Error",
          "alert_error_CheckLibrary": "There was a problem accessing local libraries",
          "alert_success_OpenLibrary": "The library was opened to",
          "modal_NewLibrariesRequest": {
            "modal_Title": "Check libraries",
            "infotext_1": "List of libraries used in",

            "table_header_Name": "Library name",
            "table_header_Type": "Type",
            "table_header_Files": "Files",
            "table_header_Status": "Status",
            "placeholder_Search": "Search",
          },
          "modal_TransferOwnership": {
            "modal_Title": "Transfer ownership to another user",
            "label_Users": "Users",

          },
          "alert_success_TransferOwnership": "Ownership of the library has been transferred to another user.",
          "alert_error_TransferOwnership": "Ownership of the library has not been transferred to another user. Error Error",
        },
        "Right": {
          "Content": {
            "tab_Tasks": "My tasks",
            "tab_WhereUse": "Where used",
            "tab_CamparisonLibraries": "Image comparison",
            "tab_CamparisonFiles": "File comparison",
            "tab_Pins": "Pins",
            "infotext_3": "Select one element in the middle panel to display MPNs.",
            "Tasks":{
              "infotext_1": "This library has tasks",
              "infotext_2": "This library has no tasks.",
              "infotext_3": "Select pending revision in the table on the left panel.",
              "infotext_4": "To manage the tasks for this item, go to request.",
              "button_Approve": "Approve",
              "button_Reject": "Reject",
              "label_Reason": "Reason for rejection",
              "label_Comment": "Comment for task",
              "label_Transfer": "Transfer ownership",
              "label_Name": "Task name",
              "label_Level1": "1st level",
              "label_Level2": "2nd level",
              "description": "Approve or reject the task",
              "alert_error_approve1": "Field",
              "alert_error_approve2": "must be completed before release.",
              "alert_success_approve": "The approval was successful",
              "alert_error_approve": "The approval was not successful",
              "modal_Reason":{
                "placeholder_Reason": "Enter a reason",
                "label_Reason": "Reason for rejection",
                "modal_Title": "Rejection"
              },
              "modal_EventTaskForm":{
                "placeholder_Reason": "Enter a comment",
                "label_Reason": "Comment",
                "modal_Title": "Approving process",
                "label_ChangeRevision": "A change in this library should cause a change in the revision of dependent parts",
                "label_Users": "If you want, select a 2nd level user"
              },
              "modal_EventTaskFormValidation":{
                "modal_Title": "Validation process",
                "infotext_1": "Approval is not possible.",
                "infotext_2": "List of libraries that have been used and may not be complete",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "modal_EventTaskDependencyInfo":{
                "modal_Title": "Dependency info",
                "infotext_1": "List of libraries that are used in",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "DetailsHistory": {
                "infotext_1": "Select the revision in the table on the left panel",
                "infotext_2": "Comments in revision",
                "infotext_3": "No comments",
                "label_Reason": "Rejected",
                "label_Comment": "Approved with comment",
                "label_WithoutComment": "Approved without comment",
                "label_Transfer": "Transfer ownership",
                "label_Assign": "Assigned MPN",
                "label_Unassign": "Unassigned MPN",
                "label_Move": "Category changed"
              },
            },
            "WhereUse":{
              "infotext_1": "Usage report in projects",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_Variant": "Variant",
              "table_header_Quantity": "Quantity",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },
            "WhereLibUsed": {
              "infotext_1": "Usage report in elements",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "WhatIsIncluded": {
              "infotext_1": "Depends on",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "CamparisonLibraries":{
              "infotext_1": "Comparison of libraries",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search",
              "button_Analyze": "Analyze",
              "alert_error_analyze": "No image to compare.",
            },
            "FileComparison": {
              "infotext_1": "File comparison ",
              "infotext_2": "Select the two revisions in the left panel to see a file comparison.",
              "table_header_Name": "File",
              "table_header_Revision": "Revision",
              "table_header_Status": "Status",
              "table_header_Size": "Size",
              "table_header_When": "Creation date",
              "table_header_Path": "Path",
              "placeholder_Search": "Search"
            },
            "PinsTable":{
              "infotext_1": "Table of pins",
              "infotext_2": "No pins for this type of library.",
              "table_header_Number": "Number",
              "table_header_Name": "Name",
              "table_header_Padstack": "Padstack",
              "table_header_Type": "Type",
              "placeholder_Search": "Search",

            },
          },
          "button_Hide": "Hide"
        }
      },

      "LibraryNew": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }

          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_NewPart": "New library",
            "NewPartForm":{
              "infotext_1": "Fill out the form to create a new library element for category",
              "infotext_2": "Load library files",
              "infotext_3": "This property is required to create a new library.",
              "infotext_4": "Unable to create an new library element in the 'All libraries' category",
              "infotext_5": "Unable to create an new library element in the 2nd level category",
              "filesPlaceholder": "Choose a library files or drop them here...",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",

              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "modal_Footprints":{
                "modal_Title": "Footprints",
                "infotext_1": "You can search and select footprint from the table below",
                "table_Footprints":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new footprint",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The footprint name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",
              },
              "modal_Symbols":{
                "modal_Title": "Symbols",
                "modal_TitleHDL": "HDL symbols",
                "modal_TitleSymbols": "Symbols",
                "infotext_1": "You can search and add symbols from the table below",
                "table_Symbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Add": "Add",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new symbol",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The symbol name must not be empty.",
                "alert_success_create_symbol": "A new symbol has been created",
                "alert_error_create_symbol": "A new symbol has not been created",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new part.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The renamed library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                }
              },

            },


          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Save": "Create new",
          "alert_success_new_part": "The new library has been saved.",
          "alert_error_new_part_required": "Fields marked as Request must not be empty.",
          "alert_error_new_part": "The new library has not been saved. Error",
          "modal_PushLibrary": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Dependency": "Dependency",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "modal_buttonWaitAlert": "Problems occurred while pushing files",
        },
        "Right": {
          "Content": {


          },
          "button_Hide": "Hide"
        }
      },
      "LibraryImport": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }

          },
          "button_Hide": "Hide"
        },
        "Middle": {
          "Content": {
            "tab_Import": "Import libraries",


            "label_file": "Upload a CSV format file containing libraries",
            "placeholder_file": "Choose a file or drop it here...",
            "button_Upload": "Upload",
            "infotext_1": "The libraries will be imported into the category",
            "infotext_notImportedParts": "List of libraries that have not been imported",

            "ImportLibraries": {
              "placeholder_Search": "Search",
              "table_header_Name": "Name",
              "table_header_Type": "Type",
              "table_header_Category": "Category",
              "table_header_Files": "Files",
              "table_header_Path": "Path",
              "table_header_Status": "Status",
              "table_header_Message": "Message",
              "table_header_Select": "Select",
              "table_header_Progress": "Result",
            },

            "tab_ImportHistory": "Import history",
            "infotext_3": "List of historical imports",
            "TableImportHistory":{
              "placeholder_Search": "Search",
              "table_header_When": "Date",
              "table_header_Category": "Category",
              "table_header_Quantity": "Quantity",
              "table_header_Action": "Action",
              "button_Undo": "Undo",
              "alert_success_undo_imported": "Library import has been cancelled correctly",
              "alert_error_undo_imported": "Library import has not been cancelled correctly"
            },


            "alert_success_importCSV": "CSV file was parsed correctly",
            "alert_error_importCSV": "CSV file was not parsed correctly. Error",


          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_ExportCsv": "Export CSV",
          "button_ExportFiles": "Export files",
          "button_Import": "Import libraries",
          "button_Approve": "Approve libraries",

          "alert_success_import": "Import of libraries successfully completed.",
          "alert_error_import": "Import of libraries failed",
          "alert_error_import2": "Some libraries were not imported. Check the list.",
          "alert_success_approving": "Approving of libraries successfully completed.",
          "alert_error_approving": "Approving of libraries failed",
          "alert_error_approving2": "Some libraries were not approved. Check the list.",
          "title_import": "Importing libraries",
          "alert_success_approveLibrariesBulk": "The approval process went correctly.",
          "alert_error_approveLibrariesBulk": "There was a problem with approve processing. Error",
          "alert_success_importLibrariesBulk": "The libraries list will be imported correctly",
          "alert_error_importLibrariesBulk": "List of libraries that have not been imported. Error",

        },
        "Right": {
          "Content": {


          },
          "button_Hide": "Hide"
        }
      },
      "Categories": {
        "Left": {
          "Content": {


          },
          "button_Hide": "Hide"
        },
        "Middle": {
          "Content": {
            "tab_Categories": "Categories",
            "placeholder_Create": "Enter new category name",
            "placeholder_Template": "Enter Library Number template",
            "button_Create": "Create",
            "button_Update": "Update",
            "validinfo_1": "The category name must not be empty.",
            "validinfo_2": "The category type must be chosen.",
            "alert_success_create_category": "Category has been created.",
            "alert_error_create_category": "Category hasn't been created. Error",
            "alert_success_update_category": "Category has been updated.",
            "alert_error_update_category": "Category hasn't been updated. Error",
            "infotext_1": "Category image",
            "infotext_2": "Select a category in the tree and enter a new category name",
            "infotext_3": "Select an image for a category",
            "infotext_4": "Select a new category image",
            "infotext_5": "A new category will be created for the parent category",
            "infotext_6": "Set template for Library Number property",
            "infotext_7": "How should you complete the Library Number template?",
            "infotext_8": "letters taken from the category name",
            "infotext_9": "e.g:",
            "infotext_10": "means taking the first three letters of the category to build the Library Number value",
            "infotext_11": "number generated on the given number of items ",
            "infotext_12": "means the number generated on three positions from 001 to 999",
            "infotext_13": "Unable to create subcategories deeper than level 3 for this category type.",
            "label_libraryType": "Select a library type",
            "checkbox_rule4eye": "Turn off the 4 eye rule for this category",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",

              "TreeItem": {
                "button_Delete": "Delete",
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
                "alerttitle_Delete": "Delete",
                "alertinfo_1": "Are you sure?",
                "alertinfo_2": "This category contains ",
                "alertinfo_3": "If a category contains any items, it cannot be deleted.",


              }

            },
            "PermissionGroups": {
              "label_Groups": "Groups",
              "label_Search": "Search group",
              "infotext_1": "There are no groups available to select",
              "infotext_2": "There are no groups matching your search criteria"
            }
          },
          "button_Back": "Back",


        },
        "Right": {
          "Content": {

          },
          "button_Hide": "Hide"
        }
      },
      "Properties": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }
          },
          "button_Hide": "Hide",

        },
        "Middle": {
          "Content": {
            "tab_Properties": "Properties",
            "infotext_1": "Properties for the category",
            "infotext_2": "Explanation",
            "infotext_3": {
              "own": "properties created for the selected category",
              "descendant": "properties created for the descendant of the selected category",
              "ancestor": "properties created for the ancestor of the selected category",
            },

            "PropertyForm": {
              "table_header_Priority": "Priority",
              "table_header_Origins": "Origins",
              "table_header_Name": "Property name",
              "table_header_Type": "Property type",
              "table_header_Request": "Required On Request",
              "table_header_Release": "Required On Release",
              "table_header_Revision": "Revision Changing",
              "table_header_HDLGlobal": "HDL global",
              "table_header_MaxLength": "Max length",
              "table_header_Actions": "Actions",
              "button_Delete": "Delete",
              "alert_success_Delete": "Property has been deleted",
              "alert_error_Delete": "Property has not been deleted",
              "alert_success_ChangePriority": "Property changed priority correctly.",
              "alert_error_ChangePriority": "Property did not change priority correctly.",
              "alert_Title": "Deleting property",
              "alert_Text": "Are you sure?",
              "alert_Text_Special": "This property is important for the proper working of the application. Are you sure?",
              "LibraryTypes": [
                "Symbol", "Footprint", "Padstack", "Pad"
              ]
            }
          },
          "button_Back": "Back",
          "button_New": "New",
          "button_Save": "Save",
          "button_Delete": "Delete",
          "alert_success_Update": "Changes have been saved",
          "alert_error_Update": "Changes have not been saved",
          "alert_success_NewProperty": "The new property was created correctly",
          "alert_error_NewProperty": "New property was not created correctly. Error",
          "alert_error_DuplicateProperty": "You cannot set duplicate reserved properties",
          "alert_error_NoPartNumber": "At least one property must be of type 'library number'.",
          "alert_error_NoLibraryType": "At least one property must be of type 'library type'.",
          "alert_error_NoProperties": "There are no properties",
          "modal_NewProperty": {
            "modal_Title": "Create new property",
            "label_Name": "Property name",
            "placeholder_Name": "Enter name",
            "validinfo_1": "Enter name",
            "label_Type": "Type of property",
            "validinfo_2": "Choose type",
            "option_Empty": "Choose...",
            "label_Request": "Required On Request",
            "label_Release": "Required On Release",
            "label_Revision": "Revision Changing",
            "label_HdlGlobal": "HDL global",
            "button_OK": "OK",
            "button_Cancel": "Cancel"
          }

        },
        "Right": {
          "Content": {

          },
          "button_Hide": "Hide"
        }
      },
    },

    "ProjectManager": {
      "ProjectTable": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "alert_success_create_category": "Category has been created.",
            "alert_error_create_category": "Category hasn't been created.",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              },

            }
          },
          "button_Hide": "Hide",
          "button_Categories": "Categories",

        },
        "Middle": {
          "Content": {
            "tab_Projects": "Projects",
            "infotext_1": "Filters",
            "infotext_2": "Categories",
            "ProjectsTable": {
              "infotext_2": "List of projects",

              "header_ProjectNumber": "Project number",
              "header_ProjectName": "Project name",
              "header_Status": "Status",
              "header_Revision": "Revision",
              "header_ProjectType": "Project type",
              "header_ProjectCategory": "Category",
              "header_Owner": "Owner",
              "header_Date": "Date",

              "contextmenu_text_Details": "Details",
              "contextmenu_text_Derive": "Derive",
              "contextmenu_text_Withdraw": "Withdraw",
              "contextmenu_text_Place": "Place",
              "export_label_top": "Libraries from"
            },
            "Filters": {
              "placeholder": "Add filters"
            },
            "FiltersButtons": {
              "infotext_1": "Applied"
            },
            "PluginCategory": {
              "placeholder_Categories": "Choose category"
            },

          },
          "button_New": "New",
          "button_Details": "Details",
          "button_Derive": "Derive",
          "button_Delete": "Delete",
          "button_Withdraw": "Withdraw",
          "button_MoveTo": "Move",
          "button_Properties": "Properties",
          "button_Open": "Open",
          "button_Push": "Push",
          "button_DownloadZIP": "Offline",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "alert_withdraw": "Are you sure you want to withdraw selected items from use?",
          "alert_delete": "Are you sure?",
          "alert_success_withdraw": "Libraries have been withdrawn",
          "alert_error_withdraw": "Libraries have not been withdrawn. Error",
          "alert_success_create_image": "The image was created correctly",
          "alert_error_create_image": "The image was not created correctly",
          "modal_Title_PushProject": "Pushed files",
          "modal_PushProject": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "modal_Moving": {
            "modal_Title": "Moving project to another category",
            "label_Categories": "Please select a target category",

            "infotext_1": "You can safely move a project to the category of your choice",
            "infotext_2": "Moving a project to a selected category will lose the following properties",

            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Name": "Name of property",
            "table_header_Value": "Value",
            "placeholder_Search": "Search",


          },
          "alert_openProject_1": "Local project files have been detected",
          "alert_openProject_2": "Do you want to overwrite the local files with the remote content, or keep working with the local content?",
          "alert_title_openProject": "Opening the project",
          "alert_error_PushProject": "Project push failed. Error",
          "alert_success_PushProject": "The project was pushed correctly.",
          "alert_error_OpenProject": "Opening project has failed. Error",
          "alert_error_CheckProject": "There was a problem accessing local projects",
          "alert_success_OpenProject": "The project was opened to",
          "alert_success_delete_project": "The project was deleted correctly",
          "alert_error_delete_project": "Project was not deleted correctly. Error",
          "alert_success_MoveProject": "The project has been moved to another category correctly",
          "alert_error_MoveProject": "The project has not been moved to another category correctly",
          "alert_error_MoveProjectCategory": "Select a target category",
          "modal_title_BulkFeedback": "Feedback reports",
          "modal_button_Close": "Close",
          "modal_BulkFeedback": {
            "modal_Title": "Feedback reports",
            "infotext_1": "The operation was not performed correctly for the following items",
            "table_header_PartNumber": "Part number",
            "table_header_LibraryNumber": "Library number",
            "table_header_ProjectNumber": "Project number",
            "table_header_Message": "Message",
            "table_header_Status": "Status",
            "placeholder_Search": "Search",

            "button_Close": "Close"
          }
        },
        "Right": {
          "Content": {
            "tab_QuickView": "Quick view",
            "infotext_1": "Select one element in the middle panel to display details data.",
            "tab_Tasks": "Tasks",
            "infotext_2": "Select one element in the middle panel to display tasks of library.",

            "tab_WhereUse": "Where used",
            "infotext_3": "Select one element in the middle panel to display report on the library.",
            "tab_Report": "Report",

            "QuickView": {
              "infotext_1": "List of properties for",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
              "infotext_2": "List of parts in the assembly",
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },


            },
            "IPCSimpleViewer": {
              "infotext_1": "IPC image"
            },
            "ProjectFiles": {
              "infotext_1": "List of files",
              "table_header_Name": "Name",
              "table_header_Size": "Size",
              "table_header_Created": "Created",
              "table_header_Action": "Action",
              "placeholder_Search": "Search",
              "table_button_Download": "Download"


            },
            "Tasks":{
              "infotext_1": "This project has tasks",
              "infotext_2": "This project has no tasks.",
              "infotext_3": "Select pending revision in the table on the left panel.",
              "button_checkIn": "CheckIn",
              "button_checkOut": "CheckOut",
              "label_Name": "Task name",

              "alert_error_checkIn1": "Field",
              "alert_error_checkIn2": "must be completed before check in.",
              "alert_success_checkIn": "The check in was successful",
              "alert_error_checkIn": "The check in was not successful",
              "alert_success_checkOut": "The check out was successful",
              "alert_error_checkOut": "The check out was not successful",
              "alert_title_checkIfPushed": "Warning",
              "alert_warning_checkIfPushed": "Have you made a Push of your project? If you are sure you want to continue click Yes.",

            },

            "WhereUse": {
              "infotext_1": "Usage report in projects",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_Variant": "Variant",
              "table_header_Quantity": "Quantity",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },
            "ProjectReport":{
              "infotext_1": "Project change report ",
              "table_header_Name": "Element name",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },


          },
          "button_Hide": "Hide"
        }
      },
      "ProjectDerive": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }

          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_NewProject": "New project",
            "DeriveProjectForm":{
              "infotext_1": "Fill out the form to create a new project for category",
              "infotext_2": "This property is required to create a new project.",
              "infotext_3": "The project files will be copied to the new project.",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",
              "label_ProjectNumber": "A blank field will automatically generate a Project number according to the template",

            },



          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Save": "Save as new",
          "alert_success_new_part": "The new project has been created.",
          "alert_error_new_part_required": "Fields marked as Request must not be empty.",
          "alert_error_new_part": "The new project has not been created. Error",
          "alert_error_new_props": "The new properties has not been added. Error",
          "alert_success_derive": "The project has been derived.",
          "alert_error_derive": "The project has not been derived. Error",
        },
        "Right": {
          "Content": {


          },
          "button_Hide": "Hide"
        }
      },

      "ProjectDetails": {
        "Left": {
          "Content": {
            "tab_Revisions": "Revision history",
            "InfoElement": {
              "infotext_1": "List of revisions for",
              "infotext_2": "Category",
            },
            "RevisionsTable": {
              "table_header_Expand": "Exp",
              "table_header_Select": "Select",
              "table_header_Revision": "Revision",
              "table_header_Status": "Status",
              "table_header_Date": "When",
              "table_header_User": "Who",
              "table_header_IsArchived": "Archived",
              "table_header_Comment": "Comment",
              "placeholder_Search": "Search"
            },
            "tab_Diagram": "Diagram",
            "RevisionsDiagram":{

            }


          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_Details": "Project details",
            "infotext_1": "List of project properties",
            "tab_Variants": "BOMs",
            "infotext_2": "BOM variants",
            "tab_BOMs": "BOMs",
            "infotext_3": "List of BOMs",
            "tab_IPC": "IPC-2581",
            "infotext_4": "Upload a XML format file containing IPC image of board",
            "tab_BomComparison": "Variants comparison",

            "ProjectDetails": {
              "infotext_1": "Select the revision in the table on the left panel",
              "infotext_2": "List of project properties",
              "infotext_3": "Load project files",
              "table_header_Name": "Name",
              "table_header_Value": "Values for revision",
              "placeholder_Search": "Search",


              "filesPlaceholder": "Choose a project files or drop them here...",
              "infotext_Request": "This property is required to save a project.",
              "infotext_Release": "This property is required to check in project.",
              "infotext_Revision": "Changing this property will change the revision after saving.",
              "table_subheader": "Revision",
              "table_button_Download": "Download",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "FolderTree": {
                "infotext_1": "Resource tree:",

                "FolderTreeItem": {
                  "button_CreateSubfolder": "Create subfolder",
                  "button_ImportFile": "Import file",
                  "button_Delete": "Delete",
                  "button_Download": "Download",
                  "button_Delegate": "Delegate",
                  "button_UndoDelegate": "Cancel delegation",
                  "button_ConfirmResource": "Commit",
                  "button_RejectDelegate": "Reject delegate",
                  "button_SetAsVariant": "Set variant",
                  "button_SetAsBomCore": "Set BOM Core",
                  "button_RemoveAsVariant": "Remove variant",
                  "alert_success_delete_item": "Resource has been deleted.",
                  "alert_error_delete_item": "Resource hasn't been deleted.",

                  "alerttitle_Delete": "Deleting",
                  "alertinfo_1": "Are you sure?",
                  "alertinfo_2": "This folder contains files (",
                  "alertinfo_3": "). If you delete this folder the files will be deleted too. Do you want to continue?",
                  "alerttitle_RemoveVariant": "Removing variant marker",
                  "modal_CreateFolder": {
                    "modal_Title": "Creating new folder",

                    "label_Name": "Name",
                    "placeholder_Name": "Enter Name",
                    "validinfo_Name": "Enter name without \\ / : * ? \" < > |",
                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },
                  "modal_ImportFile": {
                    "modal_Title": "Importing file",

                    "label_File": "File",
                    "placeholder_File": "Choose a file or drop it here...",

                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },
                  "modal_SetAsVariant": {
                    "modal_Title": "Setting as variant",

                    "label_Name": "Name",
                    "placeholder_Name": "Enter Name",
                    "validinfo_Name": "Enter name without \\ / : * ? \" < > |",
                    "button_OK": "OK",
                    "button_Cancel": "Cancel"
                  },

                  "alert_success_import_file": "The file was loaded successfully",
                  "alert_error_import_file": "File did not load correctly. Error",
                  "alert_success_create_folder": "The folder was created correctly",
                  "alert_error_create_folder": "Folder was not created correctly. Error",
                  "alert_error_create_folder_no_name": "The folder must have a name.",
                  "alert_success_download_file": "The file downloaded successfully",
                  "alert_error_download_file": "File did not download correctly. Error",
                  "alert_success_create_variant": "The variant was created correctly",
                  "alert_error_create_variant": "Variant not created correctly. Error",
                  "alert_error_create_variant_no_name": "The variant must have a name.",
                  "alert_success_remove_variant": "The variant was removed correctly.",
                  "alert_error_remove_variant": "Variant was not removed correctly. Error",
                  "alert_success_delete_folder": "The folder was deleted correctly",
                  "alert_error_delete_folder": "Folder was not deleted correctly. Error",
                  "alert_success_delete_file": "The file was created correctly",
                  "alert_error_delete_file": "File was not created correctly. Error",
                  "modal_Delegation": {
                    "modal_Title": "Delegating a resource to another user",
                    "label_Users": "Users",
                    "placeholder_Users": "You can safely move a project to the category of your choice",

                  },
                  "modal_RejectDelegation": {
                    "modal_Title": "Rejecting delegate a resource",
                    "label_Reason": "Reason",
                    "placeholder_Reason": "Enter a reason",

                  },
                  "alert_error_DelegateUser": "The delegation of the resource was not correct. The user was not chosen.",
                  "alert_success_DelegateFolder": "The folder has been delegated to another user",
                  "alert_error_DelegateFolder": "The folder has not been delegated to another user correctly. Error",
                  "alert_success_DelegateFile": "The file has been delegated to another user",
                  "alert_error_DelegateFile": "The file has not been delegated to another user correctly. Error",

                  "title_UndoDelegate": "Undo delegate",
                  "infotext_UndoDelegate": "Are you sure you want to undo delegate this resource?",
                  "alert_success_UndoDelegateFolder": "Undoing the delegation was done correctly",
                  "alert_error_UndoDelegateFolder": "Undoing the delegation was not done correctly. Error",
                  "alert_success_UndoDelegateFile": "Undoing the delegation was done correctly",
                  "alert_error_UndoDelegateFile": "Undoing the delegation was not done correctly. Error",

                  "title_RejectDelegate": "Rejecting resource",
                  "infotext_RejectDelegate": "Are you sure you want to reject this resource?",
                  "alert_success_RejectDelegateFolder": "Rejection of delegation was done correctly",
                  "alert_error_RejectDelegateFolder": "Rejection of delegation not done correctly. Error",
                  "alert_success_RejectDelegateFile": "Rejection of delegation was done correctly",
                  "alert_error_RejectDelegateFile": "Rejection of delegation not done correctly. Error",

                  "title_CommitDelegate": "Commiting resource",
                  "infotext_CommitDelegate": "Are you sure you want to commit this resource?",
                  "alert_success_CommitDelegateFolder": "The resource was committed correctly",
                  "alert_error_CommitDelegateFolder": "The resource was not committed correctly. Error",
                  "alert_success_CommitDelegateFile": "The resource was committed correctly",
                  "alert_error_CommitDelegateFile": "The resource was not committed correctly. Error",
                }
              },

            },
            "BomsTable": {
              "infotext_1": "Select the revision in the table on the left panel.",
              "infotext_2": "List of BOMs",
              "table_header_Name": "Name",
              "table_header_BomNumber": "BOM Number",
              "table_header_Description": "Description",
              "table_header_When": "When",
              "table_header_Who": "Who",
              "table_header_Files": "Files",
              "placeholder_Search": "Search",
            },
            "Variants": {
              "table_header_Name": "Name",
              "placeholder_Search": "Search",
              "infotext_1": "No content"
            },
            "BomComparison":{
              "infotext_1": "Bom comparison (differences found in different variants of the BOM)",
              "infotext_2": "There are no BOMS to compare.",
              "infotext_3": "Select the one or two revisions in the left panel.",
              "infotext_4": "Bom comparison (differences found in the BOMs of various revisions of project)",
              "table_header_PartReference": "Part reference",
              "placeholder_Search": "Search",
              "label_NoContent": "No content",
              "label_Options": "BOMs in revision"
            },
            "modal_PushProject": {
              "modal_Title": "Pushed files",
              "modal_Title": "Pushed files",
              "infotext_1": "List of pushed files",
              "infotext_2": "No files were pushed",
              "table_header_Name": "Filename",
              "table_header_Status": "Status",
              "table_header_Description": "Description",
              "placeholder_Search": "Search",
            },
            "modal_buttonWaitAlert": "Problems occurred while pushing files",
            "tab_ProjectSpec": "Project Specifications",
            "ProjectSpec": {
              "infotext_1": "Select the one or two revisions in the left panel.",
              "titlepanel_GeneralInformation": "General Information",
              "label_CADProjectTitle": "CAD Project Title",
              "info_CADProjectTitle": "Text from titleblock of the Schematic.",

              "label_ERP_PMLProjectTitle": "ERP/PML Project Title",
              "info_ERP_PMLProjectTitle": "Get this Value from your ERP/PLM System",

              "label_PCBAProductNumber": "PCBA Product Number",
              "info_PCBAProductNumber": "Get this Number from your ERP/PLM System",

              "titlepanel_CommercialParameters": "Commercial Parameters",

              "label_ProductionQuantity": "Production Quantity",
              "info_ProductionQuantity": "This number will be used to get the volume price from the component distributors and calculate the total price of the PCB assembly.",

              "label_MaxPCBAPrice": "Max PCBA Price",
              "info_MaxPCBAPrice": "Specify the maximum price your PCB Assembly shall cost. This includes the prices for all components from the BOM and the price for the empty PCB Board.",

              "label_PriceForPCBboard": "Price for PCB board",
              "info_PriceForPCBboard": "This price is the empty PCB board as it comes from the PCB fabricator.",

              "titlepanel_RequiredStandards": "Required Standards",
              "label_UL": "UL",
              "info_UL": "UL stands for Underweiters Laboratory. The UL certifications require manufacturers to rigorously test their circuit boards to measure the reliability and fire safety of PCBs. For printed circuit boards, the main standards that apply are UL796, which is the specific standard for PCBs, and UL94, which is for testing the flammability of plastics.",
              "value_UL_1": "Yes",
              "value_UL_2": "No",
              "value_UL_3": "Undefined",

              "label_RoHS": "RoHS",
              "info_RoHS": "RoHS stands for \"Restriction of certain Hazardous Substances\". This certification originated in the European Union and is designed to restrict the use of certain hazardous materials that are found in electrical products.",
              "value_RoHS_1": "Yes",
              "value_RoHS_2": "No",
              "value_RoHS_3": "Undefined",

              "label_REACH": "REACH EG-1907/2006",
              "info_REACH": "REACH stands for \"Registration, Evaluation, Authorisation and Restriction of Chemicals\".",
              "value_REACH_1": "Yes",
              "value_REACH_2": "No",
              "value_REACH_3": "Undefined",

              "label_WEEE": "WEEE",
              "info_WEEE": "WEEE stands for \"Waste Electrical and Electronic Equipment\". This regulation aims to reduce the amount of electrical and electronic equipment that end up in the landfill.",
              "value_WEEE_1": "Yes",
              "value_WEEE_2": "No",
              "value_WEEE_3": "Undefined",

              "titlepanel_OperatingThermalRangeRequirements": "Operating Thermal Range Requirements",

              "label_TAmin": "TAmin",
              "info_TAmin": "This is the minimal Ambient temperature the PCB assembly needs to work. This value will be used also for thermal simulations. ",

              "label_TAmax": "TAmax",
              "info_TAmax": "This is the maximal Ambient temperature the PCB assembly needs to work. This value will be used also for thermal simulations.",

              "label_TA": "TA",
              "info_TA": "This is the normal Ambient temperature the PCB assembly works. This value will be used also for thermal simulations.",

            }
          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Up": "Up",
          "button_Edit": "Edit",
          "button_Open": "Open",
          "button_Push": "Push",
          "button_ImportBom": "Import BOM",
          "button_OpenBom": "Open BOM",
          "button_EditBom": "Edit BOM",
          "button_DeleteBom": "Delete BOM",
          "button_CreateVariant": "Create variant",
          "button_Unedit": "Disable editing",
          "button_Save": "Save",
          "button_Derive": "Derive",
          "button_Renaming": "Rename project",
          "button_TransferOwnership": "Transfer ownership",
          "button_Delete": "Delete",
          "button_RemoveRevision": "Remove revision",
          "alert_delete": "Are you sure?",
          "button_ImportIPC": "Import IPC-2581",
          "button_RemoveIPC": "Remove IPC-2581",
          "button_ProjectSpec": "Save",
          "alert_success_edit_library": "The properties of the project have been saved.",
          "alert_error_edit_library": "Project properties have not been saved. Error ",
          "alert_error_edit_required": "Fields marked as Request must not be empty.",
          "alert_removeRevision": "Only the latest revision will be removed. Are you sure?",
          "alert_success_removeRevision_project": "The revision of project was removed correctly",
          "alert_error_removeRevision_project": "The revision of project was not removed correctly. Error",
          "modal_title_removeRevision": "Removing revision",
          "modal_Title_PushProject": "Pushed files",
          "modal_PushProject": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "modal_buttonWaitAlert": "Problems occurred while pushing files",
          "modal_Renaming": {
            "modal_Title": "Renaming project",

            "label_NewName": "New project number",
            "placeholder_NewName": "Enter new project number",

            "validinfo_NewName": "The name cannot be empty and contain such characters: \\ / : * ? \" < > |",
            "infotext_1": "Note that renaming a project will not automatically change the project files.",

            "button_OK": "OK",
            "button_Cancel": "Cancel"
          },
          "modal_TransferOwnership": {
            "modal_Title": "Transfer ownership to another user",
            "label_Users": "Users",

          },
          "modal_ImportBomType": {
            "modal_Title": "Importing BOM",
            "label_1": "Import type"
          },
          "modal_CreateBomVariant": {
            "modal_Title": "Creating BOM variant",
            "label_Name": "Variant name",
            "label_BomNumber": "BOM Number",
            "label_Description": "Variant description",
          },
          "alert_openProject_1": "Local project files have been detected",
          "alert_openProject_2": "Do you want to overwrite the local files with the remote content, or keep working with the local content?",
          "alert_title_openProject": "Opening the project",
          "alert_error_PushProject": "Project push failed. Error",
          "alert_success_PushProject": "The project was pushed correctly.",
          "alert_error_OpenProject": "Opening project has failed. Error",
          "alert_error_CheckProject": "There was a problem accessing local projects",
          "alert_success_OpenProject": "The project was opened to",
          "alert_success_RenameProject": "The name of the project has been changed",
          "alert_error_RenameProject": "The name of the project has not been changed correctly. Error",
          "alert_error_RenameProjectName": "Project must be named",
          "alert_success_delete_project": "The project was deleted correctly",
          "alert_error_delete_project": "Project was not deleted correctly. Error",
          "alert_success_CreateBomVariant": "Variant BOM created correctly",
          "alert_error_CreateBomVariant": "Variant BOM not created correctly. Error",
          "alert_error_CreateBomVariantName": "Variant BOM must be named",
          "alert_success_RemoveIpc": "IPC image has been removed correctly",
          "alert_error_RemoveIpc": "IPC image not removed correctly. Error",
          "alert_success_ProjectSpec": "The project specification was written correctly.",
          "alert_error_ProjectSpec": "The project specification was not saved correctly. Error",
          "alert_DeleteBom": "Are you sure?",
          "alert_success_delete_bom": "The BOM was deleted correctly",
          "alert_error_delete_bom": "BOM was not deleted correctly. Error",
          "modal_EditBomDetails": {
            "modal_Title": "Editing BOM details",
            "label_Name": "Name",
            "label_BomNumber": "BOM Number",
            "label_Description": "Description",
            "validinfo_name": "Name cannot be empty"
          },
          "alert_success_edit_bom_details": "The BOM was updated correctly",
          "alert_error_edit_bom_details": "BOM was not updated correctly. Error",
        },
        "Right": {
          "Content": {
            "tab_Tasks": "My tasks",
            "infotext_1": "No tasks for your role.",
            "tab_WhereUse": "Where used",
            "tab_Included": "Included",
            "tab_Report": "Report",
            "tab_FileComparison": "File comparison",
            "tab_Delegations": "Delegations",
            "tab_IPCImage": "IPC image",
            "Tasks":{
              "infotext_1": "This project has tasks",
              "infotext_2": "This project has no tasks.",
              "infotext_3": "Select pending revision in the table on the left panel.",
              "button_checkIn": "CheckIn",
              "button_checkOut": "CheckOut",
              "label_Name": "Task name",
              "task_checkin": "Approve this project revision.",
              "task_checkout": "Create a new revision of the project.",

              "alert_error_checkIn1": "Field",
              "alert_error_checkIn2": "must be completed before check in.",
              "alert_success_checkIn": "The check in was successful",
              "alert_error_checkIn": "The check in was not successful",
              "alert_success_checkOut": "The check out was successful",
              "alert_error_checkOut": "The check out was not successful",
              "alert_title_checkIfPushed": "Warning",
              "alert_warning_checkIfPushed": "Have you made a Push of your project? If you are sure you want to continue click Yes.",
              "modal_Comment":{
                "placeholder_Reason": "Enter a comment",
                "label_Reason": "Comment",
                "modal_Title": "CheckIn process"
              },

            },
            "WhereLibUsed": {
              "infotext_1": "Usage report in elements",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "WhatIsIncluded": {
              "infotext_1": "Depends on",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "WhereUse":{
              "infotext_1": "Usage report in projects",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_Variant": "Variant",
              "table_header_Quantity": "Quantity",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },
            "ProjectReport":{
              "infotext_1": "Project change report ",
              "table_header_Name": "Element name",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },
            "FileComparison":{
              "infotext_1": "File comparison ",
              "infotext_2": "Select the two revisions in the left panel to see a file comparison.",
              "table_header_Name": "File",
              "table_header_Revision": "Revision",
              "table_header_Status": "Status",
              "table_header_Size": "Size",
              "table_header_When": "Creation date",
              "table_header_Path": "Path",
              "placeholder_Search": "Search"
            },
             "Delegations":{
               "infotext_1": "Delegations report",
               "infotext_2": "No content",
               "label_Type": "Status",
               "label_Start": "Start date",
               "label_End": "End date",
               "label_Login": "User",
               "label_Path": "Path",
               "label_Reason": "Reason",
               "label_Resource": "Resource",
               "label_File": "File",
               "label_Folder": "Folder",
               "confirmed": "Delegation commited",
               "rejected": "Delegation rejected",
               "undodelegated": "Delegation cancelled",
               "delegated": "Delegated"

            },
            "IPCViewer": {
              "infotext_1": "Layers",
              "infotext_2": "Select the revision in the table on the left panel",
              "label_Revisions": "Revisions"
            }


          },
          "button_Hide": "Hide"
        }
      },

      "ProjectNew": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }

          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_NewPart": "New project",
            "NewProjectForm":{
              "infotext_1": "Fill out the form to create a new project for category",
              "infotext_2": "Load project files",
              "infotext_3": "This property is required to create a new project.",
              "infotext_4": "Unable to create an new project in the 'All projects' category",
              "filesPlaceholder": "Choose a project files or drop them here...",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",

              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",

            },
            "FolderTree": {
              "infotext_1": "Resource tree:",

              "FolderTreeItem": {
                "button_CreateSubfolder": "Create subfolder",
                "button_ImportFile": "Import file",
                "button_Delete": "Delete",
                "button_Download": "Download",
                "button_Delegate": "Delegate",
                "button_SetAsVariant": "Variant",
                "alert_success_delete_item": "Resource has been deleted.",
                "alert_error_delete_item": "Resource hasn't been deleted.",
                "modal_CreateFolder": {
                  "modal_Title": "Creating new folder",

                  "label_Name": "Name",
                  "placeholder_Name": "Enter Name",
                  "validinfo_Name": "Enter name without \\ / : * ? \" < > |",
                  "button_OK": "OK",
                  "button_Cancel": "Cancel"
                },
              }
            },

          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Create": "Create",


          "alert_success_new_project": "The new project has been created.",
          "alert_error_new_project_required": "Fields marked as Request must not be empty.",
          "alert_error_new_project": "The new project has not been created. Error",

        },
        "Right": {
          "Content": {
            "tab_BOMs": "BOMs",
            "tab_Image": "Board image",

          },
          "button_Hide": "Hide"
        }
      },
      "Categories": {
        "Left": {
          "Content": {


          },
          "button_Hide": "Hide"
        },
        "Middle": {
          "Content": {
            "tab_Categories": "Categories",
            "placeholder_Create": "Enter new category name",
            "placeholder_Template": "Enter Project Number template",
            "button_Create": "Create",
            "button_Update": "Update",
            "validinfo_1": "The category name must not be empty.",
            "alert_success_create_category": "Category has been created.",
            "alert_error_create_category": "Category hasn't been created. Error",
            "alert_success_update_category": "Category has been updated.",
            "alert_error_update_category": "Category hasn't been updated. Error",
            "infotext_1": "Category image",
            "infotext_2": "Select a category in the tree and enter a new category name",
            "infotext_3": "Select an image for a category",
            "infotext_4": "Select a new category image",
            "infotext_5": "A new category will be created for the parent category",
            "infotext_6": "Set template for Project Number property",
            "infotext_7": "How should you complete the Project Number template?",
            "infotext_8": "letters taken from the category name",
            "infotext_9": "e.g:",
            "infotext_10": "means taking the first three letters of the category to build the Project Number value",
            "infotext_11": "number generated on the given number of items ",
            "infotext_12": "means the number generated on three positions from 001 to 999",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",

              "TreeItem": {
                "button_Delete": "Delete",
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
                "alerttitle_Delete": "Delete",
                "alertinfo_1": "Are you sure?",
                "alertinfo_2": "This category contains ",
                "alertinfo_3": "If a category contains any items, it cannot be deleted.",

              },


            },
            "PermissionGroups": {
                "label_Groups": "Groups",
                "label_Search": "Search group",
                "infotext_1": "There are no groups available to select",
                "infotext_2": "There are no groups matching your search criteria"
              }
          },
          "button_Back": "Back",


        },
        "Right": {
          "Content": {

          },
          "button_Hide": "Hide"
        }
      },
      "Properties": {
        "Left": {
          "Content": {
            "tab_Category": "Categories",
            "Tree": {
              "infotext_1": "Category tree:",
              "placeholder_Search": "Search",
              "button_Delete": "Delete",
              "TreeItem": {
                "alert_success_delete_category": "Category has been deleted.",
                "alert_error_delete_category": "Category hasn't been deleted.",
              }
            }
          },
          "button_Hide": "Hide",

        },
        "Middle": {
          "Content": {
            "tab_Properties": "Properties",
            "infotext_1": "Properties for the category",
            "infotext_2": "Explanation",
            "infotext_3": {
              "own": "properties created for the selected category",
              "descendant": "properties created for the descendant of the selected category",
              "ancestor": "properties created for the ancestor of the selected category",
            },

            "PropertyForm": {
              "table_header_Priority": "Priority",
              "table_header_Origins": "Origins",
              "table_header_Name": "Property name",
              "table_header_Type": "Property type",
              "table_header_Request": "Required On Request",
              "table_header_Release": "Required On Release",
              "table_header_Revision": "Revision Changing",
              "table_header_DisplayInRevisionTable": "Display In RevisionTable",
              "table_header_MaxLength": "Max length",
              "table_header_Actions": "Actions",
              "button_Delete": "Delete",
              "alert_success_Delete": "Property has been deleted",
              "alert_error_Delete": "Property has not been deleted",
              "alert_success_ChangePriority": "Property changed priority correctly.",
              "alert_error_ChangePriority": "Property did not change priority correctly.",
              "alert_Title": "Deleting property",
              "alert_Text": "Are you sure?",
              "alert_Text_Special": "This property is important for the proper working of the application. Are you sure?",
            }
          },
          "button_Back": "Back",
          "button_New": "New",
          "button_Save": "Save",
          "button_Delete": "Delete",
          "alert_success_Update": "Changes have been saved",
          "alert_error_Update": "Changes have not been saved",
          "alert_success_NewProperty": "The new property was created correctly",
          "alert_error_NewProperty": "New property was not created correctly. Error",
          "alert_error_DuplicateProperty": "You cannot set duplicate reserved properties",
          "alert_error_NoPartNumber": "At least one property must be of type 'project number'.",
          "alert_error_NoLibraryType": "At least one property must be of type 'project type'.",
          "alert_error_NoProperties": "There are no properties",
          "modal_NewProperty": {
            "modal_Title": "Create new property",
            "label_Name": "Property name",
            "placeholder_Name": "Enter name",
            "validinfo_1": "Enter name",
            "label_Type": "Type of property",
            "validinfo_2": "Choose type",
            "option_Empty": "Choose...",
            "label_Request": "Required On Request",
            "label_Release": "Required On Release",
            "label_Revision": "Revision Changing",

            "label_DisplayInRevisionTable": "Display In Revision Table",



            "button_OK": "OK",
            "button_Cancel": "Cancel"
          }

        },
        "Right": {
          "Content": {

          },
          "button_Hide": "Hide"
        }
      },
      "ProjectImportBom":{
        "Left": {

        },
        "Middle": {
          "Content": {
            "tab_ImportBom": "Importing BOM",
            "label_file": "Upload file (CSV, RPT format) containing parts (parts cannot be aggregated)",
            "label_file_invalid": "Choose a file in CSV or RPT format.",
            "placeholder_file": "Choose a file or drop it here...",
            "button_Upload": "Upload",
            "label_Delimiter": "Delimiter",
            "infotext_1": "Only the first 25 preview records from the CSV file are displayed. Match the application properties to the columns in the CSV file",
            "textarea_label_Description": "Description",
            "textarea_label_Name": "Name",
            "textarea_label_BomNumber": "BOM Number",
            "textarea_placeholder": "Enter a description for the BOM",
            "placeholder_Name": "Enter a name for the BOM",
            "placeholder_BomNumber": "Enter a BOM Number",
            "alert_error_importBOM": "BOM file was not parsed correctly. Error",
            "alert_success_importBOM": "The BOM file was parsed correctly"
          },
          "button_Back": "Back",
          "button_ImportBom": "Import BOM",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "alert_success_import": "Import of BOM successfully completed.",
          "alert_error_import": "Import of BOM failed.",
          "title_import": "Importing BOM",
          "alert_text_mapping": "Not all required fields have been mapped. Do you want to continue importing anyway?",
          "title_import_revision": "Importing BOM - revision",
          "alert_text_revision": "If you don't have information about parts revisions, you can set the default revisions according to the latest parts revisions in the database. Do you want to do that?"
        },
        "Right":{

        },
      },
      "ProjectImportBomLst":{
        "Left": {

        },
        "Middle": {
          "Content": {
            "tab_ImportBom": "Importing BOM LST",
            "label_file": "Upload a LST format file containing variants",
            "placeholder_file": "Choose a file or drop it here...",
            "button_Upload": "Upload",

            "textarea_label_Description": "Description",
            "textarea_label_Name": "Name",
            "textarea_placeholder": "Enter a description for the BOM",
            "placeholder_Name": "Enter a name for the BOM",
            "alert_success_import": "Import of BOM successfully completed.",
            "alert_error_import": "Import of BOM failed. Error",
          },
          "button_Back": "Back",
          "button_ImportBom": "Import BOM",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",

          "title_import": "Importing BOM",
        },
        "Right":{

        },
      },
      "ProjectBom":{
        "Left": {
          "Content": {
            "tab_BomDetails": "Project details",

            "infotext_1": "Metadata",

            "label_projectNumber": "Project number",
            "label_revision": "Project revision",
            "label_projectType": "Project type",
            "label_projectOwner": "Project revision approver",
            "label_name": "Name",
            "label_bomNumber": "BOM Number",
            "label_isCore": "Type",
            "label_Login": "Who imported BOM",
            "label_creationDate": "When imported BOM",
            "label_description": "BOM description",

            "label_IsActive": "BOM is active",
            "button_Update": "Update",
            "alert_success_IsActive": "BOM's status has been changed correctly",
            "alert_error_IsActive": "BOM's status has not been changed correctly"

          },
          "button_Hide": "Hide"
        },
        "Middle": {
          "Content": {
            "tab_Parts": "Parts in BOM",
            "infotext_1": "List of parts in the BOM",
            "infotext_2": "List of compressed parts in the BOM",
            "checkbox_Aggregated": "Compressed parts",
            "PartsTable": {
              "infotext_1": "List of parts in the BOM",
              "infotext_2": "List of compressed parts in the BOM",
              "NoContent": "No content",
              "placeholder_Search": "Search",
              "table_header_PartNumber": "Part Number",
              "table_header_Revision": "Revision",
              "table_header_PartReference": "Part reference",
              "table_header_Quantity": "Quantity",
              "table_header_Remarks": "Remarks",
              "table_header_Description": "Description",
              "table_header_Status": "Status",
              "contextmenu_text_Details": "Details",
              "export_label_top1": "Project",
              "export_label_top2": "BOM",
              "tag_Synchronized": "synchronized",
              "tag_OutOfSync": "out of sync",
              "tag_OldRevision": "old revision",
              "tag_IsManual": "Manual",
              "tag_IsNotPresent": "DNI",
              "alert_OutOfSync": "Part is not synchronized",
              "alert_Preferred": "Preferred",
              "alert_NRND": "NRND",
              "alert_Forbidden": "Forbidden",
            },

            "tab_PartsAlternative": "Parts in BOM with MPNs",
            "infotext_3": "List of parts with MPNs in the BOM",
            "infotext_4": "List of compressed parts with MPNs in the BOM",

            "PartsAlternativeTable": {
              "infotext_1": "List of parts with MPNs in the BOM",
              "infotext_2": "List of compressed parts with MPNs in the BOM",
              "NoContent": "No content",
              "placeholder_Search": "Search",
              "table_header_Expand": "Exp",
              "table_header_Priority": "Priority",
              "table_header_Image": "Image",
              "table_header_PartNumber": "Part Number",
              "table_header_Revision": "Revision",
              "table_header_PartReference": "Part reference",
              "table_header_Quantity": "Quantity",
              "table_header_Remarks": "Remarks",
              "table_header_Description": "Description",
              "table_header_Datasheet": "Datasheet",
              "table_header_MPNs": "MPNs",
              "table_header_EOLalert": "EOL alert",
              "table_header_Status": "Status",
              "table_header_No": "No.",
              "table_header_ManufacturerName": "ManufacturerName",
              "table_header_ManufacturerPartNumber": "ManufacturerPartNumber",
              "table_header_Selected": "Selected",
              "contextmenu_text_Details": "Details",
              "alert_success_SelectAlternative": "Successfully changed status",
              "alert_error_SelectAlternative": "Failed to change status",
              "export_label_top1": "Project",
              "export_label_top2": "BOM",
              "tag_Synchronized": "synchronized",
              "tag_OutOfSync": "out of sync",
              "tag_OldRevision": "old revision",
              "tag_IsManual": "Manual",
              "tag_IsNotPresent": "DNI",
              "alert_OutOfSync": "Part is not synchronized",
              "alert_Preferred": "Preferred",
              "alert_NRND": "NRND",
              "alert_Forbidden": "Forbidden",
            },
            "tab_ExtendedBom": "Extended BOM",
            "infotext_5": "Extended list of parts (including components of assembly items)",
            "infotext_6": "Extended compressed list of parts (including components of assembly items)",
            "ExtendedBom": {
              "infotext_1": "Extended list of parts (including components of assembly items)",
              "infotext_2": "Extended compressed list of parts (including components of assembly items)",
              "NoContent": "No content",
              "placeholder_Search": "Search",
              "table_header_PartNumber": "Part Number",
              "table_header_Revision": "Revision",
              "table_header_PartReference": "Part reference",
              "table_header_Quantity": "Quantity",
              "table_header_Remarks": "Remarks",
              "table_header_Description": "Description",
              "table_header_Assembly": "Assembly",
              "table_header_Status": "Status",
              "export_label_top1": "Project",
              "export_label_top2": "BOM",
              "tag_Synchronized": "synchronized",
              "tag_OutOfSync": "out of sync",
              "tag_OldRevision": "old revision",
              "tag_IsManual": "Manual",
              "tag_IsNotPresent": "DNI",
              "alert_OutOfSync": "Part is not synchronized",
              "alert_Preferred": "Preferred",
              "alert_NRND": "NRND",
              "alert_Forbidden": "Forbidden",
            },
            "tab_UsedLibraries": "Used libraries",
            "infotext_7": "List of libraries used in the BOM",
            "UsedLibraries":{
              "NoContent": "No content",
              "placeholder_Search": "Search",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "table_header_PartNumber": "Part Number",
            },
            "tab_Reports": "BOM reports",

            "Reports": {
              "infotext_1": "List of MPNs used in the BOM",
              "export_label_top1": "Project Number",
              "export_label_top2": "BOM name",
              "labelSelect": "List report",
              "NoContent": "No content",
              "placeholder_Search": "Search",
              "table_header_PartReference": "Part reference",
              "table_header_ManufacturerPartNumber": "ManufacturerPartNumber",
              "table_header_Manufacturer": "Manufacturer",
              "table_header_Description": "Description",
              "table_header_Datasheet": "Datasheet",

              "table_header_OverallRisk": "OverallRisk",
              "table_header_LifeCycleRiskGrade ": "LifeCycleRiskGrade ",
              "table_header_RohsRisk": "RohsRisk",
              "table_header_RohsVersion": "RohsVersion",
              "table_header_InventoryRisk": "InventoryRisk",
              "table_header_MultiSourcingRisk": "MultiSourcingRisk",
              "table_header_EstimatedYearsToEOL": "EstimatedYearsToEOL",
              "table_header_PartStatus": "PartStatus ",
              "table_header_ContainsSVHC": "ContainsSVHC",
              "table_header_LifecycleRisk": "LifecycleRisk"
            },
            "tab_Documents": "Documents",
            "infotext_8": "List of documents in the project",
            "DocumentsTable":{
              "placeholder_Search": "Search",
              "table_header_Name": "Name",
              "table_header_Type": "Type",
              "table_header_Size": "Size",
              "table_header_WhenCreated": "When created",
              "table_header_WhoCreated": "Who created",
              "contextmenu_text_Download": "Download",

            },
            "tab_ImportIPC": "Importing IPC-2581",
            "label_file": "Upload a IPC-2581 (xml) format file",
            "placeholder_file": "Choose a file or drop it here...",
            "button_Upload": "Upload",

          },
          "button_Back": "Back",
          "button_Up": "Up",
          "button_CreateBomPart": "Add",
          "alert_success_CreateBomPart": "Part was created correctly",
          "alert_error_CreateBomPart": "Part was not created correctly. Error",
          "button_UpdateBomPart": "Edit",
          "alert_success_UpdateBomPart": "Part was modified correctly",
          "alert_error_UpdateBomPart": "Part was not modified correctly. Error",
          "button_DeleteBomPart": "Delete",
          "alert_success_DeleteBomPart": "Part was deleted correctly",
          "alert_error_DeleteBomPart": "Part was not deleted correctly. Error",
          "button_SetAlternative": "Set alternative",
          "alert_success_SetAlternative": "Setting of the alternative part was correct.",
          "alert_error_SetAlternative": "Setting the alternative element was not correct. Error",
          "button_SetNotPresent": "Set not present",
          "alert_success_SetNotPresent": "Setting the part as not present was correct.",
          "alert_error_SetNotPresent": "Setting the part as not present was correct. Error",
          "button_SetPresent": "Set present",
          "alert_success_SetPresent": "Setting the part as present was correct.",
          "alert_error_SetPresent": "Setting the part as present was not correct. Error",
          "button_ImportBom": "Import BOM",
          "button_ImportIPC": "Import IPC-2581",
          "button_RemoveIPC": "Remove IPC-2581",
          "button_PartDetails": "Part details",
          "button_ImportDocument": "Import document",
          "button_DownloadDocument": "Download document",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "modal_BomPartNewObjectForm": {
            "modal_Title": "Creating new part",
            "label_PartNumber": "Part number",
            "label_Revision": "Revision",
            "label_PartReference": "Part reference",
            "label_Description": "Description",
            "label_Remarks": "Remarks",
            "validinfo_Revision": "Use only numeric values (e.g.: 1 or 5)",
            "modal_SearchParts": {
              "modal_Title": "Searching for parts",
              "Tree": {
                "infotext_1": "Category tree:",
                "placeholder_Search": "Search",
                "button_Delete": "Delete",
                "TreeItem": {
                  "alert_success_delete_category": "Category has been deleted.",
                  "alert_error_delete_category": "Category hasn't been deleted.",
                }
              },
              "PartTable":{
                "infotext_2": "List of generic parts",
                "header_Image": "Image",
                "header_Status": "Status",
                "header_Revision": "Revision",
                "status_Used": "used",
                "status_Alternative": "no MPN",
                "status_Assembly": "assembly",
                "contextmenu_text_Details": "Details",
                "contextmenu_text_Derive": "Derive",
                "contextmenu_text_Withdraw": "Withdraw",
                "contextmenu_text_Delete": "Delete",
                "contextmenu_text_Place": "Place",
                "export_label_top": "Parts from",
                "label_checkbox": "Only parts matching through footprints",
              },
              "infotext_1": "Select one element in the middle panel to display details data.",
              "QuickView":{
                "infotext_1": "List of properties for",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
                "infotext_2": "List of parts in the assembly",
                "table_header_PartNumber": "PartNumber",
                "table_header_Revision": "Revision",
                "table_header_Quantity": "Quantity",
                "modal_ZoomSvg": {

                  "button_Close": "Close",

                },
                "label_pinSwitch": "Pin switch",
                "label_Properties": "Properties"
              },
            }
          },
          "modal_BomPartUpdateObjectForm": {
            "modal_Title": "Editing part",
            "label_PartNumber": "Part number",
            "label_Revision": "Revision",
            "label_PartReference": "Part reference",
            "label_Description": "Description",
            "label_Remarks": "Remarks",
            "validinfo_Revision": "Use only numeric values (e.g.: 1 or 5)",
            "modal_SearchParts": {
              "modal_Title": "Searching for parts",
              "Tree": {
                "infotext_1": "Category tree:",
                "placeholder_Search": "Search",
                "button_Delete": "Delete",
                "TreeItem": {
                  "alert_success_delete_category": "Category has been deleted.",
                  "alert_error_delete_category": "Category hasn't been deleted.",
                }
              },
              "PartTable":{
                "infotext_2": "List of generic parts",
                "header_Image": "Image",
                "header_Status": "Status",
                "header_Revision": "Revision",
                "status_Used": "used",
                "status_Alternative": "no MPN",
                "status_Assembly": "assembly",
                "contextmenu_text_Details": "Details",
                "contextmenu_text_Derive": "Derive",
                "contextmenu_text_Withdraw": "Withdraw",
                "contextmenu_text_Delete": "Delete",
                "contextmenu_text_Place": "Place",
                "export_label_top": "Parts from",
                "label_checkbox": "Only parts matching through footprints",
              },
              "infotext_1": "Select one element in the middle panel to display details data.",
              "QuickView":{
                "infotext_1": "List of properties for",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
                "infotext_2": "List of parts in the assembly",
                "table_header_PartNumber": "PartNumber",
                "table_header_Revision": "Revision",
                "table_header_Quantity": "Quantity",
                "modal_ZoomSvg": {

                  "button_Close": "Close",

                },
                "label_pinSwitch": "Pin switch",
                "label_Properties": "Properties"
              },
            }
          },
          "alert_delete": "Are you sure?",
          "alert_delete_title": "Deleting part",
        },
        "Right":{
          "Content": {
            "tab_QuickView": "Quick view",
            "infotext_1": "Select one element in the middle panel to display details data.",
            "infotext_2": "No data available",
            "tab_WhereUse": "Where used",
            "infotext_3": "Select one element in the middle panel to display report on the part.",
            "tab_Alternatives": "MPNs",
            "infotext_4": "Select one element in the middle panel to display MPNs.",
            "tab_IPCImage": "IPC image",
            "QuickView":{
              "infotext_1": "List of properties for",
              "table_header_Name": "Name",
              "table_header_Value": "Value",
              "placeholder_Search": "Search",
              "infotext_2": "List of parts in the assembly",
              "table_header_PartNumber": "PartNumber",
              "table_header_Revision": "Revision",
              "table_header_Quantity": "Quantity",
              "modal_ZoomSvg": {

                "button_Close": "Close",

              },
              "label_pinSwitch": "Pin switch",
              "label_Properties": "Properties"
            },

            "WhereUse":{
              "infotext_1": "Where used report",
              "table_header_Project": "Project number",
              "table_header_Revision": "Revision",
              "table_header_Variant": "Variant",
              "table_header_Quantity": "Quantity",
              "table_header_When": "Creation date",
              "placeholder_Search": "Search"
            },
            "WhereLibUsed": {
              "infotext_1": "Usage report in elements",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "WhatIsIncluded": {
              "infotext_1": "Depends on",
              "table_header_Name": "Name",
              "table_header_Revision": "Revision",
              "table_header_Type": "Type",
              "table_header_Status": "Status",
              "placeholder_Search": "Search"
            },
            "Alternatives":{
              "infotext_1": "List of MPNs",
              "table_header_Expand": "Exp",
              "table_header_Priority": "Priority",
              "table_header_Image": "Image",
              "table_header_Status": "Status",
              "table_header_SEStatus": "SE Status",
              "table_header_ManufacturerName": "Manufacturer Name",
              "table_header_ManufacturerPartNumber": "Manufacturer Part Number",
              "table_header_Description": "Description",
              "table_header_Datasheet": "Datasheet",
              "table_header_Login": "Who assigned",
              "table_header_Date": "When assigned",
              "table_header_SyncDate": "Synchronization date",
              "table_header_Manual": "Info",
              "table_info_Manual": "Manual MPN",
              "table_button_Unassign": "Unassign",
              "table_button_Details": "Details",
              "table_button_Sync": "Sync",
              "table_button_SyncSE": "SyncSE",
              "placeholder_Search": "Search",
              "alert_success_unassignAlternative": "MPN has been unassigned",
              "alert_error_unassignAlternative": "MPNs has not been unassigned",
              "alert_success_syncAlternative": "MPN has been synchronized",
              "alert_error_syncAlternative": "MPN has not been synchronized. Error",
              "alert_Title": "Unassign MPN",
              "alert_Text": "Are you sure?",
              "alert_EndOfPart": "End of",
              "alert_Preferred": "Preferred",
              "alert_NRND": "NRND",
              "alert_Forbidden": "Forbidden",
              "alert_success_ChangeMPNPriority": "Priority changed correctly.",
              "alert_error_ChangeMPNPriority": "Priority not changed correctly.",
              "alert_success_StatusMPN": "The status of the MPN has been changed.",
              "alert_error_StatusMPN": "The status of the MPN has not been changed.",
              "modal_SERisk": {
                "modal_Title": "SiliconExpert Details",
                "infotext_1": "MPN",
                "infotext_2": "Manufacturer name"
              },
              "button_label_Details": "Details",
              "button_label_GetDataFromSE": "Get data from SE",
              "button_label_SE_sync": "SE Sync",
              "button_label_SE_RiskDetails": "Risk details",
              "button_label_SyncPartSE": "Sync SE data",
              "button_label_SE_unassign": "Unassign SE data",
              "modal_title_unassignSEData": "Unassign SE data",
              "alert_unassignSEData": "Are you sure?",
              "alert_success_unassignSEData": "SE data has been unassigned",
              "alert_error_unassignSEData": "SE data has not been unassigned. Error",
              "alert_success_SyncSEData": "SE data has been synchronized",
              "alert_error_SyncSEData": "SE data has not been synchronized. Error",
              "TreeSE": {
                "placeholder_Search": "Search",
              },
              "modal_SESuggestions": {
                  "modal_Title": "SiliconExpert Parts",
                  "OverallDetails": {
                    "infotext_1": "Overall properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "PropertiesDetails":{
                    "infotext_1": "Technical properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "SEPropertiesChoose": {
                    "infotext_1": "SiliconExpert details data",
                    "infotext_2": "Select one SE part and link it to the MPN part",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                },
              "alert_success_AssignPartSEToMPN": "PartSE has been assigned to MPN.",
              "alert_error_AssignPartSEToMPN": "PartSE has not been assigned to MPN. Error",

            },
            "AlternativeDetails":{
              "button_Back": "Back",
              "button_Unassign": "Unassign",
              "button_Sync": "Sync",
              "alert_success_unassignAlternative": "MPNs has been unassigned",
              "alert_error_unassignAlternative": "MPNs has not been unassigned",
              "alert_success_syncAlternative": "MPN has been synchronized",
              "alert_error_syncAlternative": "MPN has not been synchronized. Error",
              "alert_Title": "Unassign MPN",
              "alert_Text": "Are you sure?",
              "OverallDetails": {
                "infotext_1": "Overall properties of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "PropertiesDetails":{
                "infotext_1": "Technical properties of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "AvailabilityDetails":{
                "infotext_1": "Availability of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "PriceDetails":{
                "infotext_1": "Prices of the MPN",
                "table_header_MinQuantity": "Min Quantity",
                "table_header_Price": "Price",
                "table_header_Currency": "Currency",
                "placeholder_Search": "Search",
              },
              "AvailabilityDetails":{
                "infotext_1": "Availability of the MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
              },
              "SEDetails":{
                "infotext_1": "SiliconExpert details",
                "infotext_2": "Data from SiliconExpert not matched to MPN",
                "table_header_Name": "Name",
                "table_header_Value": "Value",
                "placeholder_Search": "Search",
                "modal_SERisk": {
                  "modal_Title": "SiliconExpert Details",
                  "infotext_1": "MPN",
                  "infotext_2": "Manufacturer name"
                },
                "button_label_Details": "Details",
                "button_label_GetDataFromSE": "Get data from SE",
                "button_label_SE_sync": "SE Sync",
                "button_label_SE_RiskDetails": "Risk details",
                "button_label_SyncPartSE": "Sync SE data",
                "button_label_SE_unassign": "Unassign SE data",
                "modal_title_unassignSEData": "Unassign SE data",
                "alert_unassignSEData": "Are you sure?",
                "alert_success_unassignSEData": "SE data has been unassigned",
                "alert_error_unassignSEData": "SE data has not been unassigned. Error",
                "alert_success_SyncSEData": "SE data has been synchronized",
                "alert_error_SyncSEData": "SE data has not been synchronized. Error",
                "TreeSE": {
                  "placeholder_Search": "Search",
                },
                "modal_SESuggestions": {
                  "modal_Title": "SiliconExpert Parts",
                  "OverallDetails": {
                    "infotext_1": "Overall properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "PropertiesDetails":{
                    "infotext_1": "Technical properties of the MPN",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                  "SEPropertiesChoose": {
                    "infotext_1": "SiliconExpert details data",
                    "infotext_2": "Select one SE part and link it to the MPN part",
                    "table_header_Name": "Name",
                    "table_header_Value": "Value",
                    "placeholder_Search": "Search",
                  },
                },
              "alert_success_AssignPartSEToMPN": "PartSE has been assigned to MPN.",
              "alert_error_AssignPartSEToMPN": "PartSE has not been assigned to MPN. Error",
              },
              "label_Manual": "Additional parameters",
              "label_EndOfLife": "End of Life date",
              "label_EndOfSale": "End of Sale date",
              "label_OverallRisk": "OverallRisk",
              "label_LifeCycleRiskGrade": "LifeCycleRiskGrade",
              "label_RohsRisk": "RohsRisk",
              "label_RoHSVersion": "RoHSVersion",
              "label_ChinaRoHSStatus": "ChinaRoHSStatus",
              "label_LifecycleRisk": "LifecycleRisk",
              "label_PartStatus": "PartStatus",
              "label_EstimatedYearsToEOL": "EstimatedYearsToEOL",
              "label_MultiSourcingRisk": "MultiSourcingRisk",
              "label_Comment": "Comment",
              "button_Update": "Update",
              "alert_success_updateAlternative": "The parameters have been saved correctly",
              "alert_error_updateAlternative": "Parameters were not saved correctly"
            },
            "IPCViewer": {
              "infotext_1": "Layers",
              "infotext_2": "Select the revision in the table on the left panel",
              "label_Revisions": "Revisions"
            }
          },
          "button_Hide": "Hide"
        },

      },
      "ProjectImportIPC":{
        "Left": {

        },
        "Middle": {
          "Content": {
            "tab_ImportIPC": "Importing IPC file",
            "label_file": "Upload a XML format file containing IPC image of board",
            "placeholder_file": "Choose a file or drop it here...",
            "button_Upload": "Upload",
            "alert_success_importIPC": "The IPC file was uploaded successfully",
            "alert_error_importIPC": "The IPC file not uploaded correctly",
            "IPCViewer": {
              "infotext_1": "Layers",
              "infotext_2": "Select the revision in the table on the left panel",
              "label_Revisions": "Revisions"
            }
          },
          "button_Back": "Back",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "alert_success_import": "Import of IPC file successfully completed.",
          "alert_error_import": "Import of IPC file failed.",
          "title_import": "Importing IPC file",
        },
        "Right":{

        },
      },
    },
    "RequestManager": {
      "RequestTable": {
        "Left": {
          "Content": {

          },
          "button_Hide": "Hide",

        },
        "Middle": {
          "Content": {
            "tab_Requests": "Requests",
            "infotext_1": "Filters",
            "RequestsTable": {
              "infotext_2": "List of requests",
              "header_Image": "Image",
              "header_RequestNumber": "RequestNumber",
              "header_Manufacturer": "Manufacturer",
              "header_ManufacturerPartNumber": "ManufacturerPartNumber",
              "header_PartNumber": "PartNumber",
              "header_LibraryNumber": "LibraryNumber",
              "header_PartRequestNumber": "PartRequestNumber",
              "header_Deadline": "Deadline",
              "header_Type": "Type",
              "header_Priority": "Priority",
              "header_Stage": "Stage",
              "header_Owner": "Owner",
              "header_CreateDate": "Creation date",
              "contextmenu_text_Details": "Details",

            },
            "Filters": {
              "placeholder": "Add filters"
            },
            "FiltersButtons": {
              "infotext_1": "Applied"
            },


          },
          "button_New": "New",
          "button_Details": "Details",
          "button_Delete": "Delete",
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "modal_CreateRequest": {
            "modal_Title": "New request",
            "infotext_1": "Fill out the new part request form",
            "label_Manufacturer": "Manufacturer",
            "validinfo_Manufacturer": "The Manufacturer name must not be empty.",
            "label_ManufacturerPartNumber": "ManufacturerPartNumber",
            "validinfo_ManufacturerPartNumber": "The ManufacturerPartNumber name must not be empty.",
            "label_Type": "Type",
            "label_LibraryType": "LibraryType",
            "validinfo_LibraryType": "Select library type",
            "label_Remarks": "Remarks",
            "validinfo_Remarks": "The Remarks name must not be empty.",
            "label_Priority": "Priority",
            "label_Deadline": "Deadline",
            "validinfo_Deadline": "Deadline may not be in the past.",
            "label_Files": "Files",
            "validinfo_Files": "Incorrect file format",
            "placeholder_Files": "No files choosen",
          },
          "alert_success_CreateRequest": "The request has been created correctly",
          "alert_error_CreateRequest": "The request has not been created correctly. Error",
          "modal_PushRequest": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Dependency": "Dependency",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "alert_delete": "Are you sure?",


          "alert_success_delete_library": "The request was deleted correctly",
          "alert_error_delete_library": "The request has not been deleted correctly. Error",
          "modal_title_delete": "Deleting",

        },
        "Right": {
          "Content": {
            "tab_QuickView": "Quick view",
            "infotext_1": "Select one element in the middle panel to display details data.",
            "tab_Tasks": "Tasks",
            "tab_WhereUse": "Where used",
            "infotext_3": "Select request in the left panel to display data.",

            "RequestTasks": {
              "infotext_1": "This request has no tasks",
              "infotext_2": "List of tasks",
              "label_StageName": "Stage",

              "button_Submit": "Submit request",
              "label_Submit": "Approve request for processing",
              "alert_success_submit": "Your request has been successfully submitted.",
              "alert_error_submit": "The request was not submitted successfully. Error",

              "button_Cancel": "Cancel request",
              "label_Cancel": "Remove request",
              "alert_success_cancel": "The request has been successfully canceled.",
              "alert_error_cancel": "The request was not cancelled successfully. Error",
              "alert_Cancel": "Are you sure?",
              "modal_title_delete": "Canceling",

              "button_AssignLibrarian": "Assign to",
              "label_AssignLibrarian": "Assign request to another user",
              "alert_success_assignLibrarian": "Success",
              "alert_error_assignLibrarian": ". Error",

              "button_StartDevelopment": "Start development",
              "label_StartDevelopment": "Start developing",
              "alert_success_startDevelopment": "Success",
              "alert_error_startDevelopment": ". Error",

              "button_ReturnToRequester": "Return to Requester",
              "label_ReturnToRequester": "Resend request to requester",
              "alert_success_returnToRequester": "The request assignment was successful.",
              "alert_error_returnToRequester": "The request assignment was not successful. Error",

              "button_DoneDevelop": "Done develop",
              "label_DoneDevelop": "Approve completion of the request (approve 1st level)",
              "alert_success_doneDevelop": "Development successfully completed",
              "alert_error_doneDevelop": "Development not completed successfully. Error",

              "alert_error_approve1": "Field",
              "alert_error_approve2": "must be completed before release. Check completeness in Details.",
              "alert_success_approve": "The approval was successful",
              "alert_error_approve": "The approval was not successful",
              "alert_error_reject": "The reject was not successful",
              "alert_error_complete_task": "You cannot complete this step. Check if the part or library associated with the request is complete and if you have permissions for it.",
              "alert_error_reject_task": "You cannot rework. Check that you have permissions for the part or library associated with the request.",
              "modal_EventTaskDependencyInfo":{
                "modal_Title": "Dependency info",
                "infotext_1": "List of libraries that are used in",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "modal_EventTaskFormValidation":{
                "modal_Title": "Validation process",
                "infotext_1": "Approval is not possible.",
                "infotext_2": "List of libraries that have been used and may not be complete",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },

              "button_Rework": "Rework",
              "label_Rework": "Send request to fix",
              "alert_success_reworkRequest": "The request was successfully transferred to the requester.",
              "alert_error_reworkRequest": "The request was not successfully transferred to the requester.. Error",

              "button_Evaluation": "Evaluation",
              "label_Evaluation": "Send to evaluation",
              "alert_success_evaluationRequest": "The evaluation phase has begun successfully",
              "alert_error_evaluationRequest": "The evaluation phase did not start successfully. Error",

              "button_Production": "Production",
              "label_Production": "Send to production (approve 2nd level)",
              "alert_success_productionRequest": "The production phase has begun successfully",
              "alert_error_productionRequest": "The production phase did not start successfully. Error",

              "button_Abort": "Withdraw",
              "label_Abort": "Withdraw the request without success",
              "alert_success_withdrawRequest": "Request successfully withdrawn",
              "alert_error_withdrawRequest": "The request withdrawal was not successful. Error",

              "button_Own": "Own request",
              "label_Own": "Take ownership of request",
              "alert_success_ownRequest": "The task has been successfully assigned.",
              "alert_error_ownRequest": "The task assignment was not completed successfully. Error",

              "button_Disown": "Disown request",
              "label_Disown": "Abandon ownership of request",
              "alert_success_disownRequest": "Request abandonment successfully completed",
              "alert_error_disownRequest": "The request abandonment was not successful. Error",

              "button_CreatePart": "Create part",
              "label_CreatePart": "Create a part in the context of a request",

              "modal_AssignUser":{
                "modal_Title": "Assign user",
                "label_Users": "Select the user who will work with the request"
              },
              "modal_CommentRequest":{
                "modal_Title": "Comment in the process",
                "label_Comment": "Comment for task",
                "placeholder_Comment": "Enter something..."
              },
              "DetailsHistory": {
                "infotext_1": "Select the request in the table",
                "infotext_2": "Comments in request",
                "infotext_3": "No comments",
                "label_Reason": "Rejected",
                "label_Comment": "Approved with comment",
                "label_WithoutComment": "Approved without comment",
                "label_Transfer": "Transfer ownership",
                "label_Assign": "Assigned MPN",
                "label_Unassign": "Unassigned MPN",
                "label_Move": "Category changed"
              },
            },




          },
          "button_Hide": "Hide"
        }
      },


      "RequestDetails": {
        "Left": {
          "Content": {
            "tab_Info": "Info",
            "RequestInfo": {
              "infotext_1": "Request information",
              "label_requestNumber": "RequestNumber",
              "label_partNumber": "PartNumber",
              "label_libraryNumber": "LibraryNumber",
              "label_createDate": "Create date",
              "label_owner": "Owner",
              "label_requester": "Requester",
              "label_stage": "Stage",
              "label_status": "Status",
              "label_type": "Type",
            }

          },
          "button_Hide": "Hide",
        },
        "Middle": {
          "Content": {
            "tab_Details": "Request",


            "RequestDetails":{
              "infotext_1": "List of request properties",

              "table_header_Name": "Name",
              "table_header_Value": "Values",
              "placeholder_Search": "Search",

              "label_Manufacturer": "Manufacturer",
              "validinfo_Manufacturer": "The Manufacturer name must not be empty.",
              "label_ManufacturerPartNumber": "ManufacturerPartNumber",
              "validinfo_ManufacturerPartNumber": "The ManufacturerPartNumber name must not be empty.",
              "label_Remarks": "Remarks",
              "validinfo_Remarks": "The Remarks name must not be empty.",
              "label_Priority": "Priority",
              "label_Deadline": "Deadline",
              "validinfo_Deadline": "Deadline may not be in the past.",
              "label_Files": "Files",
              "validinfo_Files": "Incorrect file format",

              "infotext_2": "Load library files",
              "filesPlaceholder": "Choose a files or drop them here...",
              "infotext_Request": "This property is required to save a library.",
              "infotext_Release": "This property is required to approve a library.",
              "infotext_Revision": "Changing this property will change the revision after saving.",
              "table_subheader": "Revision",
              "table_button_Download": "Download",
              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "button_DeleteFile": "Delete",
              "alert_Title_deleteFile": "Deleting file",
              "alert_deleteFile": "Are you sure?",
              "alert_success_DeleteFile": "The file was deleted correctly",
              "alert_error_DeleteFile": "The file was not deleted correctly. Error",





            },

            "tab_History": "History",


            "DetailsHistory": {
              "infotext_1": "Select the request in the table",
              "infotext_2": "Comments in request",
              "infotext_3": "No comments",
              "label_Reason": "Rejected",
              "label_Comment": "Approved with comment",
              "label_WithoutComment": "Approved without comment",
              "label_Transfer": "Transfer ownership",
              "label_Assign": "Assigned MPN",
              "label_Unassign": "Unassigned MPN",
              "label_Move": "Category changed"
            },

          },

          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Up": "Up",
          "button_Edit": "Edit",
          "button_Unedit": "Disable editing",
          "button_Save": "Save",

          "modal_PushRequest": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Dependency": "Dependency",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },

          "button_CreatePart": "Create part",
          "button_CreateLibrary": "Create library",
          "button_GotoPart": "Go to part",
          "button_GotoLibrary": "Go to library",


          "alert_success_edit_library": "The properties of the request have been saved.",
          "alert_error_edit_library": "Request properties have not been saved. Error",
          "alert_error_edit_required": "Fields marked as * must not be empty.",

          "alert_withdraw": "Are you sure you want to withdraw selected items from use?",
          "alert_success_withdraw": "The library has been withdrawn",
          "alert_error_withdraw": "The library has not been withdrawn. Error",
          "alert_success_delete_library": "The library was deleted correctly",
          "alert_error_delete_library": "The library has not been deleted correctly. Error",
          "modal_title_delete": "Deleting",
          "alert_success_removeRevision_library": "The revision of library was removed correctly",
          "alert_error_removeRevision_library": "The revision of library was not removed correctly. Error",
          "modal_title_removeRevision": "Removing revision",
          "alert_removeRevision": "Only the latest revision will be removed. Are you sure?",
          "alert_delete": "Are you sure?",

          "alert_success_MoveLibrary": "The library has been moved to another category correctly",
          "alert_error_MoveLibrary": "The library has not been moved to another category correctly",
          "alert_error_MoveLibraryCategory": "Select a target category",
          "modal_title_BulkFeedback": "Feedback reports",
          "modal_button_Close": "Close",


          "modal_buttonWaitAlert": "Problems occurred while pushing files",
          "alert_openLibrary_1": "Local library files have been detected",
          "alert_openLibrary_2": "Do you want to overwrite the local files with the remote content, or keep working with the local content?",
          "alert_title_openLibrary": "Opening the library",
          "alert_error_PushLibrary": "Library push failed. Error",
          "alert_error_OpenLibrary": "Opening libraries has failed. Error",
          "alert_error_CheckLibrary": "There was a problem accessing local libraries",
          "alert_success_OpenLibrary": "The library was opened to",


          "alert_success_TransferOwnership": "Ownership of the library has been transferred to another user.",
          "alert_error_TransferOwnership": "Ownership of the library has not been transferred to another user. Error Error",
        },
        "Right": {
          "Content": {
            "tab_Tasks": "Tasks",
            "tab_Search": "External Search",
            "tab_WhereUsed": "Where used",

            "RequestTasks": {
              "infotext_1": "This request has no tasks",
              "infotext_2": "List of tasks",
              "label_StageName": "Stage",

              "button_Submit": "Submit request",
              "label_Submit": "Approve request for processing",
              "alert_success_submit": "Your request has been successfully submitted.",
              "alert_error_submit": "The request was not submitted successfully. Error",

              "button_Cancel": "Cancel request",
              "label_Cancel": "Remove request",
              "alert_success_cancel": "The request has been successfully canceled.",
              "alert_error_cancel": "The request was not cancelled successfully. Error",
              "alert_Cancel": "Are you sure?",
              "modal_title_delete": "Canceling",

              "button_AssignLibrarian": "Assign to",
              "label_AssignLibrarian": "Assign request to another user",
              "alert_success_assignLibrarian": "Success",
              "alert_error_assignLibrarian": ". Error",

              "button_StartDevelopment": "Start development",
              "label_StartDevelopment": "Start developing",
              "alert_success_startDevelopment": "Success",
              "alert_error_startDevelopment": ". Error",

              "button_ReturnToRequester": "Return to Requester",
              "label_ReturnToRequester": "Resend request to requester",
              "alert_success_returnToRequester": "The request assignment was successful.",
              "alert_error_returnToRequester": "The request assignment was not successful. Error",

              "button_DoneDevelop": "Done develop",
              "label_DoneDevelop": "Approve completion of the request (approve 1st level)",
              "alert_success_doneDevelop": "Development successfully completed",
              "alert_error_doneDevelop": "Development not completed successfully. Error",

              "alert_error_approve1": "Field",
              "alert_error_approve2": "must be completed before release. Check completeness in Details.",
              "alert_success_approve": "The approval was successful",
              "alert_error_approve": "The approval was not successful",
              "alert_error_reject": "The reject was not successful",
              "alert_error_complete_task": "You cannot complete this step. Check if the part or library associated with the request is complete and if you have permissions for it.",
              "alert_error_reject_task": "You cannot rework. Check that you have permissions for the part or library associated with the request.",
              "modal_EventTaskDependencyInfo":{
                "modal_Title": "Dependency info",
                "infotext_1": "List of libraries that are used in",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },
              "modal_EventTaskFormValidation":{
                "modal_Title": "Validation process",
                "infotext_1": "Approval is not possible.",
                "infotext_2": "List of libraries that have been used and may not be complete",
                "table_header_Name": "Name",
                "table_header_Revision": "Revision",
                "table_header_Type": "Type",
                "table_header_Status": "Status",
                "table_header_Files": "Files",
                "table_header_Info": "Info",
                "table_tag_FilesComplete": "complete",
                "table_tag_FilesIncomplete": "incomplete",
                "placeholder_Search": "Search"

              },

              "button_Rework": "Rework",
              "label_Rework": "Send request to fix",
              "alert_success_reworkRequest": "The request was successfully transferred to the requester.",
              "alert_error_reworkRequest": "The request was not successfully transferred to the requester.. Error",

              "button_Evaluation": "Evaluation",
              "label_Evaluation": "Send to evaluation",
              "alert_success_evaluationRequest": "The evaluation phase has begun successfully",
              "alert_error_evaluationRequest": "The evaluation phase did not start successfully. Error",

              "button_Production": "Production",
              "label_Production": "Send to production (approve 2nd level)",
              "alert_success_productionRequest": "The production phase has begun successfully",
              "alert_error_productionRequest": "The production phase did not start successfully. Error",

              "button_Abort": "Withdraw",
              "label_Abort": "Withdraw the request without success",
              "alert_success_withdrawRequest": "Request successfully withdrawn",
              "alert_error_withdrawRequest": "The request withdrawal was not successful. Error",

              "button_Own": "Own request",
              "label_Own": "Take ownership of request",
              "alert_success_ownRequest": "The task has been successfully assigned.",
              "alert_error_ownRequest": "The task assignment was not completed successfully. Error",

              "button_Disown": "Disown request",
              "label_Disown": "Abandon ownership of request",
              "alert_success_disownRequest": "Request abandonment successfully completed",
              "alert_error_disownRequest": "The request abandonment was not successful. Error",

              "button_CreatePart": "Create part",
              "label_CreatePart": "Create a part in the context of a request",

              "modal_AssignUser":{
                "modal_Title": "Assign user",
                "label_Users": "Select the user who will work with the request"
              },
              "modal_CommentRequest":{
                "modal_Title": "Comment in the process",
                "label_Comment": "Comment for task",
                "placeholder_Comment": "Enter something..."
              },
              "DetailsHistory": {
                "infotext_1": "Select the request in the table",
                "infotext_2": "Comments in request",
                "infotext_3": "No comments",
                "label_Reason": "Rejected",
                "label_Comment": "Approved with comment",
                "label_WithoutComment": "Approved without comment",
                "label_Transfer": "Transfer ownership",
                "label_Assign": "Assigned MPN",
                "label_Unassign": "Unassigned MPN",
                "label_Move": "Category changed"
              },
            },
            "WhereUsed":{

            },
            "Search":{
              "button_Search": "Search",
              "button_Reset": "Reset",
              "input_placeholder_Manufacturer": "Manufacturer",
              "input_placeholder_ManufacturerPartNumber": "Manufacturer Part Number",
              "loader_Search": "Searching",
              "infotext_1": "No defined search engines",
              "infotext_2": "Search from third-party suppliers",
              "infotext_3": "You do not have permission to create new parts",
              "infotext_4": "Applies only to part type requests",
              "searchError": "The search failed. Please try again.",
              "alert_error_Searching": "Searching error"
            },

          },
          "button_Hide": "Hide"
        }
      },

      "RequestNew": {
        "Left": {
          "Content": {

          },
          "button_Hide": "Hide",


        },
        "Middle": {
          "Content": {
            "tab_NewPart": "New request",
            "NewPartForm":{
              "infotext_1": "Fill out the form to create a new library element for category",
              "infotext_2": "Load library files",
              "infotext_3": "This property is required to create a new library.",
              "infotext_4": "Unable to create an new library element in the 'All libraries' category",
              "infotext_5": "Unable to create an new library element in the 2nd level category",
              "filesPlaceholder": "Choose a library files or drop them here...",
              "placeholder_Search": "Search",
              "table_header_Name": "Property name",
              "table_header_Value": "Property value",

              "button_Footprint": "Select from list",
              "button_Symbol": "Select from list",
              "modal_Footprints":{
                "modal_Title": "Footprints",
                "infotext_1": "You can search and select footprint from the table below",
                "table_Footprints":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new footprint",
                "button_Create": "Create",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The footprint name must not be empty.",
                "alert_success_create_footprint": "A new footprint has been created",
                "alert_error_create_footprint": "A new footprint has not been created",
              },
              "modal_Symbols":{
                "modal_Title": "Symbols",
                "modal_TitleHDL": "HDL symbols",
                "modal_TitleSymbols": "Symbols",
                "infotext_1": "You can search and add symbols from the table below",
                "table_Symbols":{
                  "placeholder_Search": "Search",
                  "table_header_Name": "Name",
                  "table_header_Status": "Status",
                  "table_header_Image": "Image",
                  "table_header_Action": "Action",
                  "tag_Prototype": "Prototype",
                  "button_Add": "Add",
                  "button_Select": "Select",
                  "button_Delete": "Delete"
                },
                "infotext_2": "Create new symbol",
                "button_Create": "Create",
                "button_Remove": "Remove",
                "placeholder_Create": "Enter name",
                "placeholder_file": "Choose a file or drop it here...",
                "validinfo_1": "The symbol name must not be empty.",
                "alert_success_create_symbol": "A new symbol has been created",
                "alert_error_create_symbol": "A new symbol has not been created",
                "LibraryUL": {
                  "infotext_1": "No matching libraries found",
                  "infotext_2": "Symbol not available",
                  "infotext_3": "Symbol not available",
                  "infotext_4": "Footprint not available",
                  "infotext_5": "Name",
                  "infotext_6": "Powered by",
                  "infotext_7": "Type view",
                  "infotext_8": "Type view",
                  "infotext_9": "Based on",
                  "infotext_10": "Select Your CAD format",
                  "button_Back": "Back",
                  "button_DeriveULLIbrary": "Derive library",
                  "dropdown_FirstValue": "Choose...",
                  "button_CreateNew": "Create new",
                  "DeriveULLibraryForm":{
                    "infotext_1": "Fill out the form to create a new library element for category",
                    "infotext_2": "This property is required to create a new part.",
                    "infotext_3": "Unable to create an new library element in the 'All libraries' category",
                    "infotext_4": "The renamed library files will be copied to the new library.",
                    "infotext_5": "Unable to create an new library element in the 2nd level category",
                    "infotext_6": "Library files downloaded from the Ultra Librarian service will be attached to the new library.",
                    "placeholder_Search": "Search",
                    "table_header_Name": "Property name",
                    "table_header_Value": "Property value",
                    "button_Footprint": "Select from list",
                    "button_Symbol": "Select from list",
                    "label_LibraryNumber": "A blank field will automatically generate a Library number according to the template",

                  },
                  "CategoryUL": {

                  }

                }
              },

            },


          },
          "button_Left": "Show panel left",
          "button_Right": "Show panel right",
          "button_Back": "Back",
          "button_Save": "Create new",
          "alert_success_new_part": "The new library has been saved.",
          "alert_error_new_part_required": "Fields marked as Request must not be empty.",
          "alert_error_new_part": "The new library has not been saved. Error",
          "modal_PushRequest": {
            "modal_Title": "Pushed files",
            "infotext_1": "List of pushed files",
            "infotext_2": "No files were pushed",
            "infotext_3": "As a result of the file push operation, a new revision was created",
            "table_header_Name": "Filename",
            "table_header_Status": "Status",
            "table_header_Dependency": "Dependency",
            "table_header_Description": "Description",
            "placeholder_Search": "Search",
          },
          "modal_buttonWaitAlert": "Problems occurred while pushing files",
        },
        "Right": {
          "Content": {


          },
          "button_Hide": "Hide"
        }
      },


    },
  },
  "de":{

  },
  "pl":{

  }
}



// WEBPACK FOOTER //
// ./src/Tools/lang.js